(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("deepmerge"), require("is-plain-object"), require("redux"), require("redux-saga"), require("web3"));else if (typeof define === 'function' && define.amd) define(["deepmerge", "is-plain-object", "redux", "redux-saga", "web3"], factory);else if (typeof exports === 'object') exports["@drizzle/store"] = factory(require("deepmerge"), require("is-plain-object"), require("redux"), require("redux-saga"), require("web3"));else root["@drizzle/store"] = factory(root["deepmerge"], root["is-plain-object"], root["redux"], root["redux-saga"], root["web3"]);
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_deepmerge__, __WEBPACK_EXTERNAL_MODULE_is_plain_object__, __WEBPACK_EXTERNAL_MODULE_redux__, __WEBPACK_EXTERNAL_MODULE_redux_saga__, __WEBPACK_EXTERNAL_MODULE_web3__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __webpack_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __webpack_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __webpack_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        }
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = "./src/index.js");
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      "../../node_modules/@babel/runtime/helpers/arrayWithoutHoles.js":
      /*!***********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/@babel/runtime/helpers/arrayWithoutHoles.js ***!
        \***********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersArrayWithoutHolesJs(module, exports) {
        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          }
        }

        module.exports = _arrayWithoutHoles;
        /***/
      },

      /***/
      "../../node_modules/@babel/runtime/helpers/classCallCheck.js":
      /*!********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/@babel/runtime/helpers/classCallCheck.js ***!
        \********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersClassCallCheckJs(module, exports) {
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        module.exports = _classCallCheck;
        /***/
      },

      /***/
      "../../node_modules/@babel/runtime/helpers/createClass.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/@babel/runtime/helpers/createClass.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersCreateClassJs(module, exports) {
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }

        module.exports = _createClass;
        /***/
      },

      /***/
      "../../node_modules/@babel/runtime/helpers/defineProperty.js":
      /*!********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/@babel/runtime/helpers/defineProperty.js ***!
        \********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersDefinePropertyJs(module, exports) {
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        module.exports = _defineProperty;
        /***/
      },

      /***/
      "../../node_modules/@babel/runtime/helpers/iterableToArray.js":
      /*!*********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/@babel/runtime/helpers/iterableToArray.js ***!
        \*********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersIterableToArrayJs(module, exports) {
        function _iterableToArray(iter) {
          if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
        }

        module.exports = _iterableToArray;
        /***/
      },

      /***/
      "../../node_modules/@babel/runtime/helpers/nonIterableSpread.js":
      /*!***********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/@babel/runtime/helpers/nonIterableSpread.js ***!
        \***********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersNonIterableSpreadJs(module, exports) {
        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }

        module.exports = _nonIterableSpread;
        /***/
      },

      /***/
      "../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js":
      /*!*****************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/@babel/runtime/helpers/objectWithoutProperties.js ***!
        \*****************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersObjectWithoutPropertiesJs(module, exports, __webpack_require__) {
        var objectWithoutPropertiesLoose = __webpack_require__(
        /*! ./objectWithoutPropertiesLoose */
        "../../node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js");

        function _objectWithoutProperties(source, excluded) {
          if (source == null) return {};
          var target = objectWithoutPropertiesLoose(source, excluded);
          var key, i;

          if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

            for (i = 0; i < sourceSymbolKeys.length; i++) {
              key = sourceSymbolKeys[i];
              if (excluded.indexOf(key) >= 0) continue;
              if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
              target[key] = source[key];
            }
          }

          return target;
        }

        module.exports = _objectWithoutProperties;
        /***/
      },

      /***/
      "../../node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js":
      /*!**********************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js ***!
        \**********************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersObjectWithoutPropertiesLooseJs(module, exports) {
        function _objectWithoutPropertiesLoose(source, excluded) {
          if (source == null) return {};
          var target = {};
          var sourceKeys = Object.keys(source);
          var key, i;

          for (i = 0; i < sourceKeys.length; i++) {
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
          }

          return target;
        }

        module.exports = _objectWithoutPropertiesLoose;
        /***/
      },

      /***/
      "../../node_modules/@babel/runtime/helpers/toConsumableArray.js":
      /*!***********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/@babel/runtime/helpers/toConsumableArray.js ***!
        \***********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersToConsumableArrayJs(module, exports, __webpack_require__) {
        var arrayWithoutHoles = __webpack_require__(
        /*! ./arrayWithoutHoles */
        "../../node_modules/@babel/runtime/helpers/arrayWithoutHoles.js");

        var iterableToArray = __webpack_require__(
        /*! ./iterableToArray */
        "../../node_modules/@babel/runtime/helpers/iterableToArray.js");

        var nonIterableSpread = __webpack_require__(
        /*! ./nonIterableSpread */
        "../../node_modules/@babel/runtime/helpers/nonIterableSpread.js");

        function _toConsumableArray(arr) {
          return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
        }

        module.exports = _toConsumableArray;
        /***/
      },

      /***/
      "../../node_modules/@babel/runtime/helpers/typeof.js":
      /*!************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/@babel/runtime/helpers/typeof.js ***!
        \************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersTypeofJs(module, exports) {
        function _typeof2(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof2 = function _typeof2(obj) {
              return typeof obj;
            };
          } else {
            _typeof2 = function _typeof2(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }

          return _typeof2(obj);
        }

        function _typeof(obj) {
          if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
            module.exports = _typeof = function _typeof(obj) {
              return _typeof2(obj);
            };
          } else {
            module.exports = _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
            };
          }

          return _typeof(obj);
        }

        module.exports = _typeof;
        /***/
      },

      /***/
      "../../node_modules/@babel/runtime/regenerator/index.js":
      /*!***************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/@babel/runtime/regenerator/index.js ***!
        \***************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeRegeneratorIndexJs(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(
        /*! regenerator-runtime */
        "../../node_modules/regenerator-runtime/runtime.js");
        /***/
      },

      /***/
      "../../node_modules/async-eventemitter/index.js":
      /*!*******************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async-eventemitter/index.js ***!
        \*******************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncEventemitterIndexJs(module, exports, __webpack_require__) {
        "use strict";

        module.exports = __webpack_require__(
        /*! ./lib/AsyncEventEmitter */
        "../../node_modules/async-eventemitter/lib/AsyncEventEmitter.js");
        /***/
      },

      /***/
      "../../node_modules/async-eventemitter/lib/AsyncEventEmitter.js":
      /*!***********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async-eventemitter/lib/AsyncEventEmitter.js ***!
        \***********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncEventemitterLibAsyncEventEmitterJs(module, exports, __webpack_require__) {
        "use strict";

        var EventEmitter = __webpack_require__(
        /*! events */
        "../../node_modules/events/events.js").EventEmitter,
            util = __webpack_require__(
        /*! util */
        "../../node_modules/util/util.js"),
            eachSeries = __webpack_require__(
        /*! async/eachSeries */
        "../../node_modules/async/eachSeries.js"),
            AsyncEventEmitter;

        module.exports = exports = AsyncEventEmitter = function AsyncEventEmitter() {
          EventEmitter.call(this);
        };

        util.inherits(AsyncEventEmitter, EventEmitter);
        /* Public methods
        ============================================================================= */

        AsyncEventEmitter.prototype.emit = function (event, data, callback) {
          var self = this,
              listeners = self._events[event] || []; // Optional data argument

          if (!callback && typeof data === 'function') {
            callback = data;
            data = undefined;
          } // Special treatment of internal newListener and removeListener events


          if (event === 'newListener' || event === 'removeListener') {
            data = {
              event: data,
              fn: callback
            };
            callback = undefined;
          } // A single listener is just a function not an array...


          listeners = Array.isArray(listeners) ? listeners : [listeners];
          eachSeries(listeners.slice(), function (fn, next) {
            var err; // Support synchronous functions

            if (fn.length < 2) {
              try {
                fn.call(self, data);
              } catch (e) {
                err = e;
              }

              return next(err);
            } // Async


            fn.call(self, data, next);
          }, callback);
          return self;
        };

        AsyncEventEmitter.prototype.once = function (type, listener) {
          var self = this,
              _g2;

          if (typeof listener !== 'function') {
            throw new TypeError('listener must be a function');
          } // Hack to support set arity


          if (listener.length >= 2) {
            _g2 = function g(e, next) {
              self.removeListener(type, _g2);
              listener(e, next);
            };
          } else {
            _g2 = function _g(e) {
              self.removeListener(type, _g2);
              listener(e);
            };
          }

          _g2.listener = listener;
          self.on(type, _g2);
          return self;
        };

        AsyncEventEmitter.prototype.first = function (event, listener) {
          var listeners = this._events[event] || []; // Contract

          if (typeof listener !== 'function') {
            throw new TypeError('listener must be a function');
          } // Listeners are not always an array


          if (!Array.isArray(listeners)) {
            this._events[event] = listeners = [listeners];
          }

          listeners.unshift(listener);
          return this;
        };

        AsyncEventEmitter.prototype.at = function (event, index, listener) {
          var listeners = this._events[event] || []; // Contract

          if (typeof listener !== 'function') {
            throw new TypeError('listener must be a function');
          }

          if (typeof index !== 'number' || index < 0) {
            throw new TypeError('index must be a non-negative integer');
          } // Listeners are not always an array


          if (!Array.isArray(listeners)) {
            this._events[event] = listeners = [listeners];
          }

          listeners.splice(index, 0, listener);
          return this;
        };

        AsyncEventEmitter.prototype.before = function (event, target, listener) {
          return this._beforeOrAfter(event, target, listener);
        };

        AsyncEventEmitter.prototype.after = function (event, target, listener) {
          return this._beforeOrAfter(event, target, listener, 'after');
        };
        /* Private methods
        ============================================================================= */


        AsyncEventEmitter.prototype._beforeOrAfter = function (event, target, listener, beforeOrAfter) {
          var listeners = this._events[event] || [],
              i,
              index,
              add = beforeOrAfter === 'after' ? 1 : 0; // Contract

          if (typeof listener !== 'function') {
            throw new TypeError('listener must be a function');
          }

          if (typeof target !== 'function') {
            throw new TypeError('target must be a function');
          } // Listeners are not always an array


          if (!Array.isArray(listeners)) {
            this._events[event] = listeners = [listeners];
          }

          index = listeners.length;

          for (i = listeners.length; i--;) {
            if (listeners[i] === target) {
              index = i + add;
              break;
            }
          }

          listeners.splice(index, 0, listener);
          return this;
        };
        /***/

      },

      /***/
      "../../node_modules/async/asyncify.js":
      /*!*********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/asyncify.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncAsyncifyJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = asyncify;

        var _isObject = __webpack_require__(
        /*! lodash/isObject */
        "../../node_modules/lodash/isObject.js");

        var _isObject2 = _interopRequireDefault(_isObject);

        var _initialParams = __webpack_require__(
        /*! ./internal/initialParams */
        "../../node_modules/async/internal/initialParams.js");

        var _initialParams2 = _interopRequireDefault(_initialParams);

        var _setImmediate = __webpack_require__(
        /*! ./internal/setImmediate */
        "../../node_modules/async/internal/setImmediate.js");

        var _setImmediate2 = _interopRequireDefault(_setImmediate);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        /**
         * Take a sync function and make it async, passing its return value to a
         * callback. This is useful for plugging sync functions into a waterfall,
         * series, or other async functions. Any arguments passed to the generated
         * function will be passed to the wrapped function (except for the final
         * callback argument). Errors thrown will be passed to the callback.
         *
         * If the function passed to `asyncify` returns a Promise, that promises's
         * resolved/rejected state will be used to call the callback, rather than simply
         * the synchronous return value.
         *
         * This also means you can asyncify ES2017 `async` functions.
         *
         * @name asyncify
         * @static
         * @memberOf module:Utils
         * @method
         * @alias wrapSync
         * @category Util
         * @param {Function} func - The synchronous function, or Promise-returning
         * function to convert to an {@link AsyncFunction}.
         * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
         * invoked with `(args..., callback)`.
         * @example
         *
         * // passing a regular synchronous function
         * async.waterfall([
         *     async.apply(fs.readFile, filename, "utf8"),
         *     async.asyncify(JSON.parse),
         *     function (data, next) {
         *         // data is the result of parsing the text.
         *         // If there was a parsing error, it would have been caught.
         *     }
         * ], callback);
         *
         * // passing a function returning a promise
         * async.waterfall([
         *     async.apply(fs.readFile, filename, "utf8"),
         *     async.asyncify(function (contents) {
         *         return db.model.create(contents);
         *     }),
         *     function (model, next) {
         *         // `model` is the instantiated model object.
         *         // If there was an error, this function would be skipped.
         *     }
         * ], callback);
         *
         * // es2017 example, though `asyncify` is not needed if your JS environment
         * // supports async functions out of the box
         * var q = async.queue(async.asyncify(async function(file) {
         *     var intermediateStep = await processFile(file);
         *     return await somePromise(intermediateStep)
         * }));
         *
         * q.push(files);
         */


        function asyncify(func) {
          return (0, _initialParams2.default)(function (args, callback) {
            var result;

            try {
              result = func.apply(this, args);
            } catch (e) {
              return callback(e);
            } // if result is Promise object


            if ((0, _isObject2.default)(result) && typeof result.then === 'function') {
              result.then(function (value) {
                invokeCallback(callback, null, value);
              }, function (err) {
                invokeCallback(callback, err.message ? err : new Error(err));
              });
            } else {
              callback(null, result);
            }
          });
        }

        function invokeCallback(callback, error, value) {
          try {
            callback(error, value);
          } catch (e) {
            (0, _setImmediate2.default)(rethrow, e);
          }
        }

        function rethrow(error) {
          throw error;
        }

        module.exports = exports['default'];
        /***/
      },

      /***/
      "../../node_modules/async/eachLimit.js":
      /*!**********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/eachLimit.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncEachLimitJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = eachLimit;

        var _eachOfLimit = __webpack_require__(
        /*! ./internal/eachOfLimit */
        "../../node_modules/async/internal/eachOfLimit.js");

        var _eachOfLimit2 = _interopRequireDefault(_eachOfLimit);

        var _withoutIndex = __webpack_require__(
        /*! ./internal/withoutIndex */
        "../../node_modules/async/internal/withoutIndex.js");

        var _withoutIndex2 = _interopRequireDefault(_withoutIndex);

        var _wrapAsync = __webpack_require__(
        /*! ./internal/wrapAsync */
        "../../node_modules/async/internal/wrapAsync.js");

        var _wrapAsync2 = _interopRequireDefault(_wrapAsync);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        /**
         * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
         *
         * @name eachLimit
         * @static
         * @memberOf module:Collections
         * @method
         * @see [async.each]{@link module:Collections.each}
         * @alias forEachLimit
         * @category Collection
         * @param {Array|Iterable|Object} coll - A collection to iterate over.
         * @param {number} limit - The maximum number of async operations at a time.
         * @param {AsyncFunction} iteratee - An async function to apply to each item in
         * `coll`.
         * The array index is not passed to the iteratee.
         * If you need the index, use `eachOfLimit`.
         * Invoked with (item, callback).
         * @param {Function} [callback] - A callback which is called when all
         * `iteratee` functions have finished, or an error occurs. Invoked with (err).
         */


        function eachLimit(coll, limit, iteratee, callback) {
          (0, _eachOfLimit2.default)(limit)(coll, (0, _withoutIndex2.default)((0, _wrapAsync2.default)(iteratee)), callback);
        }

        module.exports = exports['default'];
        /***/
      },

      /***/
      "../../node_modules/async/eachSeries.js":
      /*!***********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/eachSeries.js ***!
        \***********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncEachSeriesJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _eachLimit = __webpack_require__(
        /*! ./eachLimit */
        "../../node_modules/async/eachLimit.js");

        var _eachLimit2 = _interopRequireDefault(_eachLimit);

        var _doLimit = __webpack_require__(
        /*! ./internal/doLimit */
        "../../node_modules/async/internal/doLimit.js");

        var _doLimit2 = _interopRequireDefault(_doLimit);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }
        /**
         * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
         *
         * @name eachSeries
         * @static
         * @memberOf module:Collections
         * @method
         * @see [async.each]{@link module:Collections.each}
         * @alias forEachSeries
         * @category Collection
         * @param {Array|Iterable|Object} coll - A collection to iterate over.
         * @param {AsyncFunction} iteratee - An async function to apply to each
         * item in `coll`.
         * The array index is not passed to the iteratee.
         * If you need the index, use `eachOfSeries`.
         * Invoked with (item, callback).
         * @param {Function} [callback] - A callback which is called when all
         * `iteratee` functions have finished, or an error occurs. Invoked with (err).
         */


        exports.default = (0, _doLimit2.default)(_eachLimit2.default, 1);
        module.exports = exports['default'];
        /***/
      },

      /***/
      "../../node_modules/async/internal/breakLoop.js":
      /*!*******************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/internal/breakLoop.js ***!
        \*******************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncInternalBreakLoopJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        }); // A temporary value used to identify if the loop should be broken.
        // See #1064, #1293

        exports.default = {};
        module.exports = exports["default"];
        /***/
      },

      /***/
      "../../node_modules/async/internal/doLimit.js":
      /*!*****************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/internal/doLimit.js ***!
        \*****************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncInternalDoLimitJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = doLimit;

        function doLimit(fn, limit) {
          return function (iterable, iteratee, callback) {
            return fn(iterable, limit, iteratee, callback);
          };
        }

        module.exports = exports["default"];
        /***/
      },

      /***/
      "../../node_modules/async/internal/eachOfLimit.js":
      /*!*********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/internal/eachOfLimit.js ***!
        \*********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncInternalEachOfLimitJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = _eachOfLimit;

        var _noop = __webpack_require__(
        /*! lodash/noop */
        "../../node_modules/lodash/noop.js");

        var _noop2 = _interopRequireDefault(_noop);

        var _once = __webpack_require__(
        /*! ./once */
        "../../node_modules/async/internal/once.js");

        var _once2 = _interopRequireDefault(_once);

        var _iterator = __webpack_require__(
        /*! ./iterator */
        "../../node_modules/async/internal/iterator.js");

        var _iterator2 = _interopRequireDefault(_iterator);

        var _onlyOnce = __webpack_require__(
        /*! ./onlyOnce */
        "../../node_modules/async/internal/onlyOnce.js");

        var _onlyOnce2 = _interopRequireDefault(_onlyOnce);

        var _breakLoop = __webpack_require__(
        /*! ./breakLoop */
        "../../node_modules/async/internal/breakLoop.js");

        var _breakLoop2 = _interopRequireDefault(_breakLoop);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function _eachOfLimit(limit) {
          return function (obj, iteratee, callback) {
            callback = (0, _once2.default)(callback || _noop2.default);

            if (limit <= 0 || !obj) {
              return callback(null);
            }

            var nextElem = (0, _iterator2.default)(obj);
            var done = false;
            var running = 0;
            var looping = false;

            function iterateeCallback(err, value) {
              running -= 1;

              if (err) {
                done = true;
                callback(err);
              } else if (value === _breakLoop2.default || done && running <= 0) {
                done = true;
                return callback(null);
              } else if (!looping) {
                replenish();
              }
            }

            function replenish() {
              looping = true;

              while (running < limit && !done) {
                var elem = nextElem();

                if (elem === null) {
                  done = true;

                  if (running <= 0) {
                    callback(null);
                  }

                  return;
                }

                running += 1;
                iteratee(elem.value, elem.key, (0, _onlyOnce2.default)(iterateeCallback));
              }

              looping = false;
            }

            replenish();
          };
        }

        module.exports = exports['default'];
        /***/
      },

      /***/
      "../../node_modules/async/internal/getIterator.js":
      /*!*********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/internal/getIterator.js ***!
        \*********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncInternalGetIteratorJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        exports.default = function (coll) {
          return iteratorSymbol && coll[iteratorSymbol] && coll[iteratorSymbol]();
        };

        var iteratorSymbol = typeof Symbol === 'function' && Symbol.iterator;
        module.exports = exports['default'];
        /***/
      },

      /***/
      "../../node_modules/async/internal/initialParams.js":
      /*!***********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/internal/initialParams.js ***!
        \***********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncInternalInitialParamsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        exports.default = function (fn) {
          return function ()
          /*...args, callback*/
          {
            var args = (0, _slice2.default)(arguments);
            var callback = args.pop();
            fn.call(this, args, callback);
          };
        };

        var _slice = __webpack_require__(
        /*! ./slice */
        "../../node_modules/async/internal/slice.js");

        var _slice2 = _interopRequireDefault(_slice);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        module.exports = exports['default'];
        /***/
      },

      /***/
      "../../node_modules/async/internal/iterator.js":
      /*!******************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/internal/iterator.js ***!
        \******************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncInternalIteratorJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = iterator;

        var _isArrayLike = __webpack_require__(
        /*! lodash/isArrayLike */
        "../../node_modules/lodash/isArrayLike.js");

        var _isArrayLike2 = _interopRequireDefault(_isArrayLike);

        var _getIterator = __webpack_require__(
        /*! ./getIterator */
        "../../node_modules/async/internal/getIterator.js");

        var _getIterator2 = _interopRequireDefault(_getIterator);

        var _keys = __webpack_require__(
        /*! lodash/keys */
        "../../node_modules/lodash/keys.js");

        var _keys2 = _interopRequireDefault(_keys);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function createArrayIterator(coll) {
          var i = -1;
          var len = coll.length;
          return function next() {
            return ++i < len ? {
              value: coll[i],
              key: i
            } : null;
          };
        }

        function createES2015Iterator(iterator) {
          var i = -1;
          return function next() {
            var item = iterator.next();
            if (item.done) return null;
            i++;
            return {
              value: item.value,
              key: i
            };
          };
        }

        function createObjectIterator(obj) {
          var okeys = (0, _keys2.default)(obj);
          var i = -1;
          var len = okeys.length;
          return function next() {
            var key = okeys[++i];
            return i < len ? {
              value: obj[key],
              key: key
            } : null;
          };
        }

        function iterator(coll) {
          if ((0, _isArrayLike2.default)(coll)) {
            return createArrayIterator(coll);
          }

          var iterator = (0, _getIterator2.default)(coll);
          return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
        }

        module.exports = exports['default'];
        /***/
      },

      /***/
      "../../node_modules/async/internal/once.js":
      /*!**************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/internal/once.js ***!
        \**************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncInternalOnceJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = once;

        function once(fn) {
          return function () {
            if (fn === null) return;
            var callFn = fn;
            fn = null;
            callFn.apply(this, arguments);
          };
        }

        module.exports = exports["default"];
        /***/
      },

      /***/
      "../../node_modules/async/internal/onlyOnce.js":
      /*!******************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/internal/onlyOnce.js ***!
        \******************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncInternalOnlyOnceJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = onlyOnce;

        function onlyOnce(fn) {
          return function () {
            if (fn === null) throw new Error("Callback was already called.");
            var callFn = fn;
            fn = null;
            callFn.apply(this, arguments);
          };
        }

        module.exports = exports["default"];
        /***/
      },

      /***/
      "../../node_modules/async/internal/setImmediate.js":
      /*!**********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/internal/setImmediate.js ***!
        \**********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncInternalSetImmediateJs(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */

        (function (setImmediate, process) {
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.hasNextTick = exports.hasSetImmediate = undefined;
          exports.fallback = fallback;
          exports.wrap = wrap;

          var _slice = __webpack_require__(
          /*! ./slice */
          "../../node_modules/async/internal/slice.js");

          var _slice2 = _interopRequireDefault(_slice);

          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              default: obj
            };
          }

          var hasSetImmediate = exports.hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
          var hasNextTick = exports.hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';

          function fallback(fn) {
            setTimeout(fn, 0);
          }

          function wrap(defer) {
            return function (fn
            /*, ...args*/
            ) {
              var args = (0, _slice2.default)(arguments, 1);
              defer(function () {
                fn.apply(null, args);
              });
            };
          }

          var _defer;

          if (hasSetImmediate) {
            _defer = setImmediate;
          } else if (hasNextTick) {
            _defer = process.nextTick;
          } else {
            _defer = fallback;
          }

          exports.default = wrap(_defer);
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../../timers-browserify/main.js */
        "../../node_modules/timers-browserify/main.js").setImmediate, __webpack_require__(
        /*! ./../../process/browser.js */
        "../../node_modules/process/browser.js"));
        /***/
      },

      /***/
      "../../node_modules/async/internal/slice.js":
      /*!***************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/internal/slice.js ***!
        \***************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncInternalSliceJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = slice;

        function slice(arrayLike, start) {
          start = start | 0;
          var newLen = Math.max(arrayLike.length - start, 0);
          var newArr = Array(newLen);

          for (var idx = 0; idx < newLen; idx++) {
            newArr[idx] = arrayLike[start + idx];
          }

          return newArr;
        }

        module.exports = exports["default"];
        /***/
      },

      /***/
      "../../node_modules/async/internal/withoutIndex.js":
      /*!**********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/internal/withoutIndex.js ***!
        \**********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncInternalWithoutIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.default = _withoutIndex;

        function _withoutIndex(iteratee) {
          return function (value, index, callback) {
            return iteratee(value, callback);
          };
        }

        module.exports = exports["default"];
        /***/
      },

      /***/
      "../../node_modules/async/internal/wrapAsync.js":
      /*!*******************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/async/internal/wrapAsync.js ***!
        \*******************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAsyncInternalWrapAsyncJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports.isAsync = undefined;

        var _asyncify = __webpack_require__(
        /*! ../asyncify */
        "../../node_modules/async/asyncify.js");

        var _asyncify2 = _interopRequireDefault(_asyncify);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        var supportsSymbol = typeof Symbol === 'function';

        function isAsync(fn) {
          return supportsSymbol && fn[Symbol.toStringTag] === 'AsyncFunction';
        }

        function wrapAsync(asyncFn) {
          return isAsync(asyncFn) ? (0, _asyncify2.default)(asyncFn) : asyncFn;
        }

        exports.default = wrapAsync;
        exports.isAsync = isAsync;
        /***/
      },

      /***/
      "../../node_modules/babel-runtime/core-js/object/create.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/core-js/object/create.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsObjectCreateJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/object/create */
          "../../node_modules/core-js/library/fn/object/create.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "../../node_modules/babel-runtime/core-js/object/define-property.js":
      /*!***************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/core-js/object/define-property.js ***!
        \***************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsObjectDefinePropertyJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/object/define-property */
          "../../node_modules/core-js/library/fn/object/define-property.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "../../node_modules/babel-runtime/core-js/object/get-prototype-of.js":
      /*!****************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/core-js/object/get-prototype-of.js ***!
        \****************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsObjectGetPrototypeOfJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/object/get-prototype-of */
          "../../node_modules/core-js/library/fn/object/get-prototype-of.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "../../node_modules/babel-runtime/core-js/object/set-prototype-of.js":
      /*!****************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/core-js/object/set-prototype-of.js ***!
        \****************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsObjectSetPrototypeOfJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/object/set-prototype-of */
          "../../node_modules/core-js/library/fn/object/set-prototype-of.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "../../node_modules/babel-runtime/core-js/promise.js":
      /*!************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/core-js/promise.js ***!
        \************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsPromiseJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/promise */
          "../../node_modules/core-js/library/fn/promise.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "../../node_modules/babel-runtime/core-js/symbol.js":
      /*!***********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/core-js/symbol.js ***!
        \***********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsSymbolJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/symbol */
          "../../node_modules/core-js/library/fn/symbol/index.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "../../node_modules/babel-runtime/core-js/symbol/iterator.js":
      /*!********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/core-js/symbol/iterator.js ***!
        \********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeCoreJsSymbolIteratorJs(module, exports, __webpack_require__) {
        module.exports = {
          "default": __webpack_require__(
          /*! core-js/library/fn/symbol/iterator */
          "../../node_modules/core-js/library/fn/symbol/iterator.js"),
          __esModule: true
        };
        /***/
      },

      /***/
      "../../node_modules/babel-runtime/helpers/asyncToGenerator.js":
      /*!*********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/helpers/asyncToGenerator.js ***!
        \*********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersAsyncToGeneratorJs(module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;

        var _promise = __webpack_require__(
        /*! ../core-js/promise */
        "../../node_modules/babel-runtime/core-js/promise.js");

        var _promise2 = _interopRequireDefault(_promise);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.default = function (fn) {
          return function () {
            var gen = fn.apply(this, arguments);
            return new _promise2.default(function (resolve, reject) {
              function step(key, arg) {
                try {
                  var info = gen[key](arg);
                  var value = info.value;
                } catch (error) {
                  reject(error);
                  return;
                }

                if (info.done) {
                  resolve(value);
                } else {
                  return _promise2.default.resolve(value).then(function (value) {
                    step("next", value);
                  }, function (err) {
                    step("throw", err);
                  });
                }
              }

              return step("next");
            });
          };
        };
        /***/

      },

      /***/
      "../../node_modules/babel-runtime/helpers/classCallCheck.js":
      /*!*******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/helpers/classCallCheck.js ***!
        \*******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersClassCallCheckJs(module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;

        exports.default = function (instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        };
        /***/

      },

      /***/
      "../../node_modules/babel-runtime/helpers/createClass.js":
      /*!****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/helpers/createClass.js ***!
        \****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersCreateClassJs(module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;

        var _defineProperty = __webpack_require__(
        /*! ../core-js/object/define-property */
        "../../node_modules/babel-runtime/core-js/object/define-property.js");

        var _defineProperty2 = _interopRequireDefault(_defineProperty);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.default = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              (0, _defineProperty2.default)(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        /***/

      },

      /***/
      "../../node_modules/babel-runtime/helpers/inherits.js":
      /*!*************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/helpers/inherits.js ***!
        \*************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersInheritsJs(module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;

        var _setPrototypeOf = __webpack_require__(
        /*! ../core-js/object/set-prototype-of */
        "../../node_modules/babel-runtime/core-js/object/set-prototype-of.js");

        var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

        var _create = __webpack_require__(
        /*! ../core-js/object/create */
        "../../node_modules/babel-runtime/core-js/object/create.js");

        var _create2 = _interopRequireDefault(_create);

        var _typeof2 = __webpack_require__(
        /*! ../helpers/typeof */
        "../../node_modules/babel-runtime/helpers/typeof.js");

        var _typeof3 = _interopRequireDefault(_typeof2);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.default = function (subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
          }

          subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
        };
        /***/

      },

      /***/
      "../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js":
      /*!******************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/helpers/possibleConstructorReturn.js ***!
        \******************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersPossibleConstructorReturnJs(module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;

        var _typeof2 = __webpack_require__(
        /*! ../helpers/typeof */
        "../../node_modules/babel-runtime/helpers/typeof.js");

        var _typeof3 = _interopRequireDefault(_typeof2);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.default = function (self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
        };
        /***/

      },

      /***/
      "../../node_modules/babel-runtime/helpers/typeof.js":
      /*!***********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/helpers/typeof.js ***!
        \***********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersTypeofJs(module, exports, __webpack_require__) {
        "use strict";

        exports.__esModule = true;

        var _iterator = __webpack_require__(
        /*! ../core-js/symbol/iterator */
        "../../node_modules/babel-runtime/core-js/symbol/iterator.js");

        var _iterator2 = _interopRequireDefault(_iterator);

        var _symbol = __webpack_require__(
        /*! ../core-js/symbol */
        "../../node_modules/babel-runtime/core-js/symbol.js");

        var _symbol2 = _interopRequireDefault(_symbol);

        var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
        };

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
          return typeof obj === "undefined" ? "undefined" : _typeof(obj);
        } : function (obj) {
          return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
        };
        /***/
      },

      /***/
      "../../node_modules/babel-runtime/node_modules/regenerator-runtime/runtime-module.js":
      /*!********************************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/node_modules/regenerator-runtime/runtime-module.js ***!
        \********************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeNode_modulesRegeneratorRuntimeRuntimeModuleJs(module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        // This method of obtaining a reference to the global object needs to be
        // kept identical to the way it is obtained in runtime.js
        var g = function () {
          return this;
        }() || Function("return this")(); // Use `getOwnPropertyNames` because not all browsers support calling
        // `hasOwnProperty` on the global `self` object in a worker. See #183.


        var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0; // Save the old regeneratorRuntime in case it needs to be restored later.

        var oldRuntime = hadRuntime && g.regeneratorRuntime; // Force reevalutation of runtime.js.

        g.regeneratorRuntime = undefined;
        module.exports = __webpack_require__(
        /*! ./runtime */
        "../../node_modules/babel-runtime/node_modules/regenerator-runtime/runtime.js");

        if (hadRuntime) {
          // Restore the original runtime.
          g.regeneratorRuntime = oldRuntime;
        } else {
          // Remove the global property added by runtime.js.
          try {
            delete g.regeneratorRuntime;
          } catch (e) {
            g.regeneratorRuntime = undefined;
          }
        }
        /***/

      },

      /***/
      "../../node_modules/babel-runtime/node_modules/regenerator-runtime/runtime.js":
      /*!*************************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/node_modules/regenerator-runtime/runtime.js ***!
        \*************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeNode_modulesRegeneratorRuntimeRuntimeJs(module, exports) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        !function (global) {
          "use strict";

          var Op = Object.prototype;
          var hasOwn = Op.hasOwnProperty;
          var undefined; // More compressible than void 0.

          var $Symbol = typeof Symbol === "function" ? Symbol : {};
          var iteratorSymbol = $Symbol.iterator || "@@iterator";
          var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
          var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
          var inModule = typeof module === "object";
          var runtime = global.regeneratorRuntime;

          if (runtime) {
            if (inModule) {
              // If regeneratorRuntime is defined globally and we're in a module,
              // make the exports object identical to regeneratorRuntime.
              module.exports = runtime;
            } // Don't bother evaluating the rest of this file if the runtime was
            // already defined globally.


            return;
          } // Define the runtime globally (as expected by generated code) as either
          // module.exports (if we're in a module) or a new, empty object.


          runtime = global.regeneratorRuntime = inModule ? module.exports : {};

          function wrap(innerFn, outerFn, self, tryLocsList) {
            // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
            var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
            var generator = Object.create(protoGenerator.prototype);
            var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
            // .throw, and .return methods.

            generator._invoke = makeInvokeMethod(innerFn, self, context);
            return generator;
          }

          runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
          // record like context.tryEntries[i].completion. This interface could
          // have been (and was previously) designed to take a closure to be
          // invoked without arguments, but in all the cases we care about we
          // already have an existing method we want to call, so there's no need
          // to create a new function object. We can even get away with assuming
          // the method takes exactly one argument, since that happens to be true
          // in every case, so we don't have to touch the arguments object. The
          // only additional allocation required is the completion record, which
          // has a stable shape and so hopefully should be cheap to allocate.

          function tryCatch(fn, obj, arg) {
            try {
              return {
                type: "normal",
                arg: fn.call(obj, arg)
              };
            } catch (err) {
              return {
                type: "throw",
                arg: err
              };
            }
          }

          var GenStateSuspendedStart = "suspendedStart";
          var GenStateSuspendedYield = "suspendedYield";
          var GenStateExecuting = "executing";
          var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
          // breaking out of the dispatch switch statement.

          var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
          // .constructor.prototype properties for functions that return Generator
          // objects. For full spec compliance, you may wish to configure your
          // minifier not to mangle the names of these two functions.

          function Generator() {}

          function GeneratorFunction() {}

          function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
          // don't natively support it.


          var IteratorPrototype = {};

          IteratorPrototype[iteratorSymbol] = function () {
            return this;
          };

          var getProto = Object.getPrototypeOf;
          var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

          if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
            // This environment has a native %IteratorPrototype%; use it instead
            // of the polyfill.
            IteratorPrototype = NativeIteratorPrototype;
          }

          var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
          GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
          GeneratorFunctionPrototype.constructor = GeneratorFunction;
          GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
          // Iterator interface in terms of a single ._invoke method.

          function defineIteratorMethods(prototype) {
            ["next", "throw", "return"].forEach(function (method) {
              prototype[method] = function (arg) {
                return this._invoke(method, arg);
              };
            });
          }

          runtime.isGeneratorFunction = function (genFun) {
            var ctor = typeof genFun === "function" && genFun.constructor;
            return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
            // do is to check its .name property.
            (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
          };

          runtime.mark = function (genFun) {
            if (Object.setPrototypeOf) {
              Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
            } else {
              genFun.__proto__ = GeneratorFunctionPrototype;

              if (!(toStringTagSymbol in genFun)) {
                genFun[toStringTagSymbol] = "GeneratorFunction";
              }
            }

            genFun.prototype = Object.create(Gp);
            return genFun;
          }; // Within the body of any async function, `await x` is transformed to
          // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
          // `hasOwn.call(value, "__await")` to determine if the yielded value is
          // meant to be awaited.


          runtime.awrap = function (arg) {
            return {
              __await: arg
            };
          };

          function AsyncIterator(generator) {
            function invoke(method, arg, resolve, reject) {
              var record = tryCatch(generator[method], generator, arg);

              if (record.type === "throw") {
                reject(record.arg);
              } else {
                var result = record.arg;
                var value = result.value;

                if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                  return Promise.resolve(value.__await).then(function (value) {
                    invoke("next", value, resolve, reject);
                  }, function (err) {
                    invoke("throw", err, resolve, reject);
                  });
                }

                return Promise.resolve(value).then(function (unwrapped) {
                  // When a yielded Promise is resolved, its final value becomes
                  // the .value of the Promise<{value,done}> result for the
                  // current iteration. If the Promise is rejected, however, the
                  // result for this iteration will be rejected with the same
                  // reason. Note that rejections of yielded Promises are not
                  // thrown back into the generator function, as is the case
                  // when an awaited Promise is rejected. This difference in
                  // behavior between yield and await is important, because it
                  // allows the consumer to decide what to do with the yielded
                  // rejection (swallow it and continue, manually .throw it back
                  // into the generator, abandon iteration, whatever). With
                  // await, by contrast, there is no opportunity to examine the
                  // rejection reason outside the generator function, so the
                  // only option is to throw it from the await expression, and
                  // let the generator function handle the exception.
                  result.value = unwrapped;
                  resolve(result);
                }, reject);
              }
            }

            var previousPromise;

            function enqueue(method, arg) {
              function callInvokeWithMethodAndArg() {
                return new Promise(function (resolve, reject) {
                  invoke(method, arg, resolve, reject);
                });
              }

              return previousPromise = // If enqueue has been called before, then we want to wait until
              // all previous Promises have been resolved before calling invoke,
              // so that results are always delivered in the correct order. If
              // enqueue has not been called before, then it is important to
              // call invoke immediately, without waiting on a callback to fire,
              // so that the async generator function has the opportunity to do
              // any necessary setup in a predictable way. This predictability
              // is why the Promise constructor synchronously invokes its
              // executor callback, and why async functions synchronously
              // execute code before the first await. Since we implement simple
              // async functions in terms of async generators, it is especially
              // important to get this right, even though it requires care.
              previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
              // invocations of the iterator.
              callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            } // Define the unified helper method that is used to implement .next,
            // .throw, and .return (see defineIteratorMethods).


            this._invoke = enqueue;
          }

          defineIteratorMethods(AsyncIterator.prototype);

          AsyncIterator.prototype[asyncIteratorSymbol] = function () {
            return this;
          };

          runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
          // AsyncIterator objects; they just return a Promise for the value of
          // the final result produced by the iterator.

          runtime.async = function (innerFn, outerFn, self, tryLocsList) {
            var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
            return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
            : iter.next().then(function (result) {
              return result.done ? result.value : iter.next();
            });
          };

          function makeInvokeMethod(innerFn, self, context) {
            var state = GenStateSuspendedStart;
            return function invoke(method, arg) {
              if (state === GenStateExecuting) {
                throw new Error("Generator is already running");
              }

              if (state === GenStateCompleted) {
                if (method === "throw") {
                  throw arg;
                } // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


                return doneResult();
              }

              context.method = method;
              context.arg = arg;

              while (true) {
                var delegate = context.delegate;

                if (delegate) {
                  var delegateResult = maybeInvokeDelegate(delegate, context);

                  if (delegateResult) {
                    if (delegateResult === ContinueSentinel) continue;
                    return delegateResult;
                  }
                }

                if (context.method === "next") {
                  // Setting context._sent for legacy support of Babel's
                  // function.sent implementation.
                  context.sent = context._sent = context.arg;
                } else if (context.method === "throw") {
                  if (state === GenStateSuspendedStart) {
                    state = GenStateCompleted;
                    throw context.arg;
                  }

                  context.dispatchException(context.arg);
                } else if (context.method === "return") {
                  context.abrupt("return", context.arg);
                }

                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);

                if (record.type === "normal") {
                  // If an exception is thrown from innerFn, we leave state ===
                  // GenStateExecuting and loop back for another invocation.
                  state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                  if (record.arg === ContinueSentinel) {
                    continue;
                  }

                  return {
                    value: record.arg,
                    done: context.done
                  };
                } else if (record.type === "throw") {
                  state = GenStateCompleted; // Dispatch the exception by looping back around to the
                  // context.dispatchException(context.arg) call above.

                  context.method = "throw";
                  context.arg = record.arg;
                }
              }
            };
          } // Call delegate.iterator[context.method](context.arg) and handle the
          // result, either by returning a { value, done } result from the
          // delegate iterator, or by modifying context.method and context.arg,
          // setting context.delegate to null, and returning the ContinueSentinel.


          function maybeInvokeDelegate(delegate, context) {
            var method = delegate.iterator[context.method];

            if (method === undefined) {
              // A .throw or .return when the delegate iterator has no .throw
              // method always terminates the yield* loop.
              context.delegate = null;

              if (context.method === "throw") {
                if (delegate.iterator.return) {
                  // If the delegate iterator has a return method, give it a
                  // chance to clean up.
                  context.method = "return";
                  context.arg = undefined;
                  maybeInvokeDelegate(delegate, context);

                  if (context.method === "throw") {
                    // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                  }
                }

                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
              }

              return ContinueSentinel;
            }

            var record = tryCatch(method, delegate.iterator, context.arg);

            if (record.type === "throw") {
              context.method = "throw";
              context.arg = record.arg;
              context.delegate = null;
              return ContinueSentinel;
            }

            var info = record.arg;

            if (!info) {
              context.method = "throw";
              context.arg = new TypeError("iterator result is not an object");
              context.delegate = null;
              return ContinueSentinel;
            }

            if (info.done) {
              // Assign the result of the finished delegate to the temporary
              // variable specified by delegate.resultName (see delegateYield).
              context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

              context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
              // exception, let the outer generator proceed normally. If
              // context.method was "next", forget context.arg since it has been
              // "consumed" by the delegate iterator. If context.method was
              // "return", allow the original .return call to continue in the
              // outer generator.

              if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
              }
            } else {
              // Re-yield the result returned by the delegate method.
              return info;
            } // The delegate iterator is finished, so forget it and continue with
            // the outer generator.


            context.delegate = null;
            return ContinueSentinel;
          } // Define Generator.prototype.{next,throw,return} in terms of the
          // unified ._invoke helper method.


          defineIteratorMethods(Gp);
          Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
          // @@iterator function is called on it. Some browsers' implementations of the
          // iterator prototype chain incorrectly implement this, causing the Generator
          // object to not be returned from this call. This ensures that doesn't happen.
          // See https://github.com/facebook/regenerator/issues/274 for more details.

          Gp[iteratorSymbol] = function () {
            return this;
          };

          Gp.toString = function () {
            return "[object Generator]";
          };

          function pushTryEntry(locs) {
            var entry = {
              tryLoc: locs[0]
            };

            if (1 in locs) {
              entry.catchLoc = locs[1];
            }

            if (2 in locs) {
              entry.finallyLoc = locs[2];
              entry.afterLoc = locs[3];
            }

            this.tryEntries.push(entry);
          }

          function resetTryEntry(entry) {
            var record = entry.completion || {};
            record.type = "normal";
            delete record.arg;
            entry.completion = record;
          }

          function Context(tryLocsList) {
            // The root entry object (effectively a try statement without a catch
            // or a finally block) gives us a place to store values thrown from
            // locations where there is no enclosing try statement.
            this.tryEntries = [{
              tryLoc: "root"
            }];
            tryLocsList.forEach(pushTryEntry, this);
            this.reset(true);
          }

          runtime.keys = function (object) {
            var keys = [];

            for (var key in object) {
              keys.push(key);
            }

            keys.reverse(); // Rather than returning an object with a next method, we keep
            // things simple and return the next function itself.

            return function next() {
              while (keys.length) {
                var key = keys.pop();

                if (key in object) {
                  next.value = key;
                  next.done = false;
                  return next;
                }
              } // To avoid creating an additional object, we just hang the .value
              // and .done properties off the next function object itself. This
              // also ensures that the minifier will not anonymize the function.


              next.done = true;
              return next;
            };
          };

          function values(iterable) {
            if (iterable) {
              var iteratorMethod = iterable[iteratorSymbol];

              if (iteratorMethod) {
                return iteratorMethod.call(iterable);
              }

              if (typeof iterable.next === "function") {
                return iterable;
              }

              if (!isNaN(iterable.length)) {
                var i = -1,
                    next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }

                  next.value = undefined;
                  next.done = true;
                  return next;
                };

                return next.next = next;
              }
            } // Return an iterator with no values.


            return {
              next: doneResult
            };
          }

          runtime.values = values;

          function doneResult() {
            return {
              value: undefined,
              done: true
            };
          }

          Context.prototype = {
            constructor: Context,
            reset: function reset(skipTempReset) {
              this.prev = 0;
              this.next = 0; // Resetting context._sent for legacy support of Babel's
              // function.sent implementation.

              this.sent = this._sent = undefined;
              this.done = false;
              this.delegate = null;
              this.method = "next";
              this.arg = undefined;
              this.tryEntries.forEach(resetTryEntry);

              if (!skipTempReset) {
                for (var name in this) {
                  // Not sure about the optimal order of these conditions:
                  if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                    this[name] = undefined;
                  }
                }
              }
            },
            stop: function stop() {
              this.done = true;
              var rootEntry = this.tryEntries[0];
              var rootRecord = rootEntry.completion;

              if (rootRecord.type === "throw") {
                throw rootRecord.arg;
              }

              return this.rval;
            },
            dispatchException: function dispatchException(exception) {
              if (this.done) {
                throw exception;
              }

              var context = this;

              function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;

                if (caught) {
                  // If the dispatched exception was caught by a catch block,
                  // then let that catch block handle the exception normally.
                  context.method = "next";
                  context.arg = undefined;
                }

                return !!caught;
              }

              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                var record = entry.completion;

                if (entry.tryLoc === "root") {
                  // Exception thrown outside of any try block that could handle
                  // it, so set the completion value of the entire function to
                  // throw the exception.
                  return handle("end");
                }

                if (entry.tryLoc <= this.prev) {
                  var hasCatch = hasOwn.call(entry, "catchLoc");
                  var hasFinally = hasOwn.call(entry, "finallyLoc");

                  if (hasCatch && hasFinally) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    } else if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else if (hasCatch) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    }
                  } else if (hasFinally) {
                    if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else {
                    throw new Error("try statement without catch or finally");
                  }
                }
              }
            },
            abrupt: function abrupt(type, arg) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                  var finallyEntry = entry;
                  break;
                }
              }

              if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                // Ignore the finally entry if control is not jumping to a
                // location outside the try/catch block.
                finallyEntry = null;
              }

              var record = finallyEntry ? finallyEntry.completion : {};
              record.type = type;
              record.arg = arg;

              if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
              }

              return this.complete(record);
            },
            complete: function complete(record, afterLoc) {
              if (record.type === "throw") {
                throw record.arg;
              }

              if (record.type === "break" || record.type === "continue") {
                this.next = record.arg;
              } else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
              } else if (record.type === "normal" && afterLoc) {
                this.next = afterLoc;
              }

              return ContinueSentinel;
            },
            finish: function finish(finallyLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.finallyLoc === finallyLoc) {
                  this.complete(entry.completion, entry.afterLoc);
                  resetTryEntry(entry);
                  return ContinueSentinel;
                }
              }
            },
            "catch": function _catch(tryLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc === tryLoc) {
                  var record = entry.completion;

                  if (record.type === "throw") {
                    var thrown = record.arg;
                    resetTryEntry(entry);
                  }

                  return thrown;
                }
              } // The context.catch method must only be called with a location
              // argument that corresponds to a known catch block.


              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(iterable, resultName, nextLoc) {
              this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
              };

              if (this.method === "next") {
                // Deliberately forget the last sent value so that we don't
                // accidentally pass it on to the delegate.
                this.arg = undefined;
              }

              return ContinueSentinel;
            }
          };
        }( // In sloppy mode, unbound `this` refers to the global object, fallback to
        // Function constructor if we're in global strict mode. That is sadly a form
        // of indirect eval which violates Content Security Policy.
        function () {
          return this;
        }() || Function("return this")());
        /***/
      },

      /***/
      "../../node_modules/babel-runtime/regenerator/index.js":
      /*!**************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/babel-runtime/regenerator/index.js ***!
        \**************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeRegeneratorIndexJs(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(
        /*! regenerator-runtime */
        "../../node_modules/babel-runtime/node_modules/regenerator-runtime/runtime-module.js");
        /***/
      },

      /***/
      "../../node_modules/base64-js/index.js":
      /*!**********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/base64-js/index.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBase64JsIndexJs(module, exports, __webpack_require__) {
        "use strict";

        exports.byteLength = byteLength;
        exports.toByteArray = toByteArray;
        exports.fromByteArray = fromByteArray;
        var lookup = [];
        var revLookup = [];
        var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
        var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

        for (var i = 0, len = code.length; i < len; ++i) {
          lookup[i] = code[i];
          revLookup[code.charCodeAt(i)] = i;
        } // Support decoding URL-safe base64 strings, as Node.js does.
        // See: https://en.wikipedia.org/wiki/Base64#URL_applications


        revLookup['-'.charCodeAt(0)] = 62;
        revLookup['_'.charCodeAt(0)] = 63;

        function getLens(b64) {
          var len = b64.length;

          if (len % 4 > 0) {
            throw new Error('Invalid string. Length must be a multiple of 4');
          } // Trim off extra bytes after placeholder bytes are found
          // See: https://github.com/beatgammit/base64-js/issues/42


          var validLen = b64.indexOf('=');
          if (validLen === -1) validLen = len;
          var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
          return [validLen, placeHoldersLen];
        } // base64 is 4/3 + up to two characters of the original data


        function byteLength(b64) {
          var lens = getLens(b64);
          var validLen = lens[0];
          var placeHoldersLen = lens[1];
          return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
        }

        function _byteLength(b64, validLen, placeHoldersLen) {
          return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
        }

        function toByteArray(b64) {
          var tmp;
          var lens = getLens(b64);
          var validLen = lens[0];
          var placeHoldersLen = lens[1];
          var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
          var curByte = 0; // if there are placeholders, only get up to the last complete 4 chars

          var len = placeHoldersLen > 0 ? validLen - 4 : validLen;

          for (var i = 0; i < len; i += 4) {
            tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
            arr[curByte++] = tmp >> 16 & 0xFF;
            arr[curByte++] = tmp >> 8 & 0xFF;
            arr[curByte++] = tmp & 0xFF;
          }

          if (placeHoldersLen === 2) {
            tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
            arr[curByte++] = tmp & 0xFF;
          }

          if (placeHoldersLen === 1) {
            tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
            arr[curByte++] = tmp >> 8 & 0xFF;
            arr[curByte++] = tmp & 0xFF;
          }

          return arr;
        }

        function tripletToBase64(num) {
          return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
        }

        function encodeChunk(uint8, start, end) {
          var tmp;
          var output = [];

          for (var i = start; i < end; i += 3) {
            tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
            output.push(tripletToBase64(tmp));
          }

          return output.join('');
        }

        function fromByteArray(uint8) {
          var tmp;
          var len = uint8.length;
          var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes

          var parts = [];
          var maxChunkLength = 16383; // must be multiple of 3
          // go through the array every three bytes, we'll deal with trailing stuff later

          for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
            parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
          } // pad the end with zeros, but make sure to not forget the extra bytes


          if (extraBytes === 1) {
            tmp = uint8[len - 1];
            parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
          } else if (extraBytes === 2) {
            tmp = (uint8[len - 2] << 8) + uint8[len - 1];
            parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
          }

          return parts.join('');
        }
        /***/

      },

      /***/
      "../../node_modules/core-js/library/fn/object/create.js":
      /*!***************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/fn/object/create.js ***!
        \***************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnObjectCreateJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../../modules/es6.object.create */
        "../../node_modules/core-js/library/modules/es6.object.create.js");

        var $Object = __webpack_require__(
        /*! ../../modules/_core */
        "../../node_modules/core-js/library/modules/_core.js").Object;

        module.exports = function create(P, D) {
          return $Object.create(P, D);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/fn/object/define-property.js":
      /*!************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/fn/object/define-property.js ***!
        \************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnObjectDefinePropertyJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../../modules/es6.object.define-property */
        "../../node_modules/core-js/library/modules/es6.object.define-property.js");

        var $Object = __webpack_require__(
        /*! ../../modules/_core */
        "../../node_modules/core-js/library/modules/_core.js").Object;

        module.exports = function defineProperty(it, key, desc) {
          return $Object.defineProperty(it, key, desc);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/fn/object/get-prototype-of.js":
      /*!*************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/fn/object/get-prototype-of.js ***!
        \*************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnObjectGetPrototypeOfJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../../modules/es6.object.get-prototype-of */
        "../../node_modules/core-js/library/modules/es6.object.get-prototype-of.js");

        module.exports = __webpack_require__(
        /*! ../../modules/_core */
        "../../node_modules/core-js/library/modules/_core.js").Object.getPrototypeOf;
        /***/
      },

      /***/
      "../../node_modules/core-js/library/fn/object/set-prototype-of.js":
      /*!*************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/fn/object/set-prototype-of.js ***!
        \*************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnObjectSetPrototypeOfJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../../modules/es6.object.set-prototype-of */
        "../../node_modules/core-js/library/modules/es6.object.set-prototype-of.js");

        module.exports = __webpack_require__(
        /*! ../../modules/_core */
        "../../node_modules/core-js/library/modules/_core.js").Object.setPrototypeOf;
        /***/
      },

      /***/
      "../../node_modules/core-js/library/fn/promise.js":
      /*!*********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/fn/promise.js ***!
        \*********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnPromiseJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../modules/es6.object.to-string */
        "../../node_modules/core-js/library/modules/es6.object.to-string.js");

        __webpack_require__(
        /*! ../modules/es6.string.iterator */
        "../../node_modules/core-js/library/modules/es6.string.iterator.js");

        __webpack_require__(
        /*! ../modules/web.dom.iterable */
        "../../node_modules/core-js/library/modules/web.dom.iterable.js");

        __webpack_require__(
        /*! ../modules/es6.promise */
        "../../node_modules/core-js/library/modules/es6.promise.js");

        __webpack_require__(
        /*! ../modules/es7.promise.finally */
        "../../node_modules/core-js/library/modules/es7.promise.finally.js");

        __webpack_require__(
        /*! ../modules/es7.promise.try */
        "../../node_modules/core-js/library/modules/es7.promise.try.js");

        module.exports = __webpack_require__(
        /*! ../modules/_core */
        "../../node_modules/core-js/library/modules/_core.js").Promise;
        /***/
      },

      /***/
      "../../node_modules/core-js/library/fn/symbol/index.js":
      /*!**************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/fn/symbol/index.js ***!
        \**************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnSymbolIndexJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../../modules/es6.symbol */
        "../../node_modules/core-js/library/modules/es6.symbol.js");

        __webpack_require__(
        /*! ../../modules/es6.object.to-string */
        "../../node_modules/core-js/library/modules/es6.object.to-string.js");

        __webpack_require__(
        /*! ../../modules/es7.symbol.async-iterator */
        "../../node_modules/core-js/library/modules/es7.symbol.async-iterator.js");

        __webpack_require__(
        /*! ../../modules/es7.symbol.observable */
        "../../node_modules/core-js/library/modules/es7.symbol.observable.js");

        module.exports = __webpack_require__(
        /*! ../../modules/_core */
        "../../node_modules/core-js/library/modules/_core.js").Symbol;
        /***/
      },

      /***/
      "../../node_modules/core-js/library/fn/symbol/iterator.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/fn/symbol/iterator.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryFnSymbolIteratorJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ../../modules/es6.string.iterator */
        "../../node_modules/core-js/library/modules/es6.string.iterator.js");

        __webpack_require__(
        /*! ../../modules/web.dom.iterable */
        "../../node_modules/core-js/library/modules/web.dom.iterable.js");

        module.exports = __webpack_require__(
        /*! ../../modules/_wks-ext */
        "../../node_modules/core-js/library/modules/_wks-ext.js").f('iterator');
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_a-function.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_a-function.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_aFunctionJs(module, exports) {
        module.exports = function (it) {
          if (typeof it != 'function') throw TypeError(it + ' is not a function!');
          return it;
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_add-to-unscopables.js":
      /*!**************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_add-to-unscopables.js ***!
        \**************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_addToUnscopablesJs(module, exports) {
        module.exports = function () {
          /* empty */
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_an-instance.js":
      /*!*******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_an-instance.js ***!
        \*******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_anInstanceJs(module, exports) {
        module.exports = function (it, Constructor, name, forbiddenField) {
          if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
            throw TypeError(name + ': incorrect invocation!');
          }

          return it;
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_an-object.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_an-object.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_anObjectJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../../node_modules/core-js/library/modules/_is-object.js");

        module.exports = function (it) {
          if (!isObject(it)) throw TypeError(it + ' is not an object!');
          return it;
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_array-includes.js":
      /*!**********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_array-includes.js ***!
        \**********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_arrayIncludesJs(module, exports, __webpack_require__) {
        // false -> Array#indexOf
        // true  -> Array#includes
        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "../../node_modules/core-js/library/modules/_to-iobject.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "../../node_modules/core-js/library/modules/_to-length.js");

        var toAbsoluteIndex = __webpack_require__(
        /*! ./_to-absolute-index */
        "../../node_modules/core-js/library/modules/_to-absolute-index.js");

        module.exports = function (IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            var O = toIObject($this);
            var length = toLength(O.length);
            var index = toAbsoluteIndex(fromIndex, length);
            var value; // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare

            if (IS_INCLUDES && el != el) while (length > index) {
              value = O[index++]; // eslint-disable-next-line no-self-compare

              if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
            } else for (; length > index; index++) {
              if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
              }
            }
            return !IS_INCLUDES && -1;
          };
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_classof.js":
      /*!***************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_classof.js ***!
        \***************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_classofJs(module, exports, __webpack_require__) {
        // getting tag from 19.1.3.6 Object.prototype.toString()
        var cof = __webpack_require__(
        /*! ./_cof */
        "../../node_modules/core-js/library/modules/_cof.js");

        var TAG = __webpack_require__(
        /*! ./_wks */
        "../../node_modules/core-js/library/modules/_wks.js")('toStringTag'); // ES3 wrong here


        var ARG = cof(function () {
          return arguments;
        }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

        var tryGet = function tryGet(it, key) {
          try {
            return it[key];
          } catch (e) {
            /* empty */
          }
        };

        module.exports = function (it) {
          var O, T, B;
          return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
          : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T // builtinTag case
          : ARG ? cof(O) // ES3 arguments fallback
          : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_cof.js":
      /*!***********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_cof.js ***!
        \***********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_cofJs(module, exports) {
        var toString = {}.toString;

        module.exports = function (it) {
          return toString.call(it).slice(8, -1);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_core.js":
      /*!************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_core.js ***!
        \************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_coreJs(module, exports) {
        var core = module.exports = {
          version: '2.6.9'
        };
        if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_ctx.js":
      /*!***********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_ctx.js ***!
        \***********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_ctxJs(module, exports, __webpack_require__) {
        // optional / simple context binding
        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "../../node_modules/core-js/library/modules/_a-function.js");

        module.exports = function (fn, that, length) {
          aFunction(fn);
          if (that === undefined) return fn;

          switch (length) {
            case 1:
              return function (a) {
                return fn.call(that, a);
              };

            case 2:
              return function (a, b) {
                return fn.call(that, a, b);
              };

            case 3:
              return function (a, b, c) {
                return fn.call(that, a, b, c);
              };
          }

          return function ()
          /* ...args */
          {
            return fn.apply(that, arguments);
          };
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_defined.js":
      /*!***************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_defined.js ***!
        \***************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_definedJs(module, exports) {
        // 7.2.1 RequireObjectCoercible(argument)
        module.exports = function (it) {
          if (it == undefined) throw TypeError("Can't call method on  " + it);
          return it;
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_descriptors.js":
      /*!*******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_descriptors.js ***!
        \*******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_descriptorsJs(module, exports, __webpack_require__) {
        // Thank's IE8 for his funny defineProperty
        module.exports = !__webpack_require__(
        /*! ./_fails */
        "../../node_modules/core-js/library/modules/_fails.js")(function () {
          return Object.defineProperty({}, 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_dom-create.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_dom-create.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_domCreateJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../../node_modules/core-js/library/modules/_is-object.js");

        var document = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js").document; // typeof document.createElement is 'object' in old IE


        var is = isObject(document) && isObject(document.createElement);

        module.exports = function (it) {
          return is ? document.createElement(it) : {};
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_enum-bug-keys.js":
      /*!*********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_enum-bug-keys.js ***!
        \*********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_enumBugKeysJs(module, exports) {
        // IE 8- don't enum bug keys
        module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_enum-keys.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_enum-keys.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_enumKeysJs(module, exports, __webpack_require__) {
        // all enumerable object keys, includes symbols
        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "../../node_modules/core-js/library/modules/_object-keys.js");

        var gOPS = __webpack_require__(
        /*! ./_object-gops */
        "../../node_modules/core-js/library/modules/_object-gops.js");

        var pIE = __webpack_require__(
        /*! ./_object-pie */
        "../../node_modules/core-js/library/modules/_object-pie.js");

        module.exports = function (it) {
          var result = getKeys(it);
          var getSymbols = gOPS.f;

          if (getSymbols) {
            var symbols = getSymbols(it);
            var isEnum = pIE.f;
            var i = 0;
            var key;

            while (symbols.length > i) {
              if (isEnum.call(it, key = symbols[i++])) result.push(key);
            }
          }

          return result;
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_export.js":
      /*!**************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_export.js ***!
        \**************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_exportJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js");

        var core = __webpack_require__(
        /*! ./_core */
        "../../node_modules/core-js/library/modules/_core.js");

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "../../node_modules/core-js/library/modules/_ctx.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "../../node_modules/core-js/library/modules/_hide.js");

        var has = __webpack_require__(
        /*! ./_has */
        "../../node_modules/core-js/library/modules/_has.js");

        var PROTOTYPE = 'prototype';

        var $export = function $export(type, name, source) {
          var IS_FORCED = type & $export.F;
          var IS_GLOBAL = type & $export.G;
          var IS_STATIC = type & $export.S;
          var IS_PROTO = type & $export.P;
          var IS_BIND = type & $export.B;
          var IS_WRAP = type & $export.W;
          var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
          var expProto = exports[PROTOTYPE];
          var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
          var key, own, out;
          if (IS_GLOBAL) source = name;

          for (key in source) {
            // contains in native
            own = !IS_FORCED && target && target[key] !== undefined;
            if (own && has(exports, key)) continue; // export native or passed

            out = own ? target[key] : source[key]; // prevent global pollution for namespaces

            exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] // bind timers to global for call from export context
            : IS_BIND && own ? ctx(out, global) // wrap global constructors for prevent change them in library
            : IS_WRAP && target[key] == out ? function (C) {
              var F = function F(a, b, c) {
                if (this instanceof C) {
                  switch (arguments.length) {
                    case 0:
                      return new C();

                    case 1:
                      return new C(a);

                    case 2:
                      return new C(a, b);
                  }

                  return new C(a, b, c);
                }

                return C.apply(this, arguments);
              };

              F[PROTOTYPE] = C[PROTOTYPE];
              return F; // make static versions for prototype methods
            }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%

            if (IS_PROTO) {
              (exports.virtual || (exports.virtual = {}))[key] = out; // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%

              if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
            }
          }
        }; // type bitmap


        $export.F = 1; // forced

        $export.G = 2; // global

        $export.S = 4; // static

        $export.P = 8; // proto

        $export.B = 16; // bind

        $export.W = 32; // wrap

        $export.U = 64; // safe

        $export.R = 128; // real proto method for `library`

        module.exports = $export;
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_fails.js":
      /*!*************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_fails.js ***!
        \*************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_failsJs(module, exports) {
        module.exports = function (exec) {
          try {
            return !!exec();
          } catch (e) {
            return true;
          }
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_for-of.js":
      /*!**************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_for-of.js ***!
        \**************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_forOfJs(module, exports, __webpack_require__) {
        var ctx = __webpack_require__(
        /*! ./_ctx */
        "../../node_modules/core-js/library/modules/_ctx.js");

        var call = __webpack_require__(
        /*! ./_iter-call */
        "../../node_modules/core-js/library/modules/_iter-call.js");

        var isArrayIter = __webpack_require__(
        /*! ./_is-array-iter */
        "../../node_modules/core-js/library/modules/_is-array-iter.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../../node_modules/core-js/library/modules/_an-object.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "../../node_modules/core-js/library/modules/_to-length.js");

        var getIterFn = __webpack_require__(
        /*! ./core.get-iterator-method */
        "../../node_modules/core-js/library/modules/core.get-iterator-method.js");

        var BREAK = {};
        var RETURN = {};

        var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
          var iterFn = ITERATOR ? function () {
            return iterable;
          } : getIterFn(iterable);
          var f = ctx(fn, that, entries ? 2 : 1);
          var index = 0;
          var length, step, iterator, result;
          if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!'); // fast case for arrays with default iterator

          if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
            result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
            if (result === BREAK || result === RETURN) return result;
          } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
            result = call(iterator, f, step.value, entries);
            if (result === BREAK || result === RETURN) return result;
          }
        };

        exports.BREAK = BREAK;
        exports.RETURN = RETURN;
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_global.js":
      /*!**************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_global.js ***!
        \**************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_globalJs(module, exports) {
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
        : Function('return this')();
        if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_has.js":
      /*!***********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_has.js ***!
        \***********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_hasJs(module, exports) {
        var hasOwnProperty = {}.hasOwnProperty;

        module.exports = function (it, key) {
          return hasOwnProperty.call(it, key);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_hide.js":
      /*!************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_hide.js ***!
        \************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_hideJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "../../node_modules/core-js/library/modules/_object-dp.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "../../node_modules/core-js/library/modules/_property-desc.js");

        module.exports = __webpack_require__(
        /*! ./_descriptors */
        "../../node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
          return dP.f(object, key, createDesc(1, value));
        } : function (object, key, value) {
          object[key] = value;
          return object;
        };
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_html.js":
      /*!************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_html.js ***!
        \************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_htmlJs(module, exports, __webpack_require__) {
        var document = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js").document;

        module.exports = document && document.documentElement;
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_ie8-dom-define.js":
      /*!**********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_ie8-dom-define.js ***!
        \**********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_ie8DomDefineJs(module, exports, __webpack_require__) {
        module.exports = !__webpack_require__(
        /*! ./_descriptors */
        "../../node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__(
        /*! ./_fails */
        "../../node_modules/core-js/library/modules/_fails.js")(function () {
          return Object.defineProperty(__webpack_require__(
          /*! ./_dom-create */
          "../../node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_invoke.js":
      /*!**************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_invoke.js ***!
        \**************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_invokeJs(module, exports) {
        // fast apply, http://jsperf.lnkit.com/fast-apply/5
        module.exports = function (fn, args, that) {
          var un = that === undefined;

          switch (args.length) {
            case 0:
              return un ? fn() : fn.call(that);

            case 1:
              return un ? fn(args[0]) : fn.call(that, args[0]);

            case 2:
              return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);

            case 3:
              return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);

            case 4:
              return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
          }

          return fn.apply(that, args);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_iobject.js":
      /*!***************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_iobject.js ***!
        \***************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iobjectJs(module, exports, __webpack_require__) {
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        var cof = __webpack_require__(
        /*! ./_cof */
        "../../node_modules/core-js/library/modules/_cof.js"); // eslint-disable-next-line no-prototype-builtins


        module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
          return cof(it) == 'String' ? it.split('') : Object(it);
        };
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_is-array-iter.js":
      /*!*********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_is-array-iter.js ***!
        \*********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_isArrayIterJs(module, exports, __webpack_require__) {
        // check on default Array iterator
        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "../../node_modules/core-js/library/modules/_iterators.js");

        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "../../node_modules/core-js/library/modules/_wks.js")('iterator');

        var ArrayProto = Array.prototype;

        module.exports = function (it) {
          return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_is-array.js":
      /*!****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_is-array.js ***!
        \****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_isArrayJs(module, exports, __webpack_require__) {
        // 7.2.2 IsArray(argument)
        var cof = __webpack_require__(
        /*! ./_cof */
        "../../node_modules/core-js/library/modules/_cof.js");

        module.exports = Array.isArray || function isArray(arg) {
          return cof(arg) == 'Array';
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_is-object.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_is-object.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_isObjectJs(module, exports) {
        module.exports = function (it) {
          return typeof it === 'object' ? it !== null : typeof it === 'function';
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_iter-call.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_iter-call.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iterCallJs(module, exports, __webpack_require__) {
        // call something on iterator step with safe closing on error
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../../node_modules/core-js/library/modules/_an-object.js");

        module.exports = function (iterator, fn, value, entries) {
          try {
            return entries ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
          } catch (e) {
            var ret = iterator['return'];
            if (ret !== undefined) anObject(ret.call(iterator));
            throw e;
          }
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_iter-create.js":
      /*!*******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_iter-create.js ***!
        \*******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iterCreateJs(module, exports, __webpack_require__) {
        "use strict";

        var create = __webpack_require__(
        /*! ./_object-create */
        "../../node_modules/core-js/library/modules/_object-create.js");

        var descriptor = __webpack_require__(
        /*! ./_property-desc */
        "../../node_modules/core-js/library/modules/_property-desc.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "../../node_modules/core-js/library/modules/_set-to-string-tag.js");

        var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

        __webpack_require__(
        /*! ./_hide */
        "../../node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__(
        /*! ./_wks */
        "../../node_modules/core-js/library/modules/_wks.js")('iterator'), function () {
          return this;
        });

        module.exports = function (Constructor, NAME, next) {
          Constructor.prototype = create(IteratorPrototype, {
            next: descriptor(1, next)
          });
          setToStringTag(Constructor, NAME + ' Iterator');
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_iter-define.js":
      /*!*******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_iter-define.js ***!
        \*******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iterDefineJs(module, exports, __webpack_require__) {
        "use strict";

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "../../node_modules/core-js/library/modules/_library.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "../../node_modules/core-js/library/modules/_export.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "../../node_modules/core-js/library/modules/_redefine.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "../../node_modules/core-js/library/modules/_hide.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "../../node_modules/core-js/library/modules/_iterators.js");

        var $iterCreate = __webpack_require__(
        /*! ./_iter-create */
        "../../node_modules/core-js/library/modules/_iter-create.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "../../node_modules/core-js/library/modules/_set-to-string-tag.js");

        var getPrototypeOf = __webpack_require__(
        /*! ./_object-gpo */
        "../../node_modules/core-js/library/modules/_object-gpo.js");

        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "../../node_modules/core-js/library/modules/_wks.js")('iterator');

        var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

        var FF_ITERATOR = '@@iterator';
        var KEYS = 'keys';
        var VALUES = 'values';

        var returnThis = function returnThis() {
          return this;
        };

        module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
          $iterCreate(Constructor, NAME, next);

          var getMethod = function getMethod(kind) {
            if (!BUGGY && kind in proto) return proto[kind];

            switch (kind) {
              case KEYS:
                return function keys() {
                  return new Constructor(this, kind);
                };

              case VALUES:
                return function values() {
                  return new Constructor(this, kind);
                };
            }

            return function entries() {
              return new Constructor(this, kind);
            };
          };

          var TAG = NAME + ' Iterator';
          var DEF_VALUES = DEFAULT == VALUES;
          var VALUES_BUG = false;
          var proto = Base.prototype;
          var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
          var $default = $native || getMethod(DEFAULT);
          var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
          var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
          var methods, key, IteratorPrototype; // Fix native

          if ($anyNative) {
            IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

            if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
              // Set @@toStringTag to native iterators
              setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines

              if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
            }
          } // fix Array#{values, @@iterator}.name in V8 / FF


          if (DEF_VALUES && $native && $native.name !== VALUES) {
            VALUES_BUG = true;

            $default = function values() {
              return $native.call(this);
            };
          } // Define iterator


          if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
            hide(proto, ITERATOR, $default);
          } // Plug for library


          Iterators[NAME] = $default;
          Iterators[TAG] = returnThis;

          if (DEFAULT) {
            methods = {
              values: DEF_VALUES ? $default : getMethod(VALUES),
              keys: IS_SET ? $default : getMethod(KEYS),
              entries: $entries
            };
            if (FORCED) for (key in methods) {
              if (!(key in proto)) redefine(proto, key, methods[key]);
            } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
          }

          return methods;
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_iter-detect.js":
      /*!*******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_iter-detect.js ***!
        \*******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iterDetectJs(module, exports, __webpack_require__) {
        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "../../node_modules/core-js/library/modules/_wks.js")('iterator');

        var SAFE_CLOSING = false;

        try {
          var riter = [7][ITERATOR]();

          riter['return'] = function () {
            SAFE_CLOSING = true;
          }; // eslint-disable-next-line no-throw-literal


          Array.from(riter, function () {
            throw 2;
          });
        } catch (e) {
          /* empty */
        }

        module.exports = function (exec, skipClosing) {
          if (!skipClosing && !SAFE_CLOSING) return false;
          var safe = false;

          try {
            var arr = [7];
            var iter = arr[ITERATOR]();

            iter.next = function () {
              return {
                done: safe = true
              };
            };

            arr[ITERATOR] = function () {
              return iter;
            };

            exec(arr);
          } catch (e) {
            /* empty */
          }

          return safe;
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_iter-step.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_iter-step.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iterStepJs(module, exports) {
        module.exports = function (done, value) {
          return {
            value: value,
            done: !!done
          };
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_iterators.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_iterators.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_iteratorsJs(module, exports) {
        module.exports = {};
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_library.js":
      /*!***************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_library.js ***!
        \***************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_libraryJs(module, exports) {
        module.exports = true;
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_meta.js":
      /*!************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_meta.js ***!
        \************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_metaJs(module, exports, __webpack_require__) {
        var META = __webpack_require__(
        /*! ./_uid */
        "../../node_modules/core-js/library/modules/_uid.js")('meta');

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../../node_modules/core-js/library/modules/_is-object.js");

        var has = __webpack_require__(
        /*! ./_has */
        "../../node_modules/core-js/library/modules/_has.js");

        var setDesc = __webpack_require__(
        /*! ./_object-dp */
        "../../node_modules/core-js/library/modules/_object-dp.js").f;

        var id = 0;

        var isExtensible = Object.isExtensible || function () {
          return true;
        };

        var FREEZE = !__webpack_require__(
        /*! ./_fails */
        "../../node_modules/core-js/library/modules/_fails.js")(function () {
          return isExtensible(Object.preventExtensions({}));
        });

        var setMeta = function setMeta(it) {
          setDesc(it, META, {
            value: {
              i: 'O' + ++id,
              // object ID
              w: {} // weak collections IDs

            }
          });
        };

        var fastKey = function fastKey(it, create) {
          // return primitive with prefix
          if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

          if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return 'F'; // not necessary to add metadata

            if (!create) return 'E'; // add missing metadata

            setMeta(it); // return object ID
          }

          return it[META].i;
        };

        var getWeak = function getWeak(it, create) {
          if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return true; // not necessary to add metadata

            if (!create) return false; // add missing metadata

            setMeta(it); // return hash weak collections IDs
          }

          return it[META].w;
        }; // add metadata on freeze-family methods calling


        var onFreeze = function onFreeze(it) {
          if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
          return it;
        };

        var meta = module.exports = {
          KEY: META,
          NEED: false,
          fastKey: fastKey,
          getWeak: getWeak,
          onFreeze: onFreeze
        };
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_microtask.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_microtask.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_microtaskJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js");

        var macrotask = __webpack_require__(
        /*! ./_task */
        "../../node_modules/core-js/library/modules/_task.js").set;

        var Observer = global.MutationObserver || global.WebKitMutationObserver;
        var process = global.process;
        var Promise = global.Promise;
        var isNode = __webpack_require__(
        /*! ./_cof */
        "../../node_modules/core-js/library/modules/_cof.js")(process) == 'process';

        module.exports = function () {
          var head, last, notify;

          var flush = function flush() {
            var parent, fn;
            if (isNode && (parent = process.domain)) parent.exit();

            while (head) {
              fn = head.fn;
              head = head.next;

              try {
                fn();
              } catch (e) {
                if (head) notify();else last = undefined;
                throw e;
              }
            }

            last = undefined;
            if (parent) parent.enter();
          }; // Node.js


          if (isNode) {
            notify = function notify() {
              process.nextTick(flush);
            }; // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339

          } else if (Observer && !(global.navigator && global.navigator.standalone)) {
            var toggle = true;
            var node = document.createTextNode('');
            new Observer(flush).observe(node, {
              characterData: true
            }); // eslint-disable-line no-new

            notify = function notify() {
              node.data = toggle = !toggle;
            }; // environments with maybe non-completely correct, but existent Promise

          } else if (Promise && Promise.resolve) {
            // Promise.resolve without an argument throws an error in LG WebOS 2
            var promise = Promise.resolve(undefined);

            notify = function notify() {
              promise.then(flush);
            }; // for other environments - macrotask based on:
            // - setImmediate
            // - MessageChannel
            // - window.postMessag
            // - onreadystatechange
            // - setTimeout

          } else {
            notify = function notify() {
              // strange IE + webpack dev server bug - use .call(global)
              macrotask.call(global, flush);
            };
          }

          return function (fn) {
            var task = {
              fn: fn,
              next: undefined
            };
            if (last) last.next = task;

            if (!head) {
              head = task;
              notify();
            }

            last = task;
          };
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_new-promise-capability.js":
      /*!******************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_new-promise-capability.js ***!
        \******************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_newPromiseCapabilityJs(module, exports, __webpack_require__) {
        "use strict"; // 25.4.1.5 NewPromiseCapability(C)

        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "../../node_modules/core-js/library/modules/_a-function.js");

        function PromiseCapability(C) {
          var resolve, reject;
          this.promise = new C(function ($$resolve, $$reject) {
            if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
            resolve = $$resolve;
            reject = $$reject;
          });
          this.resolve = aFunction(resolve);
          this.reject = aFunction(reject);
        }

        module.exports.f = function (C) {
          return new PromiseCapability(C);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_object-create.js":
      /*!*********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_object-create.js ***!
        \*********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectCreateJs(module, exports, __webpack_require__) {
        // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../../node_modules/core-js/library/modules/_an-object.js");

        var dPs = __webpack_require__(
        /*! ./_object-dps */
        "../../node_modules/core-js/library/modules/_object-dps.js");

        var enumBugKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "../../node_modules/core-js/library/modules/_enum-bug-keys.js");

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "../../node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

        var Empty = function Empty() {
          /* empty */
        };

        var PROTOTYPE = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

        var _createDict = function createDict() {
          // Thrash, waste and sodomy: IE GC bug
          var iframe = __webpack_require__(
          /*! ./_dom-create */
          "../../node_modules/core-js/library/modules/_dom-create.js")('iframe');

          var i = enumBugKeys.length;
          var lt = '<';
          var gt = '>';
          var iframeDocument;
          iframe.style.display = 'none';

          __webpack_require__(
          /*! ./_html */
          "../../node_modules/core-js/library/modules/_html.js").appendChild(iframe);

          iframe.src = 'javascript:'; // eslint-disable-line no-script-url
          // createDict = iframe.contentWindow.Object;
          // html.removeChild(iframe);

          iframeDocument = iframe.contentWindow.document;
          iframeDocument.open();
          iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
          iframeDocument.close();
          _createDict = iframeDocument.F;

          while (i--) {
            delete _createDict[PROTOTYPE][enumBugKeys[i]];
          }

          return _createDict();
        };

        module.exports = Object.create || function create(O, Properties) {
          var result;

          if (O !== null) {
            Empty[PROTOTYPE] = anObject(O);
            result = new Empty();
            Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

            result[IE_PROTO] = O;
          } else result = _createDict();

          return Properties === undefined ? result : dPs(result, Properties);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_object-dp.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_object-dp.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectDpJs(module, exports, __webpack_require__) {
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../../node_modules/core-js/library/modules/_an-object.js");

        var IE8_DOM_DEFINE = __webpack_require__(
        /*! ./_ie8-dom-define */
        "../../node_modules/core-js/library/modules/_ie8-dom-define.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "../../node_modules/core-js/library/modules/_to-primitive.js");

        var dP = Object.defineProperty;
        exports.f = __webpack_require__(
        /*! ./_descriptors */
        "../../node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
          anObject(O);
          P = toPrimitive(P, true);
          anObject(Attributes);
          if (IE8_DOM_DEFINE) try {
            return dP(O, P, Attributes);
          } catch (e) {
            /* empty */
          }
          if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
          if ('value' in Attributes) O[P] = Attributes.value;
          return O;
        };
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_object-dps.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_object-dps.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectDpsJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "../../node_modules/core-js/library/modules/_object-dp.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../../node_modules/core-js/library/modules/_an-object.js");

        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "../../node_modules/core-js/library/modules/_object-keys.js");

        module.exports = __webpack_require__(
        /*! ./_descriptors */
        "../../node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
          anObject(O);
          var keys = getKeys(Properties);
          var length = keys.length;
          var i = 0;
          var P;

          while (length > i) {
            dP.f(O, P = keys[i++], Properties[P]);
          }

          return O;
        };
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_object-gopd.js":
      /*!*******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_object-gopd.js ***!
        \*******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectGopdJs(module, exports, __webpack_require__) {
        var pIE = __webpack_require__(
        /*! ./_object-pie */
        "../../node_modules/core-js/library/modules/_object-pie.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "../../node_modules/core-js/library/modules/_property-desc.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "../../node_modules/core-js/library/modules/_to-iobject.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "../../node_modules/core-js/library/modules/_to-primitive.js");

        var has = __webpack_require__(
        /*! ./_has */
        "../../node_modules/core-js/library/modules/_has.js");

        var IE8_DOM_DEFINE = __webpack_require__(
        /*! ./_ie8-dom-define */
        "../../node_modules/core-js/library/modules/_ie8-dom-define.js");

        var gOPD = Object.getOwnPropertyDescriptor;
        exports.f = __webpack_require__(
        /*! ./_descriptors */
        "../../node_modules/core-js/library/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
          O = toIObject(O);
          P = toPrimitive(P, true);
          if (IE8_DOM_DEFINE) try {
            return gOPD(O, P);
          } catch (e) {
            /* empty */
          }
          if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
        };
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_object-gopn-ext.js":
      /*!***********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_object-gopn-ext.js ***!
        \***********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectGopnExtJs(module, exports, __webpack_require__) {
        // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "../../node_modules/core-js/library/modules/_to-iobject.js");

        var gOPN = __webpack_require__(
        /*! ./_object-gopn */
        "../../node_modules/core-js/library/modules/_object-gopn.js").f;

        var toString = {}.toString;
        var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

        var getWindowNames = function getWindowNames(it) {
          try {
            return gOPN(it);
          } catch (e) {
            return windowNames.slice();
          }
        };

        module.exports.f = function getOwnPropertyNames(it) {
          return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_object-gopn.js":
      /*!*******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_object-gopn.js ***!
        \*******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectGopnJs(module, exports, __webpack_require__) {
        // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
        var $keys = __webpack_require__(
        /*! ./_object-keys-internal */
        "../../node_modules/core-js/library/modules/_object-keys-internal.js");

        var hiddenKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "../../node_modules/core-js/library/modules/_enum-bug-keys.js").concat('length', 'prototype');

        exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
          return $keys(O, hiddenKeys);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_object-gops.js":
      /*!*******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_object-gops.js ***!
        \*******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectGopsJs(module, exports) {
        exports.f = Object.getOwnPropertySymbols;
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_object-gpo.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_object-gpo.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectGpoJs(module, exports, __webpack_require__) {
        // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
        var has = __webpack_require__(
        /*! ./_has */
        "../../node_modules/core-js/library/modules/_has.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "../../node_modules/core-js/library/modules/_to-object.js");

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "../../node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

        var ObjectProto = Object.prototype;

        module.exports = Object.getPrototypeOf || function (O) {
          O = toObject(O);
          if (has(O, IE_PROTO)) return O[IE_PROTO];

          if (typeof O.constructor == 'function' && O instanceof O.constructor) {
            return O.constructor.prototype;
          }

          return O instanceof Object ? ObjectProto : null;
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_object-keys-internal.js":
      /*!****************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_object-keys-internal.js ***!
        \****************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectKeysInternalJs(module, exports, __webpack_require__) {
        var has = __webpack_require__(
        /*! ./_has */
        "../../node_modules/core-js/library/modules/_has.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "../../node_modules/core-js/library/modules/_to-iobject.js");

        var arrayIndexOf = __webpack_require__(
        /*! ./_array-includes */
        "../../node_modules/core-js/library/modules/_array-includes.js")(false);

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "../../node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

        module.exports = function (object, names) {
          var O = toIObject(object);
          var i = 0;
          var result = [];
          var key;

          for (key in O) {
            if (key != IE_PROTO) has(O, key) && result.push(key);
          } // Don't enum bug & hidden keys


          while (names.length > i) {
            if (has(O, key = names[i++])) {
              ~arrayIndexOf(result, key) || result.push(key);
            }
          }

          return result;
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_object-keys.js":
      /*!*******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_object-keys.js ***!
        \*******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectKeysJs(module, exports, __webpack_require__) {
        // 19.1.2.14 / 15.2.3.14 Object.keys(O)
        var $keys = __webpack_require__(
        /*! ./_object-keys-internal */
        "../../node_modules/core-js/library/modules/_object-keys-internal.js");

        var enumBugKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "../../node_modules/core-js/library/modules/_enum-bug-keys.js");

        module.exports = Object.keys || function keys(O) {
          return $keys(O, enumBugKeys);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_object-pie.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_object-pie.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectPieJs(module, exports) {
        exports.f = {}.propertyIsEnumerable;
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_object-sap.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_object-sap.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_objectSapJs(module, exports, __webpack_require__) {
        // most Object methods by ES6 should accept primitives
        var $export = __webpack_require__(
        /*! ./_export */
        "../../node_modules/core-js/library/modules/_export.js");

        var core = __webpack_require__(
        /*! ./_core */
        "../../node_modules/core-js/library/modules/_core.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "../../node_modules/core-js/library/modules/_fails.js");

        module.exports = function (KEY, exec) {
          var fn = (core.Object || {})[KEY] || Object[KEY];
          var exp = {};
          exp[KEY] = exec(fn);
          $export($export.S + $export.F * fails(function () {
            fn(1);
          }), 'Object', exp);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_perform.js":
      /*!***************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_perform.js ***!
        \***************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_performJs(module, exports) {
        module.exports = function (exec) {
          try {
            return {
              e: false,
              v: exec()
            };
          } catch (e) {
            return {
              e: true,
              v: e
            };
          }
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_promise-resolve.js":
      /*!***********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_promise-resolve.js ***!
        \***********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_promiseResolveJs(module, exports, __webpack_require__) {
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../../node_modules/core-js/library/modules/_an-object.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../../node_modules/core-js/library/modules/_is-object.js");

        var newPromiseCapability = __webpack_require__(
        /*! ./_new-promise-capability */
        "../../node_modules/core-js/library/modules/_new-promise-capability.js");

        module.exports = function (C, x) {
          anObject(C);
          if (isObject(x) && x.constructor === C) return x;
          var promiseCapability = newPromiseCapability.f(C);
          var resolve = promiseCapability.resolve;
          resolve(x);
          return promiseCapability.promise;
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_property-desc.js":
      /*!*********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_property-desc.js ***!
        \*********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_propertyDescJs(module, exports) {
        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
          };
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_redefine-all.js":
      /*!********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_redefine-all.js ***!
        \********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_redefineAllJs(module, exports, __webpack_require__) {
        var hide = __webpack_require__(
        /*! ./_hide */
        "../../node_modules/core-js/library/modules/_hide.js");

        module.exports = function (target, src, safe) {
          for (var key in src) {
            if (safe && target[key]) target[key] = src[key];else hide(target, key, src[key]);
          }

          return target;
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_redefine.js":
      /*!****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_redefine.js ***!
        \****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_redefineJs(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(
        /*! ./_hide */
        "../../node_modules/core-js/library/modules/_hide.js");
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_set-proto.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_set-proto.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_setProtoJs(module, exports, __webpack_require__) {
        // Works with __proto__ only. Old v8 can't work with null proto objects.

        /* eslint-disable no-proto */
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../../node_modules/core-js/library/modules/_is-object.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../../node_modules/core-js/library/modules/_an-object.js");

        var check = function check(O, proto) {
          anObject(O);
          if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
        };

        module.exports = {
          set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
          function (test, buggy, set) {
            try {
              set = __webpack_require__(
              /*! ./_ctx */
              "../../node_modules/core-js/library/modules/_ctx.js")(Function.call, __webpack_require__(
              /*! ./_object-gopd */
              "../../node_modules/core-js/library/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
              set(test, []);
              buggy = !(test instanceof Array);
            } catch (e) {
              buggy = true;
            }

            return function setPrototypeOf(O, proto) {
              check(O, proto);
              if (buggy) O.__proto__ = proto;else set(O, proto);
              return O;
            };
          }({}, false) : undefined),
          check: check
        };
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_set-species.js":
      /*!*******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_set-species.js ***!
        \*******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_setSpeciesJs(module, exports, __webpack_require__) {
        "use strict";

        var global = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js");

        var core = __webpack_require__(
        /*! ./_core */
        "../../node_modules/core-js/library/modules/_core.js");

        var dP = __webpack_require__(
        /*! ./_object-dp */
        "../../node_modules/core-js/library/modules/_object-dp.js");

        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "../../node_modules/core-js/library/modules/_descriptors.js");

        var SPECIES = __webpack_require__(
        /*! ./_wks */
        "../../node_modules/core-js/library/modules/_wks.js")('species');

        module.exports = function (KEY) {
          var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
          if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
            configurable: true,
            get: function get() {
              return this;
            }
          });
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_set-to-string-tag.js":
      /*!*************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_set-to-string-tag.js ***!
        \*************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_setToStringTagJs(module, exports, __webpack_require__) {
        var def = __webpack_require__(
        /*! ./_object-dp */
        "../../node_modules/core-js/library/modules/_object-dp.js").f;

        var has = __webpack_require__(
        /*! ./_has */
        "../../node_modules/core-js/library/modules/_has.js");

        var TAG = __webpack_require__(
        /*! ./_wks */
        "../../node_modules/core-js/library/modules/_wks.js")('toStringTag');

        module.exports = function (it, tag, stat) {
          if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
            configurable: true,
            value: tag
          });
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_shared-key.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_shared-key.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_sharedKeyJs(module, exports, __webpack_require__) {
        var shared = __webpack_require__(
        /*! ./_shared */
        "../../node_modules/core-js/library/modules/_shared.js")('keys');

        var uid = __webpack_require__(
        /*! ./_uid */
        "../../node_modules/core-js/library/modules/_uid.js");

        module.exports = function (key) {
          return shared[key] || (shared[key] = uid(key));
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_shared.js":
      /*!**************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_shared.js ***!
        \**************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_sharedJs(module, exports, __webpack_require__) {
        var core = __webpack_require__(
        /*! ./_core */
        "../../node_modules/core-js/library/modules/_core.js");

        var global = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js");

        var SHARED = '__core-js_shared__';
        var store = global[SHARED] || (global[SHARED] = {});
        (module.exports = function (key, value) {
          return store[key] || (store[key] = value !== undefined ? value : {});
        })('versions', []).push({
          version: core.version,
          mode: __webpack_require__(
          /*! ./_library */
          "../../node_modules/core-js/library/modules/_library.js") ? 'pure' : 'global',
          copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
        });
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_species-constructor.js":
      /*!***************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_species-constructor.js ***!
        \***************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_speciesConstructorJs(module, exports, __webpack_require__) {
        // 7.3.20 SpeciesConstructor(O, defaultConstructor)
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../../node_modules/core-js/library/modules/_an-object.js");

        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "../../node_modules/core-js/library/modules/_a-function.js");

        var SPECIES = __webpack_require__(
        /*! ./_wks */
        "../../node_modules/core-js/library/modules/_wks.js")('species');

        module.exports = function (O, D) {
          var C = anObject(O).constructor;
          var S;
          return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_string-at.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_string-at.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_stringAtJs(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "../../node_modules/core-js/library/modules/_to-integer.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "../../node_modules/core-js/library/modules/_defined.js"); // true  -> String#at
        // false -> String#codePointAt


        module.exports = function (TO_STRING) {
          return function (that, pos) {
            var s = String(defined(that));
            var i = toInteger(pos);
            var l = s.length;
            var a, b;
            if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
            a = s.charCodeAt(i);
            return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
          };
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_task.js":
      /*!************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_task.js ***!
        \************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_taskJs(module, exports, __webpack_require__) {
        var ctx = __webpack_require__(
        /*! ./_ctx */
        "../../node_modules/core-js/library/modules/_ctx.js");

        var invoke = __webpack_require__(
        /*! ./_invoke */
        "../../node_modules/core-js/library/modules/_invoke.js");

        var html = __webpack_require__(
        /*! ./_html */
        "../../node_modules/core-js/library/modules/_html.js");

        var cel = __webpack_require__(
        /*! ./_dom-create */
        "../../node_modules/core-js/library/modules/_dom-create.js");

        var global = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js");

        var process = global.process;
        var setTask = global.setImmediate;
        var clearTask = global.clearImmediate;
        var MessageChannel = global.MessageChannel;
        var Dispatch = global.Dispatch;
        var counter = 0;
        var queue = {};
        var ONREADYSTATECHANGE = 'onreadystatechange';
        var defer, channel, port;

        var run = function run() {
          var id = +this; // eslint-disable-next-line no-prototype-builtins

          if (queue.hasOwnProperty(id)) {
            var fn = queue[id];
            delete queue[id];
            fn();
          }
        };

        var listener = function listener(event) {
          run.call(event.data);
        }; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


        if (!setTask || !clearTask) {
          setTask = function setImmediate(fn) {
            var args = [];
            var i = 1;

            while (arguments.length > i) {
              args.push(arguments[i++]);
            }

            queue[++counter] = function () {
              // eslint-disable-next-line no-new-func
              invoke(typeof fn == 'function' ? fn : Function(fn), args);
            };

            defer(counter);
            return counter;
          };

          clearTask = function clearImmediate(id) {
            delete queue[id];
          }; // Node.js 0.8-


          if (__webpack_require__(
          /*! ./_cof */
          "../../node_modules/core-js/library/modules/_cof.js")(process) == 'process') {
            defer = function defer(id) {
              process.nextTick(ctx(run, id, 1));
            }; // Sphere (JS game engine) Dispatch API

          } else if (Dispatch && Dispatch.now) {
            defer = function defer(id) {
              Dispatch.now(ctx(run, id, 1));
            }; // Browsers with MessageChannel, includes WebWorkers

          } else if (MessageChannel) {
            channel = new MessageChannel();
            port = channel.port2;
            channel.port1.onmessage = listener;
            defer = ctx(port.postMessage, port, 1); // Browsers with postMessage, skip WebWorkers
            // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
          } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
            defer = function defer(id) {
              global.postMessage(id + '', '*');
            };

            global.addEventListener('message', listener, false); // IE8-
          } else if (ONREADYSTATECHANGE in cel('script')) {
            defer = function defer(id) {
              html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
                html.removeChild(this);
                run.call(id);
              };
            }; // Rest old browsers

          } else {
            defer = function defer(id) {
              setTimeout(ctx(run, id, 1), 0);
            };
          }
        }

        module.exports = {
          set: setTask,
          clear: clearTask
        };
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_to-absolute-index.js":
      /*!*************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_to-absolute-index.js ***!
        \*************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_toAbsoluteIndexJs(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "../../node_modules/core-js/library/modules/_to-integer.js");

        var max = Math.max;
        var min = Math.min;

        module.exports = function (index, length) {
          index = toInteger(index);
          return index < 0 ? max(index + length, 0) : min(index, length);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_to-integer.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_to-integer.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_toIntegerJs(module, exports) {
        // 7.1.4 ToInteger
        var ceil = Math.ceil;
        var floor = Math.floor;

        module.exports = function (it) {
          return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_to-iobject.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_to-iobject.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_toIobjectJs(module, exports, __webpack_require__) {
        // to indexed object, toObject with fallback for non-array-like ES3 strings
        var IObject = __webpack_require__(
        /*! ./_iobject */
        "../../node_modules/core-js/library/modules/_iobject.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "../../node_modules/core-js/library/modules/_defined.js");

        module.exports = function (it) {
          return IObject(defined(it));
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_to-length.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_to-length.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_toLengthJs(module, exports, __webpack_require__) {
        // 7.1.15 ToLength
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "../../node_modules/core-js/library/modules/_to-integer.js");

        var min = Math.min;

        module.exports = function (it) {
          return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_to-object.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_to-object.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_toObjectJs(module, exports, __webpack_require__) {
        // 7.1.13 ToObject(argument)
        var defined = __webpack_require__(
        /*! ./_defined */
        "../../node_modules/core-js/library/modules/_defined.js");

        module.exports = function (it) {
          return Object(defined(it));
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_to-primitive.js":
      /*!********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_to-primitive.js ***!
        \********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_toPrimitiveJs(module, exports, __webpack_require__) {
        // 7.1.1 ToPrimitive(input [, PreferredType])
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../../node_modules/core-js/library/modules/_is-object.js"); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
        // and the second argument - flag - preferred type is a string


        module.exports = function (it, S) {
          if (!isObject(it)) return it;
          var fn, val;
          if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
          if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          throw TypeError("Can't convert object to primitive value");
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_uid.js":
      /*!***********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_uid.js ***!
        \***********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_uidJs(module, exports) {
        var id = 0;
        var px = Math.random();

        module.exports = function (key) {
          return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_user-agent.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_user-agent.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_userAgentJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js");

        var navigator = global.navigator;
        module.exports = navigator && navigator.userAgent || '';
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_wks-define.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_wks-define.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_wksDefineJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js");

        var core = __webpack_require__(
        /*! ./_core */
        "../../node_modules/core-js/library/modules/_core.js");

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "../../node_modules/core-js/library/modules/_library.js");

        var wksExt = __webpack_require__(
        /*! ./_wks-ext */
        "../../node_modules/core-js/library/modules/_wks-ext.js");

        var defineProperty = __webpack_require__(
        /*! ./_object-dp */
        "../../node_modules/core-js/library/modules/_object-dp.js").f;

        module.exports = function (name) {
          var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
          if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
            value: wksExt.f(name)
          });
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/_wks-ext.js":
      /*!***************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_wks-ext.js ***!
        \***************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_wksExtJs(module, exports, __webpack_require__) {
        exports.f = __webpack_require__(
        /*! ./_wks */
        "../../node_modules/core-js/library/modules/_wks.js");
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/_wks.js":
      /*!***********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/_wks.js ***!
        \***********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModules_wksJs(module, exports, __webpack_require__) {
        var store = __webpack_require__(
        /*! ./_shared */
        "../../node_modules/core-js/library/modules/_shared.js")('wks');

        var uid = __webpack_require__(
        /*! ./_uid */
        "../../node_modules/core-js/library/modules/_uid.js");

        var Symbol = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js").Symbol;

        var USE_SYMBOL = typeof Symbol == 'function';

        var $exports = module.exports = function (name) {
          return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
        };

        $exports.store = store;
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/core.get-iterator-method.js":
      /*!*******************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/core.get-iterator-method.js ***!
        \*******************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesCoreGetIteratorMethodJs(module, exports, __webpack_require__) {
        var classof = __webpack_require__(
        /*! ./_classof */
        "../../node_modules/core-js/library/modules/_classof.js");

        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "../../node_modules/core-js/library/modules/_wks.js")('iterator');

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "../../node_modules/core-js/library/modules/_iterators.js");

        module.exports = __webpack_require__(
        /*! ./_core */
        "../../node_modules/core-js/library/modules/_core.js").getIteratorMethod = function (it) {
          if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
        };
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/es6.array.iterator.js":
      /*!*************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/es6.array.iterator.js ***!
        \*************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6ArrayIteratorJs(module, exports, __webpack_require__) {
        "use strict";

        var addToUnscopables = __webpack_require__(
        /*! ./_add-to-unscopables */
        "../../node_modules/core-js/library/modules/_add-to-unscopables.js");

        var step = __webpack_require__(
        /*! ./_iter-step */
        "../../node_modules/core-js/library/modules/_iter-step.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "../../node_modules/core-js/library/modules/_iterators.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "../../node_modules/core-js/library/modules/_to-iobject.js"); // 22.1.3.4 Array.prototype.entries()
        // 22.1.3.13 Array.prototype.keys()
        // 22.1.3.29 Array.prototype.values()
        // 22.1.3.30 Array.prototype[@@iterator]()


        module.exports = __webpack_require__(
        /*! ./_iter-define */
        "../../node_modules/core-js/library/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
          this._t = toIObject(iterated); // target

          this._i = 0; // next index

          this._k = kind; // kind
          // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
        }, function () {
          var O = this._t;
          var kind = this._k;
          var index = this._i++;

          if (!O || index >= O.length) {
            this._t = undefined;
            return step(1);
          }

          if (kind == 'keys') return step(0, index);
          if (kind == 'values') return step(0, O[index]);
          return step(0, [index, O[index]]);
        }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)

        Iterators.Arguments = Iterators.Array;
        addToUnscopables('keys');
        addToUnscopables('values');
        addToUnscopables('entries');
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/es6.object.create.js":
      /*!************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/es6.object.create.js ***!
        \************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6ObjectCreateJs(module, exports, __webpack_require__) {
        var $export = __webpack_require__(
        /*! ./_export */
        "../../node_modules/core-js/library/modules/_export.js"); // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


        $export($export.S, 'Object', {
          create: __webpack_require__(
          /*! ./_object-create */
          "../../node_modules/core-js/library/modules/_object-create.js")
        });
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/es6.object.define-property.js":
      /*!*********************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/es6.object.define-property.js ***!
        \*********************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6ObjectDefinePropertyJs(module, exports, __webpack_require__) {
        var $export = __webpack_require__(
        /*! ./_export */
        "../../node_modules/core-js/library/modules/_export.js"); // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)


        $export($export.S + $export.F * !__webpack_require__(
        /*! ./_descriptors */
        "../../node_modules/core-js/library/modules/_descriptors.js"), 'Object', {
          defineProperty: __webpack_require__(
          /*! ./_object-dp */
          "../../node_modules/core-js/library/modules/_object-dp.js").f
        });
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/es6.object.get-prototype-of.js":
      /*!**********************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/es6.object.get-prototype-of.js ***!
        \**********************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6ObjectGetPrototypeOfJs(module, exports, __webpack_require__) {
        // 19.1.2.9 Object.getPrototypeOf(O)
        var toObject = __webpack_require__(
        /*! ./_to-object */
        "../../node_modules/core-js/library/modules/_to-object.js");

        var $getPrototypeOf = __webpack_require__(
        /*! ./_object-gpo */
        "../../node_modules/core-js/library/modules/_object-gpo.js");

        __webpack_require__(
        /*! ./_object-sap */
        "../../node_modules/core-js/library/modules/_object-sap.js")('getPrototypeOf', function () {
          return function getPrototypeOf(it) {
            return $getPrototypeOf(toObject(it));
          };
        });
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/es6.object.set-prototype-of.js":
      /*!**********************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/es6.object.set-prototype-of.js ***!
        \**********************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6ObjectSetPrototypeOfJs(module, exports, __webpack_require__) {
        // 19.1.3.19 Object.setPrototypeOf(O, proto)
        var $export = __webpack_require__(
        /*! ./_export */
        "../../node_modules/core-js/library/modules/_export.js");

        $export($export.S, 'Object', {
          setPrototypeOf: __webpack_require__(
          /*! ./_set-proto */
          "../../node_modules/core-js/library/modules/_set-proto.js").set
        });
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/es6.object.to-string.js":
      /*!***************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/es6.object.to-string.js ***!
        \***************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6ObjectToStringJs(module, exports) {
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/es6.promise.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/es6.promise.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6PromiseJs(module, exports, __webpack_require__) {
        "use strict";

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "../../node_modules/core-js/library/modules/_library.js");

        var global = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js");

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "../../node_modules/core-js/library/modules/_ctx.js");

        var classof = __webpack_require__(
        /*! ./_classof */
        "../../node_modules/core-js/library/modules/_classof.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "../../node_modules/core-js/library/modules/_export.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../../node_modules/core-js/library/modules/_is-object.js");

        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "../../node_modules/core-js/library/modules/_a-function.js");

        var anInstance = __webpack_require__(
        /*! ./_an-instance */
        "../../node_modules/core-js/library/modules/_an-instance.js");

        var forOf = __webpack_require__(
        /*! ./_for-of */
        "../../node_modules/core-js/library/modules/_for-of.js");

        var speciesConstructor = __webpack_require__(
        /*! ./_species-constructor */
        "../../node_modules/core-js/library/modules/_species-constructor.js");

        var task = __webpack_require__(
        /*! ./_task */
        "../../node_modules/core-js/library/modules/_task.js").set;

        var microtask = __webpack_require__(
        /*! ./_microtask */
        "../../node_modules/core-js/library/modules/_microtask.js")();

        var newPromiseCapabilityModule = __webpack_require__(
        /*! ./_new-promise-capability */
        "../../node_modules/core-js/library/modules/_new-promise-capability.js");

        var perform = __webpack_require__(
        /*! ./_perform */
        "../../node_modules/core-js/library/modules/_perform.js");

        var userAgent = __webpack_require__(
        /*! ./_user-agent */
        "../../node_modules/core-js/library/modules/_user-agent.js");

        var promiseResolve = __webpack_require__(
        /*! ./_promise-resolve */
        "../../node_modules/core-js/library/modules/_promise-resolve.js");

        var PROMISE = 'Promise';
        var TypeError = global.TypeError;
        var process = global.process;
        var versions = process && process.versions;
        var v8 = versions && versions.v8 || '';
        var $Promise = global[PROMISE];
        var isNode = classof(process) == 'process';

        var empty = function empty() {
          /* empty */
        };

        var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
        var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
        var USE_NATIVE = !!function () {
          try {
            // correct subclassing with @@species support
            var promise = $Promise.resolve(1);

            var FakePromise = (promise.constructor = {})[__webpack_require__(
            /*! ./_wks */
            "../../node_modules/core-js/library/modules/_wks.js")('species')] = function (exec) {
              exec(empty, empty);
            }; // unhandled rejections tracking support, NodeJS Promise without it fails @@species test


            return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
            // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
            // we can't detect it synchronously, so just check versions
            && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
          } catch (e) {
            /* empty */
          }
        }(); // helpers

        var isThenable = function isThenable(it) {
          var then;
          return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
        };

        var notify = function notify(promise, isReject) {
          if (promise._n) return;
          promise._n = true;
          var chain = promise._c;
          microtask(function () {
            var value = promise._v;
            var ok = promise._s == 1;
            var i = 0;

            var run = function run(reaction) {
              var handler = ok ? reaction.ok : reaction.fail;
              var resolve = reaction.resolve;
              var reject = reaction.reject;
              var domain = reaction.domain;
              var result, then, exited;

              try {
                if (handler) {
                  if (!ok) {
                    if (promise._h == 2) onHandleUnhandled(promise);
                    promise._h = 1;
                  }

                  if (handler === true) result = value;else {
                    if (domain) domain.enter();
                    result = handler(value); // may throw

                    if (domain) {
                      domain.exit();
                      exited = true;
                    }
                  }

                  if (result === reaction.promise) {
                    reject(TypeError('Promise-chain cycle'));
                  } else if (then = isThenable(result)) {
                    then.call(result, resolve, reject);
                  } else resolve(result);
                } else reject(value);
              } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
              }
            };

            while (chain.length > i) {
              run(chain[i++]);
            } // variable length - can't use forEach


            promise._c = [];
            promise._n = false;
            if (isReject && !promise._h) onUnhandled(promise);
          });
        };

        var onUnhandled = function onUnhandled(promise) {
          task.call(global, function () {
            var value = promise._v;
            var unhandled = isUnhandled(promise);
            var result, handler, console;

            if (unhandled) {
              result = perform(function () {
                if (isNode) {
                  process.emit('unhandledRejection', value, promise);
                } else if (handler = global.onunhandledrejection) {
                  handler({
                    promise: promise,
                    reason: value
                  });
                } else if ((console = global.console) && console.error) {
                  console.error('Unhandled promise rejection', value);
                }
              }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

              promise._h = isNode || isUnhandled(promise) ? 2 : 1;
            }

            promise._a = undefined;
            if (unhandled && result.e) throw result.v;
          });
        };

        var isUnhandled = function isUnhandled(promise) {
          return promise._h !== 1 && (promise._a || promise._c).length === 0;
        };

        var onHandleUnhandled = function onHandleUnhandled(promise) {
          task.call(global, function () {
            var handler;

            if (isNode) {
              process.emit('rejectionHandled', promise);
            } else if (handler = global.onrejectionhandled) {
              handler({
                promise: promise,
                reason: promise._v
              });
            }
          });
        };

        var $reject = function $reject(value) {
          var promise = this;
          if (promise._d) return;
          promise._d = true;
          promise = promise._w || promise; // unwrap

          promise._v = value;
          promise._s = 2;
          if (!promise._a) promise._a = promise._c.slice();
          notify(promise, true);
        };

        var $resolve = function $resolve(value) {
          var promise = this;
          var then;
          if (promise._d) return;
          promise._d = true;
          promise = promise._w || promise; // unwrap

          try {
            if (promise === value) throw TypeError("Promise can't be resolved itself");

            if (then = isThenable(value)) {
              microtask(function () {
                var wrapper = {
                  _w: promise,
                  _d: false
                }; // wrap

                try {
                  then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
                } catch (e) {
                  $reject.call(wrapper, e);
                }
              });
            } else {
              promise._v = value;
              promise._s = 1;
              notify(promise, false);
            }
          } catch (e) {
            $reject.call({
              _w: promise,
              _d: false
            }, e); // wrap
          }
        }; // constructor polyfill


        if (!USE_NATIVE) {
          // 25.4.3.1 Promise(executor)
          $Promise = function Promise(executor) {
            anInstance(this, $Promise, PROMISE, '_h');
            aFunction(executor);
            Internal.call(this);

            try {
              executor(ctx($resolve, this, 1), ctx($reject, this, 1));
            } catch (err) {
              $reject.call(this, err);
            }
          }; // eslint-disable-next-line no-unused-vars


          Internal = function Promise(executor) {
            this._c = []; // <- awaiting reactions

            this._a = undefined; // <- checked in isUnhandled reactions

            this._s = 0; // <- state

            this._d = false; // <- done

            this._v = undefined; // <- value

            this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled

            this._n = false; // <- notify
          };

          Internal.prototype = __webpack_require__(
          /*! ./_redefine-all */
          "../../node_modules/core-js/library/modules/_redefine-all.js")($Promise.prototype, {
            // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
            then: function then(onFulfilled, onRejected) {
              var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
              reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
              reaction.fail = typeof onRejected == 'function' && onRejected;
              reaction.domain = isNode ? process.domain : undefined;

              this._c.push(reaction);

              if (this._a) this._a.push(reaction);
              if (this._s) notify(this, false);
              return reaction.promise;
            },
            // 25.4.5.1 Promise.prototype.catch(onRejected)
            'catch': function _catch(onRejected) {
              return this.then(undefined, onRejected);
            }
          });

          OwnPromiseCapability = function OwnPromiseCapability() {
            var promise = new Internal();
            this.promise = promise;
            this.resolve = ctx($resolve, promise, 1);
            this.reject = ctx($reject, promise, 1);
          };

          newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
            return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
          };
        }

        $export($export.G + $export.W + $export.F * !USE_NATIVE, {
          Promise: $Promise
        });

        __webpack_require__(
        /*! ./_set-to-string-tag */
        "../../node_modules/core-js/library/modules/_set-to-string-tag.js")($Promise, PROMISE);

        __webpack_require__(
        /*! ./_set-species */
        "../../node_modules/core-js/library/modules/_set-species.js")(PROMISE);

        Wrapper = __webpack_require__(
        /*! ./_core */
        "../../node_modules/core-js/library/modules/_core.js")[PROMISE]; // statics

        $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
          // 25.4.4.5 Promise.reject(r)
          reject: function reject(r) {
            var capability = newPromiseCapability(this);
            var $$reject = capability.reject;
            $$reject(r);
            return capability.promise;
          }
        });
        $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
          // 25.4.4.6 Promise.resolve(x)
          resolve: function resolve(x) {
            return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
          }
        });
        $export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(
        /*! ./_iter-detect */
        "../../node_modules/core-js/library/modules/_iter-detect.js")(function (iter) {
          $Promise.all(iter)['catch'](empty);
        })), PROMISE, {
          // 25.4.4.1 Promise.all(iterable)
          all: function all(iterable) {
            var C = this;
            var capability = newPromiseCapability(C);
            var resolve = capability.resolve;
            var reject = capability.reject;
            var result = perform(function () {
              var values = [];
              var index = 0;
              var remaining = 1;
              forOf(iterable, false, function (promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function (value) {
                  if (alreadyCalled) return;
                  alreadyCalled = true;
                  values[$index] = value;
                  --remaining || resolve(values);
                }, reject);
              });
              --remaining || resolve(values);
            });
            if (result.e) reject(result.v);
            return capability.promise;
          },
          // 25.4.4.4 Promise.race(iterable)
          race: function race(iterable) {
            var C = this;
            var capability = newPromiseCapability(C);
            var reject = capability.reject;
            var result = perform(function () {
              forOf(iterable, false, function (promise) {
                C.resolve(promise).then(capability.resolve, reject);
              });
            });
            if (result.e) reject(result.v);
            return capability.promise;
          }
        });
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/es6.string.iterator.js":
      /*!**************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/es6.string.iterator.js ***!
        \**************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6StringIteratorJs(module, exports, __webpack_require__) {
        "use strict";

        var $at = __webpack_require__(
        /*! ./_string-at */
        "../../node_modules/core-js/library/modules/_string-at.js")(true); // 21.1.3.27 String.prototype[@@iterator]()


        __webpack_require__(
        /*! ./_iter-define */
        "../../node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function (iterated) {
          this._t = String(iterated); // target

          this._i = 0; // next index
          // 21.1.5.2.1 %StringIteratorPrototype%.next()
        }, function () {
          var O = this._t;
          var index = this._i;
          var point;
          if (index >= O.length) return {
            value: undefined,
            done: true
          };
          point = $at(O, index);
          this._i += point.length;
          return {
            value: point,
            done: false
          };
        });
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/es6.symbol.js":
      /*!*****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/es6.symbol.js ***!
        \*****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs6SymbolJs(module, exports, __webpack_require__) {
        "use strict"; // ECMAScript 6 symbols shim

        var global = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js");

        var has = __webpack_require__(
        /*! ./_has */
        "../../node_modules/core-js/library/modules/_has.js");

        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "../../node_modules/core-js/library/modules/_descriptors.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "../../node_modules/core-js/library/modules/_export.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "../../node_modules/core-js/library/modules/_redefine.js");

        var META = __webpack_require__(
        /*! ./_meta */
        "../../node_modules/core-js/library/modules/_meta.js").KEY;

        var $fails = __webpack_require__(
        /*! ./_fails */
        "../../node_modules/core-js/library/modules/_fails.js");

        var shared = __webpack_require__(
        /*! ./_shared */
        "../../node_modules/core-js/library/modules/_shared.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "../../node_modules/core-js/library/modules/_set-to-string-tag.js");

        var uid = __webpack_require__(
        /*! ./_uid */
        "../../node_modules/core-js/library/modules/_uid.js");

        var wks = __webpack_require__(
        /*! ./_wks */
        "../../node_modules/core-js/library/modules/_wks.js");

        var wksExt = __webpack_require__(
        /*! ./_wks-ext */
        "../../node_modules/core-js/library/modules/_wks-ext.js");

        var wksDefine = __webpack_require__(
        /*! ./_wks-define */
        "../../node_modules/core-js/library/modules/_wks-define.js");

        var enumKeys = __webpack_require__(
        /*! ./_enum-keys */
        "../../node_modules/core-js/library/modules/_enum-keys.js");

        var isArray = __webpack_require__(
        /*! ./_is-array */
        "../../node_modules/core-js/library/modules/_is-array.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../../node_modules/core-js/library/modules/_an-object.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../../node_modules/core-js/library/modules/_is-object.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "../../node_modules/core-js/library/modules/_to-object.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "../../node_modules/core-js/library/modules/_to-iobject.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "../../node_modules/core-js/library/modules/_to-primitive.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "../../node_modules/core-js/library/modules/_property-desc.js");

        var _create = __webpack_require__(
        /*! ./_object-create */
        "../../node_modules/core-js/library/modules/_object-create.js");

        var gOPNExt = __webpack_require__(
        /*! ./_object-gopn-ext */
        "../../node_modules/core-js/library/modules/_object-gopn-ext.js");

        var $GOPD = __webpack_require__(
        /*! ./_object-gopd */
        "../../node_modules/core-js/library/modules/_object-gopd.js");

        var $GOPS = __webpack_require__(
        /*! ./_object-gops */
        "../../node_modules/core-js/library/modules/_object-gops.js");

        var $DP = __webpack_require__(
        /*! ./_object-dp */
        "../../node_modules/core-js/library/modules/_object-dp.js");

        var $keys = __webpack_require__(
        /*! ./_object-keys */
        "../../node_modules/core-js/library/modules/_object-keys.js");

        var gOPD = $GOPD.f;
        var dP = $DP.f;
        var gOPN = gOPNExt.f;
        var $Symbol = global.Symbol;
        var $JSON = global.JSON;

        var _stringify = $JSON && $JSON.stringify;

        var PROTOTYPE = 'prototype';
        var HIDDEN = wks('_hidden');
        var TO_PRIMITIVE = wks('toPrimitive');
        var isEnum = {}.propertyIsEnumerable;
        var SymbolRegistry = shared('symbol-registry');
        var AllSymbols = shared('symbols');
        var OPSymbols = shared('op-symbols');
        var ObjectProto = Object[PROTOTYPE];
        var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
        var QObject = global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

        var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

        var setSymbolDesc = DESCRIPTORS && $fails(function () {
          return _create(dP({}, 'a', {
            get: function get() {
              return dP(this, 'a', {
                value: 7
              }).a;
            }
          })).a != 7;
        }) ? function (it, key, D) {
          var protoDesc = gOPD(ObjectProto, key);
          if (protoDesc) delete ObjectProto[key];
          dP(it, key, D);
          if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
        } : dP;

        var wrap = function wrap(tag) {
          var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);

          sym._k = tag;
          return sym;
        };

        var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
          return typeof it == 'symbol';
        } : function (it) {
          return it instanceof $Symbol;
        };

        var $defineProperty = function defineProperty(it, key, D) {
          if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
          anObject(it);
          key = toPrimitive(key, true);
          anObject(D);

          if (has(AllSymbols, key)) {
            if (!D.enumerable) {
              if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
              it[HIDDEN][key] = true;
            } else {
              if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
              D = _create(D, {
                enumerable: createDesc(0, false)
              });
            }

            return setSymbolDesc(it, key, D);
          }

          return dP(it, key, D);
        };

        var $defineProperties = function defineProperties(it, P) {
          anObject(it);
          var keys = enumKeys(P = toIObject(P));
          var i = 0;
          var l = keys.length;
          var key;

          while (l > i) {
            $defineProperty(it, key = keys[i++], P[key]);
          }

          return it;
        };

        var $create = function create(it, P) {
          return P === undefined ? _create(it) : $defineProperties(_create(it), P);
        };

        var $propertyIsEnumerable = function propertyIsEnumerable(key) {
          var E = isEnum.call(this, key = toPrimitive(key, true));
          if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
          return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
        };

        var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
          it = toIObject(it);
          key = toPrimitive(key, true);
          if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
          var D = gOPD(it, key);
          if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
          return D;
        };

        var $getOwnPropertyNames = function getOwnPropertyNames(it) {
          var names = gOPN(toIObject(it));
          var result = [];
          var i = 0;
          var key;

          while (names.length > i) {
            if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
          }

          return result;
        };

        var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
          var IS_OP = it === ObjectProto;
          var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
          var result = [];
          var i = 0;
          var key;

          while (names.length > i) {
            if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
          }

          return result;
        }; // 19.4.1.1 Symbol([description])


        if (!USE_NATIVE) {
          $Symbol = function Symbol() {
            if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
            var tag = uid(arguments.length > 0 ? arguments[0] : undefined);

            var $set = function $set(value) {
              if (this === ObjectProto) $set.call(OPSymbols, value);
              if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
              setSymbolDesc(this, tag, createDesc(1, value));
            };

            if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
              configurable: true,
              set: $set
            });
            return wrap(tag);
          };

          redefine($Symbol[PROTOTYPE], 'toString', function toString() {
            return this._k;
          });
          $GOPD.f = $getOwnPropertyDescriptor;
          $DP.f = $defineProperty;
          __webpack_require__(
          /*! ./_object-gopn */
          "../../node_modules/core-js/library/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
          __webpack_require__(
          /*! ./_object-pie */
          "../../node_modules/core-js/library/modules/_object-pie.js").f = $propertyIsEnumerable;
          $GOPS.f = $getOwnPropertySymbols;

          if (DESCRIPTORS && !__webpack_require__(
          /*! ./_library */
          "../../node_modules/core-js/library/modules/_library.js")) {
            redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
          }

          wksExt.f = function (name) {
            return wrap(wks(name));
          };
        }

        $export($export.G + $export.W + $export.F * !USE_NATIVE, {
          Symbol: $Symbol
        });

        for (var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
        'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
          wks(es6Symbols[j++]);
        }

        for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
          wksDefine(wellKnownSymbols[k++]);
        }

        $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
          // 19.4.2.1 Symbol.for(key)
          'for': function _for(key) {
            return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
          },
          // 19.4.2.5 Symbol.keyFor(sym)
          keyFor: function keyFor(sym) {
            if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');

            for (var key in SymbolRegistry) {
              if (SymbolRegistry[key] === sym) return key;
            }
          },
          useSetter: function useSetter() {
            setter = true;
          },
          useSimple: function useSimple() {
            setter = false;
          }
        });
        $export($export.S + $export.F * !USE_NATIVE, 'Object', {
          // 19.1.2.2 Object.create(O [, Properties])
          create: $create,
          // 19.1.2.4 Object.defineProperty(O, P, Attributes)
          defineProperty: $defineProperty,
          // 19.1.2.3 Object.defineProperties(O, Properties)
          defineProperties: $defineProperties,
          // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
          getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
          // 19.1.2.7 Object.getOwnPropertyNames(O)
          getOwnPropertyNames: $getOwnPropertyNames,
          // 19.1.2.8 Object.getOwnPropertySymbols(O)
          getOwnPropertySymbols: $getOwnPropertySymbols
        }); // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
        // https://bugs.chromium.org/p/v8/issues/detail?id=3443

        var FAILS_ON_PRIMITIVES = $fails(function () {
          $GOPS.f(1);
        });
        $export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
          getOwnPropertySymbols: function getOwnPropertySymbols(it) {
            return $GOPS.f(toObject(it));
          }
        }); // 24.3.2 JSON.stringify(value [, replacer [, space]])

        $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
          var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
          // WebKit converts symbol values to JSON as null
          // V8 throws on boxed symbols

          return _stringify([S]) != '[null]' || _stringify({
            a: S
          }) != '{}' || _stringify(Object(S)) != '{}';
        })), 'JSON', {
          stringify: function stringify(it) {
            var args = [it];
            var i = 1;
            var replacer, $replacer;

            while (arguments.length > i) {
              args.push(arguments[i++]);
            }

            $replacer = replacer = args[1];
            if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

            if (!isArray(replacer)) replacer = function replacer(key, value) {
              if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
              if (!isSymbol(value)) return value;
            };
            args[1] = replacer;
            return _stringify.apply($JSON, args);
          }
        }); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

        $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(
        /*! ./_hide */
        "../../node_modules/core-js/library/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

        setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]

        setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]

        setToStringTag(global.JSON, 'JSON', true);
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/es7.promise.finally.js":
      /*!**************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/es7.promise.finally.js ***!
        \**************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs7PromiseFinallyJs(module, exports, __webpack_require__) {
        "use strict"; // https://github.com/tc39/proposal-promise-finally

        var $export = __webpack_require__(
        /*! ./_export */
        "../../node_modules/core-js/library/modules/_export.js");

        var core = __webpack_require__(
        /*! ./_core */
        "../../node_modules/core-js/library/modules/_core.js");

        var global = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js");

        var speciesConstructor = __webpack_require__(
        /*! ./_species-constructor */
        "../../node_modules/core-js/library/modules/_species-constructor.js");

        var promiseResolve = __webpack_require__(
        /*! ./_promise-resolve */
        "../../node_modules/core-js/library/modules/_promise-resolve.js");

        $export($export.P + $export.R, 'Promise', {
          'finally': function _finally(onFinally) {
            var C = speciesConstructor(this, core.Promise || global.Promise);
            var isFunction = typeof onFinally == 'function';
            return this.then(isFunction ? function (x) {
              return promiseResolve(C, onFinally()).then(function () {
                return x;
              });
            } : onFinally, isFunction ? function (e) {
              return promiseResolve(C, onFinally()).then(function () {
                throw e;
              });
            } : onFinally);
          }
        });
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/es7.promise.try.js":
      /*!**********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/es7.promise.try.js ***!
        \**********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs7PromiseTryJs(module, exports, __webpack_require__) {
        "use strict"; // https://github.com/tc39/proposal-promise-try

        var $export = __webpack_require__(
        /*! ./_export */
        "../../node_modules/core-js/library/modules/_export.js");

        var newPromiseCapability = __webpack_require__(
        /*! ./_new-promise-capability */
        "../../node_modules/core-js/library/modules/_new-promise-capability.js");

        var perform = __webpack_require__(
        /*! ./_perform */
        "../../node_modules/core-js/library/modules/_perform.js");

        $export($export.S, 'Promise', {
          'try': function _try(callbackfn) {
            var promiseCapability = newPromiseCapability.f(this);
            var result = perform(callbackfn);
            (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
            return promiseCapability.promise;
          }
        });
        /***/
      },

      /***/
      "../../node_modules/core-js/library/modules/es7.symbol.async-iterator.js":
      /*!********************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/es7.symbol.async-iterator.js ***!
        \********************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs7SymbolAsyncIteratorJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ./_wks-define */
        "../../node_modules/core-js/library/modules/_wks-define.js")('asyncIterator');
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/es7.symbol.observable.js":
      /*!****************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/es7.symbol.observable.js ***!
        \****************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesEs7SymbolObservableJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ./_wks-define */
        "../../node_modules/core-js/library/modules/_wks-define.js")('observable');
        /***/

      },

      /***/
      "../../node_modules/core-js/library/modules/web.dom.iterable.js":
      /*!***********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/core-js/library/modules/web.dom.iterable.js ***!
        \***********************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsLibraryModulesWebDomIterableJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ./es6.array.iterator */
        "../../node_modules/core-js/library/modules/es6.array.iterator.js");

        var global = __webpack_require__(
        /*! ./_global */
        "../../node_modules/core-js/library/modules/_global.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "../../node_modules/core-js/library/modules/_hide.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "../../node_modules/core-js/library/modules/_iterators.js");

        var TO_STRING_TAG = __webpack_require__(
        /*! ./_wks */
        "../../node_modules/core-js/library/modules/_wks.js")('toStringTag');

        var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

        for (var i = 0; i < DOMIterables.length; i++) {
          var NAME = DOMIterables[i];
          var Collection = global[NAME];
          var proto = Collection && Collection.prototype;
          if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
          Iterators[NAME] = Iterators.Array;
        }
        /***/

      },

      /***/
      "../../node_modules/eth-block-tracker-es5/dist/hexUtils.js":
      /*!******************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/eth-block-tracker-es5/dist/hexUtils.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesEthBlockTrackerEs5DistHexUtilsJs(module, exports, __webpack_require__) {
        "use strict";

        var ethjsUtil = __webpack_require__(
        /*! ethjs-util */
        "../../node_modules/ethjs-util/lib/index.js");

        module.exports = {
          incrementHexNumber: incrementHexNumber,
          formatHex: formatHex
        };

        function incrementHexNumber(hexNum) {
          return formatHex(ethjsUtil.intToHex(parseInt(hexNum, 16) + 1));
        }

        function formatHex(hexNum) {
          var stripped = ethjsUtil.stripHexPrefix(hexNum);

          while (stripped[0] === '0') {
            stripped = stripped.substr(1);
          }

          return '0x' + stripped;
        }
        /***/

      },

      /***/
      "../../node_modules/eth-block-tracker-es5/dist/index.js":
      /*!***************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/eth-block-tracker-es5/dist/index.js ***!
        \***************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesEthBlockTrackerEs5DistIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var _regenerator = __webpack_require__(
        /*! babel-runtime/regenerator */
        "../../node_modules/babel-runtime/regenerator/index.js");

        var _regenerator2 = _interopRequireDefault(_regenerator);

        var _promise = __webpack_require__(
        /*! babel-runtime/core-js/promise */
        "../../node_modules/babel-runtime/core-js/promise.js");

        var _promise2 = _interopRequireDefault(_promise);

        var _asyncToGenerator2 = __webpack_require__(
        /*! babel-runtime/helpers/asyncToGenerator */
        "../../node_modules/babel-runtime/helpers/asyncToGenerator.js");

        var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

        var _getPrototypeOf = __webpack_require__(
        /*! babel-runtime/core-js/object/get-prototype-of */
        "../../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

        var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

        var _classCallCheck2 = __webpack_require__(
        /*! babel-runtime/helpers/classCallCheck */
        "../../node_modules/babel-runtime/helpers/classCallCheck.js");

        var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

        var _createClass2 = __webpack_require__(
        /*! babel-runtime/helpers/createClass */
        "../../node_modules/babel-runtime/helpers/createClass.js");

        var _createClass3 = _interopRequireDefault(_createClass2);

        var _possibleConstructorReturn2 = __webpack_require__(
        /*! babel-runtime/helpers/possibleConstructorReturn */
        "../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

        var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

        var _inherits2 = __webpack_require__(
        /*! babel-runtime/helpers/inherits */
        "../../node_modules/babel-runtime/helpers/inherits.js");

        var _inherits3 = _interopRequireDefault(_inherits2);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        } // const EthQuery = require('ethjs-query')


        var EthQuery = __webpack_require__(
        /*! eth-query */
        "../../node_modules/eth-query/index.js");

        var AsyncEventEmitter = __webpack_require__(
        /*! async-eventemitter */
        "../../node_modules/async-eventemitter/index.js");

        var pify = __webpack_require__(
        /*! pify */
        "../../node_modules/eth-block-tracker-es5/node_modules/pify/index.js");

        var hexUtils = __webpack_require__(
        /*! ./hexUtils */
        "../../node_modules/eth-block-tracker-es5/dist/hexUtils.js");

        var incrementHexNumber = hexUtils.incrementHexNumber;

        var RpcBlockTracker = function (_AsyncEventEmitter) {
          (0, _inherits3.default)(RpcBlockTracker, _AsyncEventEmitter);

          function RpcBlockTracker() {
            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            (0, _classCallCheck3.default)(this, RpcBlockTracker);

            var _this = (0, _possibleConstructorReturn3.default)(this, (RpcBlockTracker.__proto__ || (0, _getPrototypeOf2.default)(RpcBlockTracker)).call(this));

            if (!opts.provider) throw new Error('RpcBlockTracker - no provider specified.');
            _this._provider = opts.provider;
            _this._query = new EthQuery(opts.provider); // config

            _this._pollingInterval = opts.pollingInterval || 4e3; // 4 sec

            _this._syncingTimeout = opts.syncingTimeout || 60 * 1e3; // 1 min
            // state

            _this._trackingBlock = null;
            _this._trackingBlockTimestamp = null;
            _this._currentBlock = null;
            _this._isRunning = false; // bind methods for cleaner syntax later

            _this.emit = _this.emit.bind(_this);
            _this._performSync = _this._performSync.bind(_this);
            _this._handleNewBlockNotification = _this._handleNewBlockNotification.bind(_this);
            return _this;
          }

          (0, _createClass3.default)(RpcBlockTracker, [{
            key: 'getTrackingBlock',
            value: function getTrackingBlock() {
              return this._trackingBlock;
            }
          }, {
            key: 'getCurrentBlock',
            value: function getCurrentBlock() {
              return this._currentBlock;
            }
          }, {
            key: 'awaitCurrentBlock',
            value: function () {
              var _ref = (0, _asyncToGenerator3.default)(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee() {
                var _this2 = this;

                return _regenerator2.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!this._currentBlock) {
                          _context.next = 2;
                          break;
                        }

                        return _context.abrupt('return', this._currentBlock);

                      case 2:
                        _context.next = 4;
                        return new _promise2.default(function (resolve) {
                          return _this2.once('sync', resolve);
                        });

                      case 4:
                        return _context.abrupt('return', this._currentBlock);

                      case 5:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              }));

              function awaitCurrentBlock() {
                return _ref.apply(this, arguments);
              }

              return awaitCurrentBlock;
            }()
          }, {
            key: 'start',
            value: function () {
              var _ref2 = (0, _asyncToGenerator3.default)(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee2() {
                var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!this._isRunning) {
                          _context2.next = 2;
                          break;
                        }

                        return _context2.abrupt('return');

                      case 2:
                        this._isRunning = true; // if this._currentBlock

                        if (!opts.fromBlock) {
                          _context2.next = 12;
                          break;
                        }

                        _context2.t0 = this;
                        _context2.next = 7;
                        return this._fetchBlockByNumber(opts.fromBlock);

                      case 7:
                        _context2.t1 = _context2.sent;
                        _context2.next = 10;
                        return _context2.t0._setTrackingBlock.call(_context2.t0, _context2.t1);

                      case 10:
                        _context2.next = 18;
                        break;

                      case 12:
                        _context2.t2 = this;
                        _context2.next = 15;
                        return this._fetchLatestBlock();

                      case 15:
                        _context2.t3 = _context2.sent;
                        _context2.next = 18;
                        return _context2.t2._setTrackingBlock.call(_context2.t2, _context2.t3);

                      case 18:
                        if (!this._provider.on) {
                          _context2.next = 23;
                          break;
                        }

                        _context2.next = 21;
                        return this._initSubscription();

                      case 21:
                        _context2.next = 24;
                        break;

                      case 23:
                        this._performSync().catch(function (err) {
                          if (err) console.error(err);
                        });

                      case 24:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, this);
              }));

              function start() {
                return _ref2.apply(this, arguments);
              }

              return start;
            }()
          }, {
            key: 'stop',
            value: function () {
              var _ref3 = (0, _asyncToGenerator3.default)(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        this._isRunning = false;

                        if (!this._provider.on) {
                          _context3.next = 4;
                          break;
                        }

                        _context3.next = 4;
                        return this._removeSubscription();

                      case 4:
                      case 'end':
                        return _context3.stop();
                    }
                  }
                }, _callee3, this);
              }));

              function stop() {
                return _ref3.apply(this, arguments);
              }

              return stop;
            }() //
            // private
            //

          }, {
            key: '_setTrackingBlock',
            value: function () {
              var _ref4 = (0, _asyncToGenerator3.default)(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee4(newBlock) {
                var previous, now;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!(this._trackingBlock && this._trackingBlock.hash === newBlock.hash)) {
                          _context4.next = 2;
                          break;
                        }

                        return _context4.abrupt('return');

                      case 2:
                        // check for large timestamp lapse
                        previous = this._trackingBlockTimestamp;
                        now = Date.now(); // check for desynchronization (computer sleep or no internet)

                        if (!(previous && now - previous > this._syncingTimeout)) {
                          _context4.next = 10;
                          break;
                        }

                        this._trackingBlockTimestamp = null;
                        _context4.next = 8;
                        return this._warpToLatest();

                      case 8:
                        _context4.next = 14;
                        break;

                      case 10:
                        this._trackingBlock = newBlock;
                        this._trackingBlockTimestamp = now;
                        _context4.next = 14;
                        return pify(this.emit)('block', newBlock);

                      case 14:
                      case 'end':
                        return _context4.stop();
                    }
                  }
                }, _callee4, this);
              }));

              function _setTrackingBlock(_x3) {
                return _ref4.apply(this, arguments);
              }

              return _setTrackingBlock;
            }()
          }, {
            key: '_setCurrentBlock',
            value: function () {
              var _ref5 = (0, _asyncToGenerator3.default)(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee5(newBlock) {
                var oldBlock;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!(this._currentBlock && this._currentBlock.hash === newBlock.hash)) {
                          _context5.next = 2;
                          break;
                        }

                        return _context5.abrupt('return');

                      case 2:
                        oldBlock = this._currentBlock;
                        this._currentBlock = newBlock;
                        _context5.next = 6;
                        return pify(this.emit)('latest', newBlock);

                      case 6:
                        _context5.next = 8;
                        return pify(this.emit)('sync', {
                          newBlock: newBlock,
                          oldBlock: oldBlock
                        });

                      case 8:
                      case 'end':
                        return _context5.stop();
                    }
                  }
                }, _callee5, this);
              }));

              function _setCurrentBlock(_x4) {
                return _ref5.apply(this, arguments);
              }

              return _setCurrentBlock;
            }()
          }, {
            key: '_warpToLatest',
            value: function () {
              var _ref6 = (0, _asyncToGenerator3.default)(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee6() {
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.t0 = this;
                        _context6.next = 3;
                        return this._fetchLatestBlock();

                      case 3:
                        _context6.t1 = _context6.sent;
                        _context6.next = 6;
                        return _context6.t0._setTrackingBlock.call(_context6.t0, _context6.t1);

                      case 6:
                      case 'end':
                        return _context6.stop();
                    }
                  }
                }, _callee6, this);
              }));

              function _warpToLatest() {
                return _ref6.apply(this, arguments);
              }

              return _warpToLatest;
            }()
          }, {
            key: '_pollForNextBlock',
            value: function () {
              var _ref7 = (0, _asyncToGenerator3.default)(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee7() {
                var _this3 = this;

                return _regenerator2.default.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        setTimeout(function () {
                          return _this3._performSync();
                        }, this._pollingInterval);

                      case 1:
                      case 'end':
                        return _context7.stop();
                    }
                  }
                }, _callee7, this);
              }));

              function _pollForNextBlock() {
                return _ref7.apply(this, arguments);
              }

              return _pollForNextBlock;
            }()
          }, {
            key: '_performSync',
            value: function () {
              var _ref8 = (0, _asyncToGenerator3.default)(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee8() {
                var trackingBlock, nextNumber, newBlock;
                return _regenerator2.default.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        if (this._isRunning) {
                          _context8.next = 2;
                          break;
                        }

                        return _context8.abrupt('return');

                      case 2:
                        trackingBlock = this.getTrackingBlock();

                        if (trackingBlock) {
                          _context8.next = 5;
                          break;
                        }

                        throw new Error('RpcBlockTracker - tracking block is missing');

                      case 5:
                        nextNumber = incrementHexNumber(trackingBlock.number);
                        _context8.prev = 6;
                        _context8.next = 9;
                        return this._fetchBlockByNumber(nextNumber);

                      case 9:
                        newBlock = _context8.sent;

                        if (!newBlock) {
                          _context8.next = 16;
                          break;
                        }

                        _context8.next = 13;
                        return this._setTrackingBlock(newBlock);

                      case 13:
                        // ask for next block
                        this._performSync();

                        _context8.next = 19;
                        break;

                      case 16:
                        _context8.next = 18;
                        return this._setCurrentBlock(trackingBlock);

                      case 18:
                        // setup poll for next block
                        this._pollForNextBlock();

                      case 19:
                        _context8.next = 31;
                        break;

                      case 21:
                        _context8.prev = 21;
                        _context8.t0 = _context8['catch'](6);

                        if (!(_context8.t0.message.includes('index out of range') || _context8.t0.message.includes("Couldn't find block by reference"))) {
                          _context8.next = 29;
                          break;
                        }

                        _context8.next = 26;
                        return this._setCurrentBlock(trackingBlock);

                      case 26:
                        // setup poll for next block
                        this._pollForNextBlock();

                        _context8.next = 31;
                        break;

                      case 29:
                        console.error(_context8.t0);

                        this._pollForNextBlock();

                      case 31:
                      case 'end':
                        return _context8.stop();
                    }
                  }
                }, _callee8, this, [[6, 21]]);
              }));

              function _performSync() {
                return _ref8.apply(this, arguments);
              }

              return _performSync;
            }()
          }, {
            key: '_handleNewBlockNotification',
            value: function () {
              var _ref9 = (0, _asyncToGenerator3.default)(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee9(err, notification) {
                return _regenerator2.default.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        if (!(notification.id != this._subscriptionId)) {
                          _context9.next = 2;
                          break;
                        }

                        return _context9.abrupt('return');

                      case 2:
                        if (!err) {
                          _context9.next = 7;
                          break;
                        }

                        _context9.next = 5;
                        return pify(this.emit)('error', err);

                      case 5:
                        _context9.next = 7;
                        return this._removeSubscription();

                      case 7:
                        _context9.t0 = this;
                        _context9.next = 10;
                        return this._fetchBlockByNumber(notification.result.number);

                      case 10:
                        _context9.t1 = _context9.sent;
                        _context9.next = 13;
                        return _context9.t0._setTrackingBlock.call(_context9.t0, _context9.t1);

                      case 13:
                      case 'end':
                        return _context9.stop();
                    }
                  }
                }, _callee9, this);
              }));

              function _handleNewBlockNotification(_x5, _x6) {
                return _ref9.apply(this, arguments);
              }

              return _handleNewBlockNotification;
            }()
          }, {
            key: '_initSubscription',
            value: function () {
              var _ref10 = (0, _asyncToGenerator3.default)(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee10() {
                var result;
                return _regenerator2.default.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        this._provider.on('data', this._handleNewBlockNotification);

                        _context10.next = 3;
                        return pify(this._provider.sendAsync || this._provider.send)({
                          jsonrpc: '2.0',
                          id: new Date().getTime(),
                          method: 'eth_subscribe',
                          params: ['newHeads']
                        });

                      case 3:
                        result = _context10.sent;
                        this._subscriptionId = result.result;

                      case 5:
                      case 'end':
                        return _context10.stop();
                    }
                  }
                }, _callee10, this);
              }));

              function _initSubscription() {
                return _ref10.apply(this, arguments);
              }

              return _initSubscription;
            }()
          }, {
            key: '_removeSubscription',
            value: function () {
              var _ref11 = (0, _asyncToGenerator3.default)(
              /*#__PURE__*/
              _regenerator2.default.mark(function _callee11() {
                return _regenerator2.default.wrap(function _callee11$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        if (this._subscriptionId) {
                          _context11.next = 2;
                          break;
                        }

                        throw new Error("Not subscribed.");

                      case 2:
                        this._provider.removeListener('data', this._handleNewBlockNotification);

                        _context11.next = 5;
                        return pify(this._provider.sendAsync || this._provider.send)({
                          jsonrpc: '2.0',
                          id: new Date().getTime(),
                          method: 'eth_unsubscribe',
                          params: [this._subscriptionId]
                        });

                      case 5:
                        delete this._subscriptionId;

                      case 6:
                      case 'end':
                        return _context11.stop();
                    }
                  }
                }, _callee11, this);
              }));

              function _removeSubscription() {
                return _ref11.apply(this, arguments);
              }

              return _removeSubscription;
            }()
          }, {
            key: '_fetchLatestBlock',
            value: function _fetchLatestBlock() {
              return pify(this._query.getBlockByNumber).call(this._query, 'latest', true);
            }
          }, {
            key: '_fetchBlockByNumber',
            value: function _fetchBlockByNumber(hexNumber) {
              var cleanHex = hexUtils.formatHex(hexNumber);
              return pify(this._query.getBlockByNumber).call(this._query, cleanHex, true);
            }
          }]);
          return RpcBlockTracker;
        }(AsyncEventEmitter);

        module.exports = RpcBlockTracker; // ├─ difficulty: 0x2892ddca
        // ├─ extraData: 0xd983010507846765746887676f312e372e348777696e646f7773
        // ├─ gasLimit: 0x47e7c4
        // ├─ gasUsed: 0x6384
        // ├─ hash: 0xf60903687b1559b9c80f2d935b4c4f468ad95c3076928c432ec34f2ef3d4eec9
        // ├─ logsBloom: 0x00000000000000000000000000000000000000000000000000000000000020000000000000000000000000040000000000000000000000000000000000000000000000000000000000000001000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000040000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000000000000000000
        // ├─ miner: 0x01711853335f857442ef6f349b2467c531731318
        // ├─ mixHash: 0xf0d9bec999600eec92e8e4da8fc1182e357468c9ed2f849aa17e0e900412b352
        // ├─ nonce: 0xd556d5a5504198e4
        // ├─ number: 0x72ac8
        // ├─ parentHash: 0xf5239c3ce1085194521435a5052494c02bbb1002b019684dcf368490ea6208e5
        // ├─ receiptsRoot: 0x78c6f8236094b392bcc43b47b0dc1ce93ecd2875bfb5e4e4c3431e5af698ff99
        // ├─ sha3Uncles: 0x1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347
        // ├─ size: 0x2ad
        // ├─ stateRoot: 0x0554f145c481df2fa02ecd2da17071672740c3aa948c896f1465e6772f741ac6
        // ├─ timestamp: 0x58955844
        // ├─ totalDifficulty: 0x751d0dfa03c1
        // ├─ transactions
        // │  └─ 0
        // │     ├─ blockHash: 0xf60903687b1559b9c80f2d935b4c4f468ad95c3076928c432ec34f2ef3d4eec9
        // │     ├─ blockNumber: 0x72ac8
        // │     ├─ from: 0x201354729f8d0f8b64e9a0c353c672c6a66b3857
        // │     ├─ gas: 0x15f90
        // │     ├─ gasPrice: 0x4a817c800
        // │     ├─ hash: 0xd5a15d7c2449150db4f74f42a6ca0702150a24c46c5b406a7e1b3e44908ef44d
        // │     ├─ input: 0xe1fa8e849bc10d87fb03c6b0603b05a3e29043c7e0b7c927119576a4bec457e96c7d7cde
        // │     ├─ nonce: 0x323e
        // │     ├─ to: 0xd10e3be2bc8f959bc8c41cf65f60de721cf89adf
        // │     ├─ transactionIndex: 0x0
        // │     ├─ value: 0x0
        // │     ├─ v: 0x29
        // │     ├─ r: 0xf35f8ab241e6bb3ccaffd21b268dbfc7fcb5df1c1fb83ee5306207e4a1a3e954
        // │     └─ s: 0x1610cdac2782c91065fd43584cd8974f7f3b4e6d46a2aafe7b101788285bf3f2
        // ├─ transactionsRoot: 0xb090c32d840dec1e9752719f21bbae4a73e58333aecb89bc3b8ed559fb2712a3
        // └─ uncles

        /***/
      },

      /***/
      "../../node_modules/eth-block-tracker-es5/node_modules/pify/index.js":
      /*!****************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/eth-block-tracker-es5/node_modules/pify/index.js ***!
        \****************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesEthBlockTrackerEs5Node_modulesPifyIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var processFn = function processFn(fn, P, opts) {
          return function () {
            var that = this;
            var args = new Array(arguments.length);

            for (var i = 0; i < arguments.length; i++) {
              args[i] = arguments[i];
            }

            return new P(function (resolve, reject) {
              args.push(function (err, result) {
                if (err) {
                  reject(err);
                } else if (opts.multiArgs) {
                  var results = new Array(arguments.length - 1);

                  for (var i = 1; i < arguments.length; i++) {
                    results[i - 1] = arguments[i];
                  }

                  resolve(results);
                } else {
                  resolve(result);
                }
              });
              fn.apply(that, args);
            });
          };
        };

        var pify = module.exports = function (obj, P, opts) {
          if (typeof P !== 'function') {
            opts = P;
            P = Promise;
          }

          opts = opts || {};
          opts.exclude = opts.exclude || [/.+Sync$/];

          var filter = function filter(key) {
            var match = function match(pattern) {
              return typeof pattern === 'string' ? key === pattern : pattern.test(key);
            };

            return opts.include ? opts.include.some(match) : !opts.exclude.some(match);
          };

          var ret = typeof obj === 'function' ? function () {
            if (opts.excludeMain) {
              return obj.apply(this, arguments);
            }

            return processFn(obj, P, opts).apply(this, arguments);
          } : {};
          return Object.keys(obj).reduce(function (ret, key) {
            var x = obj[key];
            ret[key] = typeof x === 'function' && filter(key) ? processFn(x, P, opts) : x;
            return ret;
          }, ret);
        };

        pify.all = pify;
        /***/
      },

      /***/
      "../../node_modules/eth-query/index.js":
      /*!**********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/eth-query/index.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesEthQueryIndexJs(module, exports, __webpack_require__) {
        var extend = __webpack_require__(
        /*! xtend */
        "../../node_modules/xtend/immutable.js");

        var createRandomId = __webpack_require__(
        /*! json-rpc-random-id */
        "../../node_modules/json-rpc-random-id/index.js")();

        module.exports = EthQuery;

        function EthQuery(provider) {
          var self = this;
          self.currentProvider = provider;
        } //
        // base queries
        //
        // default block


        EthQuery.prototype.getBalance = generateFnWithDefaultBlockFor(2, 'eth_getBalance');
        EthQuery.prototype.getCode = generateFnWithDefaultBlockFor(2, 'eth_getCode');
        EthQuery.prototype.getTransactionCount = generateFnWithDefaultBlockFor(2, 'eth_getTransactionCount');
        EthQuery.prototype.getStorageAt = generateFnWithDefaultBlockFor(3, 'eth_getStorageAt');
        EthQuery.prototype.call = generateFnWithDefaultBlockFor(2, 'eth_call'); // standard

        EthQuery.prototype.protocolVersion = generateFnFor('eth_protocolVersion');
        EthQuery.prototype.syncing = generateFnFor('eth_syncing');
        EthQuery.prototype.coinbase = generateFnFor('eth_coinbase');
        EthQuery.prototype.mining = generateFnFor('eth_mining');
        EthQuery.prototype.hashrate = generateFnFor('eth_hashrate');
        EthQuery.prototype.gasPrice = generateFnFor('eth_gasPrice');
        EthQuery.prototype.accounts = generateFnFor('eth_accounts');
        EthQuery.prototype.blockNumber = generateFnFor('eth_blockNumber');
        EthQuery.prototype.getBlockTransactionCountByHash = generateFnFor('eth_getBlockTransactionCountByHash');
        EthQuery.prototype.getBlockTransactionCountByNumber = generateFnFor('eth_getBlockTransactionCountByNumber');
        EthQuery.prototype.getUncleCountByBlockHash = generateFnFor('eth_getUncleCountByBlockHash');
        EthQuery.prototype.getUncleCountByBlockNumber = generateFnFor('eth_getUncleCountByBlockNumber');
        EthQuery.prototype.sign = generateFnFor('eth_sign');
        EthQuery.prototype.sendTransaction = generateFnFor('eth_sendTransaction');
        EthQuery.prototype.sendRawTransaction = generateFnFor('eth_sendRawTransaction');
        EthQuery.prototype.estimateGas = generateFnFor('eth_estimateGas');
        EthQuery.prototype.getBlockByHash = generateFnFor('eth_getBlockByHash');
        EthQuery.prototype.getBlockByNumber = generateFnFor('eth_getBlockByNumber');
        EthQuery.prototype.getTransactionByHash = generateFnFor('eth_getTransactionByHash');
        EthQuery.prototype.getTransactionByBlockHashAndIndex = generateFnFor('eth_getTransactionByBlockHashAndIndex');
        EthQuery.prototype.getTransactionByBlockNumberAndIndex = generateFnFor('eth_getTransactionByBlockNumberAndIndex');
        EthQuery.prototype.getTransactionReceipt = generateFnFor('eth_getTransactionReceipt');
        EthQuery.prototype.getUncleByBlockHashAndIndex = generateFnFor('eth_getUncleByBlockHashAndIndex');
        EthQuery.prototype.getUncleByBlockNumberAndIndex = generateFnFor('eth_getUncleByBlockNumberAndIndex');
        EthQuery.prototype.getCompilers = generateFnFor('eth_getCompilers');
        EthQuery.prototype.compileLLL = generateFnFor('eth_compileLLL');
        EthQuery.prototype.compileSolidity = generateFnFor('eth_compileSolidity');
        EthQuery.prototype.compileSerpent = generateFnFor('eth_compileSerpent');
        EthQuery.prototype.newFilter = generateFnFor('eth_newFilter');
        EthQuery.prototype.newBlockFilter = generateFnFor('eth_newBlockFilter');
        EthQuery.prototype.newPendingTransactionFilter = generateFnFor('eth_newPendingTransactionFilter');
        EthQuery.prototype.uninstallFilter = generateFnFor('eth_uninstallFilter');
        EthQuery.prototype.getFilterChanges = generateFnFor('eth_getFilterChanges');
        EthQuery.prototype.getFilterLogs = generateFnFor('eth_getFilterLogs');
        EthQuery.prototype.getLogs = generateFnFor('eth_getLogs');
        EthQuery.prototype.getWork = generateFnFor('eth_getWork');
        EthQuery.prototype.submitWork = generateFnFor('eth_submitWork');
        EthQuery.prototype.submitHashrate = generateFnFor('eth_submitHashrate'); // network level

        EthQuery.prototype.sendAsync = function (opts, cb) {
          var self = this;
          self.currentProvider.sendAsync(createPayload(opts), function (err, response) {
            if (!err && response.error) err = new Error('EthQuery - RPC Error - ' + response.error.message);
            if (err) return cb(err);
            cb(null, response.result);
          });
        }; // util


        function generateFnFor(methodName) {
          return function () {
            var self = this;
            var args = [].slice.call(arguments);
            var cb = args.pop();
            self.sendAsync({
              method: methodName,
              params: args
            }, cb);
          };
        }

        function generateFnWithDefaultBlockFor(argCount, methodName) {
          return function () {
            var self = this;
            var args = [].slice.call(arguments);
            var cb = args.pop(); // set optional default block param

            if (args.length < argCount) args.push('latest');
            self.sendAsync({
              method: methodName,
              params: args
            }, cb);
          };
        }

        function createPayload(data) {
          return extend({
            // defaults
            id: createRandomId(),
            jsonrpc: '2.0',
            params: [] // user-specified

          }, data);
        }
        /***/

      },

      /***/
      "../../node_modules/ethjs-util/lib/index.js":
      /*!***************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/ethjs-util/lib/index.js ***!
        \***************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesEthjsUtilLibIndexJs(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */

        (function (Buffer) {
          var isHexPrefixed = __webpack_require__(
          /*! is-hex-prefixed */
          "../../node_modules/is-hex-prefixed/src/index.js");

          var stripHexPrefix = __webpack_require__(
          /*! strip-hex-prefix */
          "../../node_modules/strip-hex-prefix/src/index.js");
          /**
           * Pads a `String` to have an even length
           * @param {String} value
           * @return {String} output
           */


          function padToEven(value) {
            var a = value; // eslint-disable-line

            if (typeof a !== 'string') {
              throw new Error('[ethjs-util] while padding to even, value must be string, is currently ' + typeof a + ', while padToEven.');
            }

            if (a.length % 2) {
              a = '0' + a;
            }

            return a;
          }
          /**
           * Converts a `Number` into a hex `String`
           * @param {Number} i
           * @return {String}
           */


          function intToHex(i) {
            var hex = i.toString(16); // eslint-disable-line

            return '0x' + hex;
          }
          /**
           * Converts an `Number` to a `Buffer`
           * @param {Number} i
           * @return {Buffer}
           */


          function intToBuffer(i) {
            var hex = intToHex(i);
            return new Buffer(padToEven(hex.slice(2)), 'hex');
          }
          /**
           * Get the binary size of a string
           * @param {String} str
           * @return {Number}
           */


          function getBinarySize(str) {
            if (typeof str !== 'string') {
              throw new Error('[ethjs-util] while getting binary size, method getBinarySize requires input \'str\' to be type String, got \'' + typeof str + '\'.');
            }

            return Buffer.byteLength(str, 'utf8');
          }
          /**
           * Returns TRUE if the first specified array contains all elements
           * from the second one. FALSE otherwise.
           *
           * @param {array} superset
           * @param {array} subset
           *
           * @returns {boolean}
           */


          function arrayContainsArray(superset, subset, some) {
            if (Array.isArray(superset) !== true) {
              throw new Error('[ethjs-util] method arrayContainsArray requires input \'superset\' to be an array got type \'' + typeof superset + '\'');
            }

            if (Array.isArray(subset) !== true) {
              throw new Error('[ethjs-util] method arrayContainsArray requires input \'subset\' to be an array got type \'' + typeof subset + '\'');
            }

            return subset[Boolean(some) && 'some' || 'every'](function (value) {
              return superset.indexOf(value) >= 0;
            });
          }
          /**
           * Should be called to get utf8 from it's hex representation
           *
           * @method toUtf8
           * @param {String} string in hex
           * @returns {String} ascii string representation of hex value
           */


          function toUtf8(hex) {
            var bufferValue = new Buffer(padToEven(stripHexPrefix(hex).replace(/^0+|0+$/g, '')), 'hex');
            return bufferValue.toString('utf8');
          }
          /**
           * Should be called to get ascii from it's hex representation
           *
           * @method toAscii
           * @param {String} string in hex
           * @returns {String} ascii string representation of hex value
           */


          function toAscii(hex) {
            var str = ''; // eslint-disable-line

            var i = 0,
                l = hex.length; // eslint-disable-line

            if (hex.substring(0, 2) === '0x') {
              i = 2;
            }

            for (; i < l; i += 2) {
              var code = parseInt(hex.substr(i, 2), 16);
              str += String.fromCharCode(code);
            }

            return str;
          }
          /**
           * Should be called to get hex representation (prefixed by 0x) of utf8 string
           *
           * @method fromUtf8
           * @param {String} string
           * @param {Number} optional padding
           * @returns {String} hex representation of input string
           */


          function fromUtf8(stringValue) {
            var str = new Buffer(stringValue, 'utf8');
            return '0x' + padToEven(str.toString('hex')).replace(/^0+|0+$/g, '');
          }
          /**
           * Should be called to get hex representation (prefixed by 0x) of ascii string
           *
           * @method fromAscii
           * @param {String} string
           * @param {Number} optional padding
           * @returns {String} hex representation of input string
           */


          function fromAscii(stringValue) {
            var hex = ''; // eslint-disable-line

            for (var i = 0; i < stringValue.length; i++) {
              // eslint-disable-line
              var code = stringValue.charCodeAt(i);
              var n = code.toString(16);
              hex += n.length < 2 ? '0' + n : n;
            }

            return '0x' + hex;
          }
          /**
           * getKeys([{a: 1, b: 2}, {a: 3, b: 4}], 'a') => [1, 3]
           *
           * @method getKeys get specific key from inner object array of objects
           * @param {String} params
           * @param {String} key
           * @param {Boolean} allowEmpty
           * @returns {Array} output just a simple array of output keys
           */


          function getKeys(params, key, allowEmpty) {
            if (!Array.isArray(params)) {
              throw new Error('[ethjs-util] method getKeys expecting type Array as \'params\' input, got \'' + typeof params + '\'');
            }

            if (typeof key !== 'string') {
              throw new Error('[ethjs-util] method getKeys expecting type String for input \'key\' got \'' + typeof key + '\'.');
            }

            var result = []; // eslint-disable-line

            for (var i = 0; i < params.length; i++) {
              // eslint-disable-line
              var value = params[i][key]; // eslint-disable-line

              if (allowEmpty && !value) {
                value = '';
              } else if (typeof value !== 'string') {
                throw new Error('invalid abi');
              }

              result.push(value);
            }

            return result;
          }
          /**
           * Is the string a hex string.
           *
           * @method check if string is hex string of specific length
           * @param {String} value
           * @param {Number} length
           * @returns {Boolean} output the string is a hex string
           */


          function isHexString(value, length) {
            if (typeof value !== 'string' || !value.match(/^0x[0-9A-Fa-f]*$/)) {
              return false;
            }

            if (length && value.length !== 2 + 2 * length) {
              return false;
            }

            return true;
          }

          module.exports = {
            arrayContainsArray: arrayContainsArray,
            intToBuffer: intToBuffer,
            getBinarySize: getBinarySize,
            isHexPrefixed: isHexPrefixed,
            stripHexPrefix: stripHexPrefix,
            padToEven: padToEven,
            intToHex: intToHex,
            fromAscii: fromAscii,
            fromUtf8: fromUtf8,
            toAscii: toAscii,
            toUtf8: toUtf8,
            getKeys: getKeys,
            isHexString: isHexString
          };
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../../node-libs-browser/node_modules/buffer/index.js */
        "../../node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer);
        /***/
      },

      /***/
      "../../node_modules/events/events.js":
      /*!********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/events/events.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesEventsEventsJs(module, exports, __webpack_require__) {
        "use strict"; // Copyright Joyent, Inc. and other Node contributors.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a
        // copy of this software and associated documentation files (the
        // "Software"), to deal in the Software without restriction, including
        // without limitation the rights to use, copy, modify, merge, publish,
        // distribute, sublicense, and/or sell copies of the Software, and to permit
        // persons to whom the Software is furnished to do so, subject to the
        // following conditions:
        //
        // The above copyright notice and this permission notice shall be included
        // in all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
        // USE OR OTHER DEALINGS IN THE SOFTWARE.

        var R = typeof Reflect === 'object' ? Reflect : null;
        var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
          return Function.prototype.apply.call(target, receiver, args);
        };
        var ReflectOwnKeys;

        if (R && typeof R.ownKeys === 'function') {
          ReflectOwnKeys = R.ownKeys;
        } else if (Object.getOwnPropertySymbols) {
          ReflectOwnKeys = function ReflectOwnKeys(target) {
            return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
          };
        } else {
          ReflectOwnKeys = function ReflectOwnKeys(target) {
            return Object.getOwnPropertyNames(target);
          };
        }

        function ProcessEmitWarning(warning) {
          if (console && console.warn) console.warn(warning);
        }

        var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
          return value !== value;
        };

        function EventEmitter() {
          EventEmitter.init.call(this);
        }

        module.exports = EventEmitter; // Backwards-compat with node 0.10.x

        EventEmitter.EventEmitter = EventEmitter;
        EventEmitter.prototype._events = undefined;
        EventEmitter.prototype._eventsCount = 0;
        EventEmitter.prototype._maxListeners = undefined; // By default EventEmitters will print a warning if more than 10 listeners are
        // added to it. This is a useful default which helps finding memory leaks.

        var defaultMaxListeners = 10;
        Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
          enumerable: true,
          get: function get() {
            return defaultMaxListeners;
          },
          set: function set(arg) {
            if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
              throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
            }

            defaultMaxListeners = arg;
          }
        });

        EventEmitter.init = function () {
          if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
            this._events = Object.create(null);
            this._eventsCount = 0;
          }

          this._maxListeners = this._maxListeners || undefined;
        }; // Obviously not all Emitters should be limited to 10. This function allows
        // that to be increased. Set to zero for unlimited.


        EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
          if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
            throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
          }

          this._maxListeners = n;
          return this;
        };

        function $getMaxListeners(that) {
          if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
          return that._maxListeners;
        }

        EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
          return $getMaxListeners(this);
        };

        EventEmitter.prototype.emit = function emit(type) {
          var args = [];

          for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
          }

          var doError = type === 'error';
          var events = this._events;
          if (events !== undefined) doError = doError && events.error === undefined;else if (!doError) return false; // If there is no 'error' event listener then throw.

          if (doError) {
            var er;
            if (args.length > 0) er = args[0];

            if (er instanceof Error) {
              // Note: The comments on the `throw` lines are intentional, they show
              // up in Node's output if this results in an unhandled exception.
              throw er; // Unhandled 'error' event
            } // At least give some kind of context to the user


            var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
            err.context = er;
            throw err; // Unhandled 'error' event
          }

          var handler = events[type];
          if (handler === undefined) return false;

          if (typeof handler === 'function') {
            ReflectApply(handler, this, args);
          } else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);

            for (var i = 0; i < len; ++i) {
              ReflectApply(listeners[i], this, args);
            }
          }

          return true;
        };

        function _addListener(target, type, listener, prepend) {
          var m;
          var events;
          var existing;

          if (typeof listener !== 'function') {
            throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
          }

          events = target._events;

          if (events === undefined) {
            events = target._events = Object.create(null);
            target._eventsCount = 0;
          } else {
            // To avoid recursion in the case that type === "newListener"! Before
            // adding it to the listeners, first emit "newListener".
            if (events.newListener !== undefined) {
              target.emit('newListener', type, listener.listener ? listener.listener : listener); // Re-assign `events` because a newListener handler could have caused the
              // this._events to be assigned to a new object

              events = target._events;
            }

            existing = events[type];
          }

          if (existing === undefined) {
            // Optimize the case of one listener. Don't need the extra array object.
            existing = events[type] = listener;
            ++target._eventsCount;
          } else {
            if (typeof existing === 'function') {
              // Adding the second element, need to change to array.
              existing = events[type] = prepend ? [listener, existing] : [existing, listener]; // If we've already got an array, just append.
            } else if (prepend) {
              existing.unshift(listener);
            } else {
              existing.push(listener);
            } // Check for listener leak


            m = $getMaxListeners(target);

            if (m > 0 && existing.length > m && !existing.warned) {
              existing.warned = true; // No error code for this since it is a Warning
              // eslint-disable-next-line no-restricted-syntax

              var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
              w.name = 'MaxListenersExceededWarning';
              w.emitter = target;
              w.type = type;
              w.count = existing.length;
              ProcessEmitWarning(w);
            }
          }

          return target;
        }

        EventEmitter.prototype.addListener = function addListener(type, listener) {
          return _addListener(this, type, listener, false);
        };

        EventEmitter.prototype.on = EventEmitter.prototype.addListener;

        EventEmitter.prototype.prependListener = function prependListener(type, listener) {
          return _addListener(this, type, listener, true);
        };

        function onceWrapper() {
          var args = [];

          for (var i = 0; i < arguments.length; i++) {
            args.push(arguments[i]);
          }

          if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            ReflectApply(this.listener, this.target, args);
          }
        }

        function _onceWrap(target, type, listener) {
          var state = {
            fired: false,
            wrapFn: undefined,
            target: target,
            type: type,
            listener: listener
          };
          var wrapped = onceWrapper.bind(state);
          wrapped.listener = listener;
          state.wrapFn = wrapped;
          return wrapped;
        }

        EventEmitter.prototype.once = function once(type, listener) {
          if (typeof listener !== 'function') {
            throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
          }

          this.on(type, _onceWrap(this, type, listener));
          return this;
        };

        EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
          if (typeof listener !== 'function') {
            throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
          }

          this.prependListener(type, _onceWrap(this, type, listener));
          return this;
        }; // Emits a 'removeListener' event if and only if the listener was removed.


        EventEmitter.prototype.removeListener = function removeListener(type, listener) {
          var list, events, position, i, originalListener;

          if (typeof listener !== 'function') {
            throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
          }

          events = this._events;
          if (events === undefined) return this;
          list = events[type];
          if (list === undefined) return this;

          if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = Object.create(null);else {
              delete events[type];
              if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
            }
          } else if (typeof list !== 'function') {
            position = -1;

            for (i = list.length - 1; i >= 0; i--) {
              if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
              }
            }

            if (position < 0) return this;
            if (position === 0) list.shift();else {
              spliceOne(list, position);
            }
            if (list.length === 1) events[type] = list[0];
            if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
          }

          return this;
        };

        EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

        EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
          var listeners, events, i;
          events = this._events;
          if (events === undefined) return this; // not listening for removeListener, no need to emit

          if (events.removeListener === undefined) {
            if (arguments.length === 0) {
              this._events = Object.create(null);
              this._eventsCount = 0;
            } else if (events[type] !== undefined) {
              if (--this._eventsCount === 0) this._events = Object.create(null);else delete events[type];
            }

            return this;
          } // emit removeListener for all listeners on all events


          if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;

            for (i = 0; i < keys.length; ++i) {
              key = keys[i];
              if (key === 'removeListener') continue;
              this.removeAllListeners(key);
            }

            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
          }

          listeners = events[type];

          if (typeof listeners === 'function') {
            this.removeListener(type, listeners);
          } else if (listeners !== undefined) {
            // LIFO order
            for (i = listeners.length - 1; i >= 0; i--) {
              this.removeListener(type, listeners[i]);
            }
          }

          return this;
        };

        function _listeners(target, type, unwrap) {
          var events = target._events;
          if (events === undefined) return [];
          var evlistener = events[type];
          if (evlistener === undefined) return [];
          if (typeof evlistener === 'function') return unwrap ? [evlistener.listener || evlistener] : [evlistener];
          return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
        }

        EventEmitter.prototype.listeners = function listeners(type) {
          return _listeners(this, type, true);
        };

        EventEmitter.prototype.rawListeners = function rawListeners(type) {
          return _listeners(this, type, false);
        };

        EventEmitter.listenerCount = function (emitter, type) {
          if (typeof emitter.listenerCount === 'function') {
            return emitter.listenerCount(type);
          } else {
            return listenerCount.call(emitter, type);
          }
        };

        EventEmitter.prototype.listenerCount = listenerCount;

        function listenerCount(type) {
          var events = this._events;

          if (events !== undefined) {
            var evlistener = events[type];

            if (typeof evlistener === 'function') {
              return 1;
            } else if (evlistener !== undefined) {
              return evlistener.length;
            }
          }

          return 0;
        }

        EventEmitter.prototype.eventNames = function eventNames() {
          return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
        };

        function arrayClone(arr, n) {
          var copy = new Array(n);

          for (var i = 0; i < n; ++i) {
            copy[i] = arr[i];
          }

          return copy;
        }

        function spliceOne(list, index) {
          for (; index + 1 < list.length; index++) {
            list[index] = list[index + 1];
          }

          list.pop();
        }

        function unwrapListeners(arr) {
          var ret = new Array(arr.length);

          for (var i = 0; i < ret.length; ++i) {
            ret[i] = arr[i].listener || arr[i];
          }

          return ret;
        }
        /***/

      },

      /***/
      "../../node_modules/ieee754/index.js":
      /*!********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/ieee754/index.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesIeee754IndexJs(module, exports) {
        exports.read = function (buffer, offset, isLE, mLen, nBytes) {
          var e, m;
          var eLen = nBytes * 8 - mLen - 1;
          var eMax = (1 << eLen) - 1;
          var eBias = eMax >> 1;
          var nBits = -7;
          var i = isLE ? nBytes - 1 : 0;
          var d = isLE ? -1 : 1;
          var s = buffer[offset + i];
          i += d;
          e = s & (1 << -nBits) - 1;
          s >>= -nBits;
          nBits += eLen;

          for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

          m = e & (1 << -nBits) - 1;
          e >>= -nBits;
          nBits += mLen;

          for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

          if (e === 0) {
            e = 1 - eBias;
          } else if (e === eMax) {
            return m ? NaN : (s ? -1 : 1) * Infinity;
          } else {
            m = m + Math.pow(2, mLen);
            e = e - eBias;
          }

          return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
        };

        exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
          var e, m, c;
          var eLen = nBytes * 8 - mLen - 1;
          var eMax = (1 << eLen) - 1;
          var eBias = eMax >> 1;
          var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
          var i = isLE ? 0 : nBytes - 1;
          var d = isLE ? 1 : -1;
          var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
          value = Math.abs(value);

          if (isNaN(value) || value === Infinity) {
            m = isNaN(value) ? 1 : 0;
            e = eMax;
          } else {
            e = Math.floor(Math.log(value) / Math.LN2);

            if (value * (c = Math.pow(2, -e)) < 1) {
              e--;
              c *= 2;
            }

            if (e + eBias >= 1) {
              value += rt / c;
            } else {
              value += rt * Math.pow(2, 1 - eBias);
            }

            if (value * c >= 2) {
              e++;
              c /= 2;
            }

            if (e + eBias >= eMax) {
              m = 0;
              e = eMax;
            } else if (e + eBias >= 1) {
              m = (value * c - 1) * Math.pow(2, mLen);
              e = e + eBias;
            } else {
              m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
              e = 0;
            }
          }

          for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

          e = e << mLen | m;
          eLen += mLen;

          for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

          buffer[offset + i - d] |= s * 128;
        };
        /***/

      },

      /***/
      "../../node_modules/is-hex-prefixed/src/index.js":
      /*!********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/is-hex-prefixed/src/index.js ***!
        \********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesIsHexPrefixedSrcIndexJs(module, exports) {
        /**
         * Returns a `Boolean` on whether or not the a `String` starts with '0x'
         * @param {String} str the string input value
         * @return {Boolean} a boolean if it is or is not hex prefixed
         * @throws if the str input is not a string
         */
        module.exports = function isHexPrefixed(str) {
          if (typeof str !== 'string') {
            throw new Error("[is-hex-prefixed] value must be type 'string', is currently type " + typeof str + ", while checking isHexPrefixed.");
          }

          return str.slice(0, 2) === '0x';
        };
        /***/

      },

      /***/
      "../../node_modules/isarray/index.js":
      /*!********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/isarray/index.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesIsarrayIndexJs(module, exports) {
        var toString = {}.toString;

        module.exports = Array.isArray || function (arr) {
          return toString.call(arr) == '[object Array]';
        };
        /***/

      },

      /***/
      "../../node_modules/json-rpc-random-id/index.js":
      /*!*******************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/json-rpc-random-id/index.js ***!
        \*******************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesJsonRpcRandomIdIndexJs(module, exports) {
        module.exports = IdIterator;

        function IdIterator(opts) {
          opts = opts || {};
          var max = opts.max || Number.MAX_SAFE_INTEGER;
          var idCounter = typeof opts.start !== 'undefined' ? opts.start : Math.floor(Math.random() * max);
          return function createRandomId() {
            idCounter = idCounter % max;
            return idCounter++;
          };
        }
        /***/

      },

      /***/
      "../../node_modules/lodash/_Symbol.js":
      /*!*********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_Symbol.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_SymbolJs(module, exports, __webpack_require__) {
        var root = __webpack_require__(
        /*! ./_root */
        "../../node_modules/lodash/_root.js");
        /** Built-in value references. */


        var Symbol = root.Symbol;
        module.exports = Symbol;
        /***/
      },

      /***/
      "../../node_modules/lodash/_arrayLikeKeys.js":
      /*!****************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_arrayLikeKeys.js ***!
        \****************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_arrayLikeKeysJs(module, exports, __webpack_require__) {
        var baseTimes = __webpack_require__(
        /*! ./_baseTimes */
        "../../node_modules/lodash/_baseTimes.js"),
            isArguments = __webpack_require__(
        /*! ./isArguments */
        "../../node_modules/lodash/isArguments.js"),
            isArray = __webpack_require__(
        /*! ./isArray */
        "../../node_modules/lodash/isArray.js"),
            isBuffer = __webpack_require__(
        /*! ./isBuffer */
        "../../node_modules/lodash/isBuffer.js"),
            isIndex = __webpack_require__(
        /*! ./_isIndex */
        "../../node_modules/lodash/_isIndex.js"),
            isTypedArray = __webpack_require__(
        /*! ./isTypedArray */
        "../../node_modules/lodash/isTypedArray.js");
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * Creates an array of the enumerable property names of the array-like `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @param {boolean} inherited Specify returning inherited property names.
         * @returns {Array} Returns the array of property names.
         */

        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value),
              isArg = !isArr && isArguments(value),
              isBuff = !isArr && !isArg && isBuffer(value),
              isType = !isArr && !isArg && !isBuff && isTypedArray(value),
              skipIndexes = isArr || isArg || isBuff || isType,
              result = skipIndexes ? baseTimes(value.length, String) : [],
              length = result.length;

          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
            key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) {
              result.push(key);
            }
          }

          return result;
        }

        module.exports = arrayLikeKeys;
        /***/
      },

      /***/
      "../../node_modules/lodash/_baseGetTag.js":
      /*!*************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_baseGetTag.js ***!
        \*************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseGetTagJs(module, exports, __webpack_require__) {
        var Symbol = __webpack_require__(
        /*! ./_Symbol */
        "../../node_modules/lodash/_Symbol.js"),
            getRawTag = __webpack_require__(
        /*! ./_getRawTag */
        "../../node_modules/lodash/_getRawTag.js"),
            objectToString = __webpack_require__(
        /*! ./_objectToString */
        "../../node_modules/lodash/_objectToString.js");
        /** `Object#toString` result references. */


        var nullTag = '[object Null]',
            undefinedTag = '[object Undefined]';
        /** Built-in value references. */

        var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        /**
         * The base implementation of `getTag` without fallbacks for buggy environments.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */

        function baseGetTag(value) {
          if (value == null) {
            return value === undefined ? undefinedTag : nullTag;
          }

          return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
        }

        module.exports = baseGetTag;
        /***/
      },

      /***/
      "../../node_modules/lodash/_baseIsArguments.js":
      /*!******************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_baseIsArguments.js ***!
        \******************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseIsArgumentsJs(module, exports, __webpack_require__) {
        var baseGetTag = __webpack_require__(
        /*! ./_baseGetTag */
        "../../node_modules/lodash/_baseGetTag.js"),
            isObjectLike = __webpack_require__(
        /*! ./isObjectLike */
        "../../node_modules/lodash/isObjectLike.js");
        /** `Object#toString` result references. */


        var argsTag = '[object Arguments]';
        /**
         * The base implementation of `_.isArguments`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         */

        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }

        module.exports = baseIsArguments;
        /***/
      },

      /***/
      "../../node_modules/lodash/_baseIsTypedArray.js":
      /*!*******************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_baseIsTypedArray.js ***!
        \*******************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseIsTypedArrayJs(module, exports, __webpack_require__) {
        var baseGetTag = __webpack_require__(
        /*! ./_baseGetTag */
        "../../node_modules/lodash/_baseGetTag.js"),
            isLength = __webpack_require__(
        /*! ./isLength */
        "../../node_modules/lodash/isLength.js"),
            isObjectLike = __webpack_require__(
        /*! ./isObjectLike */
        "../../node_modules/lodash/isObjectLike.js");
        /** `Object#toString` result references. */


        var argsTag = '[object Arguments]',
            arrayTag = '[object Array]',
            boolTag = '[object Boolean]',
            dateTag = '[object Date]',
            errorTag = '[object Error]',
            funcTag = '[object Function]',
            mapTag = '[object Map]',
            numberTag = '[object Number]',
            objectTag = '[object Object]',
            regexpTag = '[object RegExp]',
            setTag = '[object Set]',
            stringTag = '[object String]',
            weakMapTag = '[object WeakMap]';
        var arrayBufferTag = '[object ArrayBuffer]',
            dataViewTag = '[object DataView]',
            float32Tag = '[object Float32Array]',
            float64Tag = '[object Float64Array]',
            int8Tag = '[object Int8Array]',
            int16Tag = '[object Int16Array]',
            int32Tag = '[object Int32Array]',
            uint8Tag = '[object Uint8Array]',
            uint8ClampedTag = '[object Uint8ClampedArray]',
            uint16Tag = '[object Uint16Array]',
            uint32Tag = '[object Uint32Array]';
        /** Used to identify `toStringTag` values of typed arrays. */

        var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
        /**
         * The base implementation of `_.isTypedArray` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         */

        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }

        module.exports = baseIsTypedArray;
        /***/
      },

      /***/
      "../../node_modules/lodash/_baseKeys.js":
      /*!***********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_baseKeys.js ***!
        \***********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseKeysJs(module, exports, __webpack_require__) {
        var isPrototype = __webpack_require__(
        /*! ./_isPrototype */
        "../../node_modules/lodash/_isPrototype.js"),
            nativeKeys = __webpack_require__(
        /*! ./_nativeKeys */
        "../../node_modules/lodash/_nativeKeys.js");
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */

        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }

          var result = [];

          for (var key in Object(object)) {
            if (hasOwnProperty.call(object, key) && key != 'constructor') {
              result.push(key);
            }
          }

          return result;
        }

        module.exports = baseKeys;
        /***/
      },

      /***/
      "../../node_modules/lodash/_baseTimes.js":
      /*!************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_baseTimes.js ***!
        \************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseTimesJs(module, exports) {
        /**
         * The base implementation of `_.times` without support for iteratee shorthands
         * or max array length checks.
         *
         * @private
         * @param {number} n The number of times to invoke `iteratee`.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns the array of results.
         */
        function baseTimes(n, iteratee) {
          var index = -1,
              result = Array(n);

          while (++index < n) {
            result[index] = iteratee(index);
          }

          return result;
        }

        module.exports = baseTimes;
        /***/
      },

      /***/
      "../../node_modules/lodash/_baseUnary.js":
      /*!************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_baseUnary.js ***!
        \************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_baseUnaryJs(module, exports) {
        /**
         * The base implementation of `_.unary` without support for storing metadata.
         *
         * @private
         * @param {Function} func The function to cap arguments for.
         * @returns {Function} Returns the new capped function.
         */
        function baseUnary(func) {
          return function (value) {
            return func(value);
          };
        }

        module.exports = baseUnary;
        /***/
      },

      /***/
      "../../node_modules/lodash/_freeGlobal.js":
      /*!*************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_freeGlobal.js ***!
        \*************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_freeGlobalJs(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (global) {
          /** Detect free variable `global` from Node.js. */
          var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
          module.exports = freeGlobal;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../../packages/store/node_modules/webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"));
        /***/
      },

      /***/
      "../../node_modules/lodash/_getRawTag.js":
      /*!************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_getRawTag.js ***!
        \************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_getRawTagJs(module, exports, __webpack_require__) {
        var Symbol = __webpack_require__(
        /*! ./_Symbol */
        "../../node_modules/lodash/_Symbol.js");
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */

        var nativeObjectToString = objectProto.toString;
        /** Built-in value references. */

        var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        /**
         * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the raw `toStringTag`.
         */

        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag),
              tag = value[symToStringTag];

          try {
            value[symToStringTag] = undefined;
            var unmasked = true;
          } catch (e) {}

          var result = nativeObjectToString.call(value);

          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }

          return result;
        }

        module.exports = getRawTag;
        /***/
      },

      /***/
      "../../node_modules/lodash/_isIndex.js":
      /*!**********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_isIndex.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_isIndexJs(module, exports) {
        /** Used as references for various `Number` constants. */
        var MAX_SAFE_INTEGER = 9007199254740991;
        /** Used to detect unsigned integer values. */

        var reIsUint = /^(?:0|[1-9]\d*)$/;
        /**
         * Checks if `value` is a valid array-like index.
         *
         * @private
         * @param {*} value The value to check.
         * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
         * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
         */

        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }

        module.exports = isIndex;
        /***/
      },

      /***/
      "../../node_modules/lodash/_isPrototype.js":
      /*!**************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_isPrototype.js ***!
        \**************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_isPrototypeJs(module, exports) {
        /** Used for built-in method references. */
        var objectProto = Object.prototype;
        /**
         * Checks if `value` is likely a prototype object.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
         */

        function isPrototype(value) {
          var Ctor = value && value.constructor,
              proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
          return value === proto;
        }

        module.exports = isPrototype;
        /***/
      },

      /***/
      "../../node_modules/lodash/_nativeKeys.js":
      /*!*************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_nativeKeys.js ***!
        \*************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_nativeKeysJs(module, exports, __webpack_require__) {
        var overArg = __webpack_require__(
        /*! ./_overArg */
        "../../node_modules/lodash/_overArg.js");
        /* Built-in method references for those with the same name as other `lodash` methods. */


        var nativeKeys = overArg(Object.keys, Object);
        module.exports = nativeKeys;
        /***/
      },

      /***/
      "../../node_modules/lodash/_nodeUtil.js":
      /*!***********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_nodeUtil.js ***!
        \***********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_nodeUtilJs(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (module) {
          var freeGlobal = __webpack_require__(
          /*! ./_freeGlobal */
          "../../node_modules/lodash/_freeGlobal.js");
          /** Detect free variable `exports`. */


          var freeExports = true && exports && !exports.nodeType && exports;
          /** Detect free variable `module`. */

          var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
          /** Detect the popular CommonJS extension `module.exports`. */

          var moduleExports = freeModule && freeModule.exports === freeExports;
          /** Detect free variable `process` from Node.js. */

          var freeProcess = moduleExports && freeGlobal.process;
          /** Used to access faster Node.js helpers. */

          var nodeUtil = function () {
            try {
              // Use `util.types` for Node.js 10+.
              var types = freeModule && freeModule.require && freeModule.require('util').types;

              if (types) {
                return types;
              } // Legacy `process.binding('util')` for Node.js < 10.


              return freeProcess && freeProcess.binding && freeProcess.binding('util');
            } catch (e) {}
          }();

          module.exports = nodeUtil;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../../packages/store/node_modules/webpack/buildin/module.js */
        "./node_modules/webpack/buildin/module.js")(module));
        /***/
      },

      /***/
      "../../node_modules/lodash/_objectToString.js":
      /*!*****************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_objectToString.js ***!
        \*****************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_objectToStringJs(module, exports) {
        /** Used for built-in method references. */
        var objectProto = Object.prototype;
        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */

        var nativeObjectToString = objectProto.toString;
        /**
         * Converts `value` to a string using `Object.prototype.toString`.
         *
         * @private
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         */

        function objectToString(value) {
          return nativeObjectToString.call(value);
        }

        module.exports = objectToString;
        /***/
      },

      /***/
      "../../node_modules/lodash/_overArg.js":
      /*!**********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_overArg.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_overArgJs(module, exports) {
        /**
         * Creates a unary function that invokes `func` with its argument transformed.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {Function} transform The argument transform.
         * @returns {Function} Returns the new function.
         */
        function overArg(func, transform) {
          return function (arg) {
            return func(transform(arg));
          };
        }

        module.exports = overArg;
        /***/
      },

      /***/
      "../../node_modules/lodash/_root.js":
      /*!*******************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/_root.js ***!
        \*******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodash_rootJs(module, exports, __webpack_require__) {
        var freeGlobal = __webpack_require__(
        /*! ./_freeGlobal */
        "../../node_modules/lodash/_freeGlobal.js");
        /** Detect free variable `self`. */


        var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
        /** Used as a reference to the global object. */

        var root = freeGlobal || freeSelf || Function('return this')();
        module.exports = root;
        /***/
      },

      /***/
      "../../node_modules/lodash/isArguments.js":
      /*!*************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/isArguments.js ***!
        \*************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsArgumentsJs(module, exports, __webpack_require__) {
        var baseIsArguments = __webpack_require__(
        /*! ./_baseIsArguments */
        "../../node_modules/lodash/_baseIsArguments.js"),
            isObjectLike = __webpack_require__(
        /*! ./isObjectLike */
        "../../node_modules/lodash/isObjectLike.js");
        /** Used for built-in method references. */


        var objectProto = Object.prototype;
        /** Used to check objects for own properties. */

        var hasOwnProperty = objectProto.hasOwnProperty;
        /** Built-in value references. */

        var propertyIsEnumerable = objectProto.propertyIsEnumerable;
        /**
         * Checks if `value` is likely an `arguments` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         *  else `false`.
         * @example
         *
         * _.isArguments(function() { return arguments; }());
         * // => true
         *
         * _.isArguments([1, 2, 3]);
         * // => false
         */

        var isArguments = baseIsArguments(function () {
          return arguments;
        }()) ? baseIsArguments : function (value) {
          return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        module.exports = isArguments;
        /***/
      },

      /***/
      "../../node_modules/lodash/isArray.js":
      /*!*********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/isArray.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsArrayJs(module, exports) {
        /**
         * Checks if `value` is classified as an `Array` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array, else `false`.
         * @example
         *
         * _.isArray([1, 2, 3]);
         * // => true
         *
         * _.isArray(document.body.children);
         * // => false
         *
         * _.isArray('abc');
         * // => false
         *
         * _.isArray(_.noop);
         * // => false
         */
        var isArray = Array.isArray;
        module.exports = isArray;
        /***/
      },

      /***/
      "../../node_modules/lodash/isArrayLike.js":
      /*!*************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/isArrayLike.js ***!
        \*************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsArrayLikeJs(module, exports, __webpack_require__) {
        var isFunction = __webpack_require__(
        /*! ./isFunction */
        "../../node_modules/lodash/isFunction.js"),
            isLength = __webpack_require__(
        /*! ./isLength */
        "../../node_modules/lodash/isLength.js");
        /**
         * Checks if `value` is array-like. A value is considered array-like if it's
         * not a function and has a `value.length` that's an integer greater than or
         * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
         * @example
         *
         * _.isArrayLike([1, 2, 3]);
         * // => true
         *
         * _.isArrayLike(document.body.children);
         * // => true
         *
         * _.isArrayLike('abc');
         * // => true
         *
         * _.isArrayLike(_.noop);
         * // => false
         */


        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }

        module.exports = isArrayLike;
        /***/
      },

      /***/
      "../../node_modules/lodash/isBuffer.js":
      /*!**********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/isBuffer.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsBufferJs(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (module) {
          var root = __webpack_require__(
          /*! ./_root */
          "../../node_modules/lodash/_root.js"),
              stubFalse = __webpack_require__(
          /*! ./stubFalse */
          "../../node_modules/lodash/stubFalse.js");
          /** Detect free variable `exports`. */


          var freeExports = true && exports && !exports.nodeType && exports;
          /** Detect free variable `module`. */

          var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
          /** Detect the popular CommonJS extension `module.exports`. */

          var moduleExports = freeModule && freeModule.exports === freeExports;
          /** Built-in value references. */

          var Buffer = moduleExports ? root.Buffer : undefined;
          /* Built-in method references for those with the same name as other `lodash` methods. */

          var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
          /**
           * Checks if `value` is a buffer.
           *
           * @static
           * @memberOf _
           * @since 4.3.0
           * @category Lang
           * @param {*} value The value to check.
           * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
           * @example
           *
           * _.isBuffer(new Buffer(2));
           * // => true
           *
           * _.isBuffer(new Uint8Array(2));
           * // => false
           */

          var isBuffer = nativeIsBuffer || stubFalse;
          module.exports = isBuffer;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../../packages/store/node_modules/webpack/buildin/module.js */
        "./node_modules/webpack/buildin/module.js")(module));
        /***/
      },

      /***/
      "../../node_modules/lodash/isFunction.js":
      /*!************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/isFunction.js ***!
        \************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsFunctionJs(module, exports, __webpack_require__) {
        var baseGetTag = __webpack_require__(
        /*! ./_baseGetTag */
        "../../node_modules/lodash/_baseGetTag.js"),
            isObject = __webpack_require__(
        /*! ./isObject */
        "../../node_modules/lodash/isObject.js");
        /** `Object#toString` result references. */


        var asyncTag = '[object AsyncFunction]',
            funcTag = '[object Function]',
            genTag = '[object GeneratorFunction]',
            proxyTag = '[object Proxy]';
        /**
         * Checks if `value` is classified as a `Function` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a function, else `false`.
         * @example
         *
         * _.isFunction(_);
         * // => true
         *
         * _.isFunction(/abc/);
         * // => false
         */

        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          } // The use of `Object#toString` avoids issues with the `typeof` operator
          // in Safari 9 which returns 'object' for typed arrays and other constructors.


          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }

        module.exports = isFunction;
        /***/
      },

      /***/
      "../../node_modules/lodash/isLength.js":
      /*!**********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/isLength.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsLengthJs(module, exports) {
        /** Used as references for various `Number` constants. */
        var MAX_SAFE_INTEGER = 9007199254740991;
        /**
         * Checks if `value` is a valid array-like length.
         *
         * **Note:** This method is loosely based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
         * @example
         *
         * _.isLength(3);
         * // => true
         *
         * _.isLength(Number.MIN_VALUE);
         * // => false
         *
         * _.isLength(Infinity);
         * // => false
         *
         * _.isLength('3');
         * // => false
         */

        function isLength(value) {
          return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }

        module.exports = isLength;
        /***/
      },

      /***/
      "../../node_modules/lodash/isObject.js":
      /*!**********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/isObject.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsObjectJs(module, exports) {
        /**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == 'object' || type == 'function');
        }

        module.exports = isObject;
        /***/
      },

      /***/
      "../../node_modules/lodash/isObjectLike.js":
      /*!**************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/isObjectLike.js ***!
        \**************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsObjectLikeJs(module, exports) {
        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */
        function isObjectLike(value) {
          return value != null && typeof value == 'object';
        }

        module.exports = isObjectLike;
        /***/
      },

      /***/
      "../../node_modules/lodash/isTypedArray.js":
      /*!**************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/isTypedArray.js ***!
        \**************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashIsTypedArrayJs(module, exports, __webpack_require__) {
        var baseIsTypedArray = __webpack_require__(
        /*! ./_baseIsTypedArray */
        "../../node_modules/lodash/_baseIsTypedArray.js"),
            baseUnary = __webpack_require__(
        /*! ./_baseUnary */
        "../../node_modules/lodash/_baseUnary.js"),
            nodeUtil = __webpack_require__(
        /*! ./_nodeUtil */
        "../../node_modules/lodash/_nodeUtil.js");
        /* Node.js helper references. */


        var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
        /**
         * Checks if `value` is classified as a typed array.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         * @example
         *
         * _.isTypedArray(new Uint8Array);
         * // => true
         *
         * _.isTypedArray([]);
         * // => false
         */

        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        module.exports = isTypedArray;
        /***/
      },

      /***/
      "../../node_modules/lodash/keys.js":
      /*!******************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/keys.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashKeysJs(module, exports, __webpack_require__) {
        var arrayLikeKeys = __webpack_require__(
        /*! ./_arrayLikeKeys */
        "../../node_modules/lodash/_arrayLikeKeys.js"),
            baseKeys = __webpack_require__(
        /*! ./_baseKeys */
        "../../node_modules/lodash/_baseKeys.js"),
            isArrayLike = __webpack_require__(
        /*! ./isArrayLike */
        "../../node_modules/lodash/isArrayLike.js");
        /**
         * Creates an array of the own enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects. See the
         * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * for more details.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keys(new Foo);
         * // => ['a', 'b'] (iteration order is not guaranteed)
         *
         * _.keys('hi');
         * // => ['0', '1']
         */


        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }

        module.exports = keys;
        /***/
      },

      /***/
      "../../node_modules/lodash/noop.js":
      /*!******************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/noop.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashNoopJs(module, exports) {
        /**
         * This method returns `undefined`.
         *
         * @static
         * @memberOf _
         * @since 2.3.0
         * @category Util
         * @example
         *
         * _.times(2, _.noop);
         * // => [undefined, undefined]
         */
        function noop() {// No operation performed.
        }

        module.exports = noop;
        /***/
      },

      /***/
      "../../node_modules/lodash/stubFalse.js":
      /*!***********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/lodash/stubFalse.js ***!
        \***********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesLodashStubFalseJs(module, exports) {
        /**
         * This method returns `false`.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {boolean} Returns `false`.
         * @example
         *
         * _.times(2, _.stubFalse);
         * // => [false, false]
         */
        function stubFalse() {
          return false;
        }

        module.exports = stubFalse;
        /***/
      },

      /***/
      "../../node_modules/node-libs-browser/node_modules/buffer/index.js":
      /*!**************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/node-libs-browser/node_modules/buffer/index.js ***!
        \**************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesNodeLibsBrowserNode_modulesBufferIndexJs(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */

        (function (global) {
          /*!
          * The buffer module from node.js, for the browser.
          *
          * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
          * @license  MIT
          */

          /* eslint-disable no-proto */
          var base64 = __webpack_require__(
          /*! base64-js */
          "../../node_modules/base64-js/index.js");

          var ieee754 = __webpack_require__(
          /*! ieee754 */
          "../../node_modules/ieee754/index.js");

          var isArray = __webpack_require__(
          /*! isarray */
          "../../node_modules/isarray/index.js");

          exports.Buffer = Buffer;
          exports.SlowBuffer = SlowBuffer;
          exports.INSPECT_MAX_BYTES = 50;
          /**
           * If `Buffer.TYPED_ARRAY_SUPPORT`:
           *   === true    Use Uint8Array implementation (fastest)
           *   === false   Use Object implementation (most compatible, even IE6)
           *
           * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
           * Opera 11.6+, iOS 4.2+.
           *
           * Due to various browser bugs, sometimes the Object implementation will be used even
           * when the browser supports typed arrays.
           *
           * Note:
           *
           *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
           *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
           *
           *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
           *
           *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
           *     incorrect length in some situations.
          
           * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
           * get the Object implementation, which is slower but behaves correctly.
           */

          Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
          /*
           * Export kMaxLength after typed array support is determined.
           */

          exports.kMaxLength = kMaxLength();

          function typedArraySupport() {
            try {
              var arr = new Uint8Array(1);
              arr.__proto__ = {
                __proto__: Uint8Array.prototype,
                foo: function foo() {
                  return 42;
                }
              };
              return arr.foo() === 42 && // typed array instances can be augmented
              typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
              arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
            } catch (e) {
              return false;
            }
          }

          function kMaxLength() {
            return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
          }

          function createBuffer(that, length) {
            if (kMaxLength() < length) {
              throw new RangeError('Invalid typed array length');
            }

            if (Buffer.TYPED_ARRAY_SUPPORT) {
              // Return an augmented `Uint8Array` instance, for best performance
              that = new Uint8Array(length);
              that.__proto__ = Buffer.prototype;
            } else {
              // Fallback: Return an object instance of the Buffer class
              if (that === null) {
                that = new Buffer(length);
              }

              that.length = length;
            }

            return that;
          }
          /**
           * The Buffer constructor returns instances of `Uint8Array` that have their
           * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
           * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
           * and the `Uint8Array` methods. Square bracket notation works as expected -- it
           * returns a single octet.
           *
           * The `Uint8Array` prototype remains unmodified.
           */


          function Buffer(arg, encodingOrOffset, length) {
            if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
              return new Buffer(arg, encodingOrOffset, length);
            } // Common case.


            if (typeof arg === 'number') {
              if (typeof encodingOrOffset === 'string') {
                throw new Error('If encoding is specified then the first argument must be a string');
              }

              return allocUnsafe(this, arg);
            }

            return from(this, arg, encodingOrOffset, length);
          }

          Buffer.poolSize = 8192; // not used by this implementation
          // TODO: Legacy, not needed anymore. Remove in next major version.

          Buffer._augment = function (arr) {
            arr.__proto__ = Buffer.prototype;
            return arr;
          };

          function from(that, value, encodingOrOffset, length) {
            if (typeof value === 'number') {
              throw new TypeError('"value" argument must not be a number');
            }

            if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
              return fromArrayBuffer(that, value, encodingOrOffset, length);
            }

            if (typeof value === 'string') {
              return fromString(that, value, encodingOrOffset);
            }

            return fromObject(that, value);
          }
          /**
           * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
           * if value is a number.
           * Buffer.from(str[, encoding])
           * Buffer.from(array)
           * Buffer.from(buffer)
           * Buffer.from(arrayBuffer[, byteOffset[, length]])
           **/


          Buffer.from = function (value, encodingOrOffset, length) {
            return from(null, value, encodingOrOffset, length);
          };

          if (Buffer.TYPED_ARRAY_SUPPORT) {
            Buffer.prototype.__proto__ = Uint8Array.prototype;
            Buffer.__proto__ = Uint8Array;

            if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
              // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
              Object.defineProperty(Buffer, Symbol.species, {
                value: null,
                configurable: true
              });
            }
          }

          function assertSize(size) {
            if (typeof size !== 'number') {
              throw new TypeError('"size" argument must be a number');
            } else if (size < 0) {
              throw new RangeError('"size" argument must not be negative');
            }
          }

          function alloc(that, size, fill, encoding) {
            assertSize(size);

            if (size <= 0) {
              return createBuffer(that, size);
            }

            if (fill !== undefined) {
              // Only pay attention to encoding if it's a string. This
              // prevents accidentally sending in a number that would
              // be interpretted as a start offset.
              return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
            }

            return createBuffer(that, size);
          }
          /**
           * Creates a new filled Buffer instance.
           * alloc(size[, fill[, encoding]])
           **/


          Buffer.alloc = function (size, fill, encoding) {
            return alloc(null, size, fill, encoding);
          };

          function allocUnsafe(that, size) {
            assertSize(size);
            that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);

            if (!Buffer.TYPED_ARRAY_SUPPORT) {
              for (var i = 0; i < size; ++i) {
                that[i] = 0;
              }
            }

            return that;
          }
          /**
           * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
           * */


          Buffer.allocUnsafe = function (size) {
            return allocUnsafe(null, size);
          };
          /**
           * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
           */


          Buffer.allocUnsafeSlow = function (size) {
            return allocUnsafe(null, size);
          };

          function fromString(that, string, encoding) {
            if (typeof encoding !== 'string' || encoding === '') {
              encoding = 'utf8';
            }

            if (!Buffer.isEncoding(encoding)) {
              throw new TypeError('"encoding" must be a valid string encoding');
            }

            var length = byteLength(string, encoding) | 0;
            that = createBuffer(that, length);
            var actual = that.write(string, encoding);

            if (actual !== length) {
              // Writing a hex string, for example, that contains invalid characters will
              // cause everything after the first invalid character to be ignored. (e.g.
              // 'abxxcd' will be treated as 'ab')
              that = that.slice(0, actual);
            }

            return that;
          }

          function fromArrayLike(that, array) {
            var length = array.length < 0 ? 0 : checked(array.length) | 0;
            that = createBuffer(that, length);

            for (var i = 0; i < length; i += 1) {
              that[i] = array[i] & 255;
            }

            return that;
          }

          function fromArrayBuffer(that, array, byteOffset, length) {
            array.byteLength; // this throws if `array` is not a valid ArrayBuffer

            if (byteOffset < 0 || array.byteLength < byteOffset) {
              throw new RangeError('\'offset\' is out of bounds');
            }

            if (array.byteLength < byteOffset + (length || 0)) {
              throw new RangeError('\'length\' is out of bounds');
            }

            if (byteOffset === undefined && length === undefined) {
              array = new Uint8Array(array);
            } else if (length === undefined) {
              array = new Uint8Array(array, byteOffset);
            } else {
              array = new Uint8Array(array, byteOffset, length);
            }

            if (Buffer.TYPED_ARRAY_SUPPORT) {
              // Return an augmented `Uint8Array` instance, for best performance
              that = array;
              that.__proto__ = Buffer.prototype;
            } else {
              // Fallback: Return an object instance of the Buffer class
              that = fromArrayLike(that, array);
            }

            return that;
          }

          function fromObject(that, obj) {
            if (Buffer.isBuffer(obj)) {
              var len = checked(obj.length) | 0;
              that = createBuffer(that, len);

              if (that.length === 0) {
                return that;
              }

              obj.copy(that, 0, 0, len);
              return that;
            }

            if (obj) {
              if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
                if (typeof obj.length !== 'number' || isnan(obj.length)) {
                  return createBuffer(that, 0);
                }

                return fromArrayLike(that, obj);
              }

              if (obj.type === 'Buffer' && isArray(obj.data)) {
                return fromArrayLike(that, obj.data);
              }
            }

            throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
          }

          function checked(length) {
            // Note: cannot use `length < kMaxLength()` here because that fails when
            // length is NaN (which is otherwise coerced to zero.)
            if (length >= kMaxLength()) {
              throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
            }

            return length | 0;
          }

          function SlowBuffer(length) {
            if (+length != length) {
              // eslint-disable-line eqeqeq
              length = 0;
            }

            return Buffer.alloc(+length);
          }

          Buffer.isBuffer = function isBuffer(b) {
            return !!(b != null && b._isBuffer);
          };

          Buffer.compare = function compare(a, b) {
            if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
              throw new TypeError('Arguments must be Buffers');
            }

            if (a === b) return 0;
            var x = a.length;
            var y = b.length;

            for (var i = 0, len = Math.min(x, y); i < len; ++i) {
              if (a[i] !== b[i]) {
                x = a[i];
                y = b[i];
                break;
              }
            }

            if (x < y) return -1;
            if (y < x) return 1;
            return 0;
          };

          Buffer.isEncoding = function isEncoding(encoding) {
            switch (String(encoding).toLowerCase()) {
              case 'hex':
              case 'utf8':
              case 'utf-8':
              case 'ascii':
              case 'latin1':
              case 'binary':
              case 'base64':
              case 'ucs2':
              case 'ucs-2':
              case 'utf16le':
              case 'utf-16le':
                return true;

              default:
                return false;
            }
          };

          Buffer.concat = function concat(list, length) {
            if (!isArray(list)) {
              throw new TypeError('"list" argument must be an Array of Buffers');
            }

            if (list.length === 0) {
              return Buffer.alloc(0);
            }

            var i;

            if (length === undefined) {
              length = 0;

              for (i = 0; i < list.length; ++i) {
                length += list[i].length;
              }
            }

            var buffer = Buffer.allocUnsafe(length);
            var pos = 0;

            for (i = 0; i < list.length; ++i) {
              var buf = list[i];

              if (!Buffer.isBuffer(buf)) {
                throw new TypeError('"list" argument must be an Array of Buffers');
              }

              buf.copy(buffer, pos);
              pos += buf.length;
            }

            return buffer;
          };

          function byteLength(string, encoding) {
            if (Buffer.isBuffer(string)) {
              return string.length;
            }

            if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
              return string.byteLength;
            }

            if (typeof string !== 'string') {
              string = '' + string;
            }

            var len = string.length;
            if (len === 0) return 0; // Use a for loop to avoid recursion

            var loweredCase = false;

            for (;;) {
              switch (encoding) {
                case 'ascii':
                case 'latin1':
                case 'binary':
                  return len;

                case 'utf8':
                case 'utf-8':
                case undefined:
                  return utf8ToBytes(string).length;

                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                  return len * 2;

                case 'hex':
                  return len >>> 1;

                case 'base64':
                  return base64ToBytes(string).length;

                default:
                  if (loweredCase) return utf8ToBytes(string).length; // assume utf8

                  encoding = ('' + encoding).toLowerCase();
                  loweredCase = true;
              }
            }
          }

          Buffer.byteLength = byteLength;

          function slowToString(encoding, start, end) {
            var loweredCase = false; // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
            // property of a typed array.
            // This behaves neither like String nor Uint8Array in that we set start/end
            // to their upper/lower bounds if the value passed is out of range.
            // undefined is handled specially as per ECMA-262 6th Edition,
            // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.

            if (start === undefined || start < 0) {
              start = 0;
            } // Return early if start > this.length. Done here to prevent potential uint32
            // coercion fail below.


            if (start > this.length) {
              return '';
            }

            if (end === undefined || end > this.length) {
              end = this.length;
            }

            if (end <= 0) {
              return '';
            } // Force coersion to uint32. This will also coerce falsey/NaN values to 0.


            end >>>= 0;
            start >>>= 0;

            if (end <= start) {
              return '';
            }

            if (!encoding) encoding = 'utf8';

            while (true) {
              switch (encoding) {
                case 'hex':
                  return hexSlice(this, start, end);

                case 'utf8':
                case 'utf-8':
                  return utf8Slice(this, start, end);

                case 'ascii':
                  return asciiSlice(this, start, end);

                case 'latin1':
                case 'binary':
                  return latin1Slice(this, start, end);

                case 'base64':
                  return base64Slice(this, start, end);

                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                  return utf16leSlice(this, start, end);

                default:
                  if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                  encoding = (encoding + '').toLowerCase();
                  loweredCase = true;
              }
            }
          } // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
          // Buffer instances.


          Buffer.prototype._isBuffer = true;

          function swap(b, n, m) {
            var i = b[n];
            b[n] = b[m];
            b[m] = i;
          }

          Buffer.prototype.swap16 = function swap16() {
            var len = this.length;

            if (len % 2 !== 0) {
              throw new RangeError('Buffer size must be a multiple of 16-bits');
            }

            for (var i = 0; i < len; i += 2) {
              swap(this, i, i + 1);
            }

            return this;
          };

          Buffer.prototype.swap32 = function swap32() {
            var len = this.length;

            if (len % 4 !== 0) {
              throw new RangeError('Buffer size must be a multiple of 32-bits');
            }

            for (var i = 0; i < len; i += 4) {
              swap(this, i, i + 3);
              swap(this, i + 1, i + 2);
            }

            return this;
          };

          Buffer.prototype.swap64 = function swap64() {
            var len = this.length;

            if (len % 8 !== 0) {
              throw new RangeError('Buffer size must be a multiple of 64-bits');
            }

            for (var i = 0; i < len; i += 8) {
              swap(this, i, i + 7);
              swap(this, i + 1, i + 6);
              swap(this, i + 2, i + 5);
              swap(this, i + 3, i + 4);
            }

            return this;
          };

          Buffer.prototype.toString = function toString() {
            var length = this.length | 0;
            if (length === 0) return '';
            if (arguments.length === 0) return utf8Slice(this, 0, length);
            return slowToString.apply(this, arguments);
          };

          Buffer.prototype.equals = function equals(b) {
            if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
            if (this === b) return true;
            return Buffer.compare(this, b) === 0;
          };

          Buffer.prototype.inspect = function inspect() {
            var str = '';
            var max = exports.INSPECT_MAX_BYTES;

            if (this.length > 0) {
              str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
              if (this.length > max) str += ' ... ';
            }

            return '<Buffer ' + str + '>';
          };

          Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
            if (!Buffer.isBuffer(target)) {
              throw new TypeError('Argument must be a Buffer');
            }

            if (start === undefined) {
              start = 0;
            }

            if (end === undefined) {
              end = target ? target.length : 0;
            }

            if (thisStart === undefined) {
              thisStart = 0;
            }

            if (thisEnd === undefined) {
              thisEnd = this.length;
            }

            if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
              throw new RangeError('out of range index');
            }

            if (thisStart >= thisEnd && start >= end) {
              return 0;
            }

            if (thisStart >= thisEnd) {
              return -1;
            }

            if (start >= end) {
              return 1;
            }

            start >>>= 0;
            end >>>= 0;
            thisStart >>>= 0;
            thisEnd >>>= 0;
            if (this === target) return 0;
            var x = thisEnd - thisStart;
            var y = end - start;
            var len = Math.min(x, y);
            var thisCopy = this.slice(thisStart, thisEnd);
            var targetCopy = target.slice(start, end);

            for (var i = 0; i < len; ++i) {
              if (thisCopy[i] !== targetCopy[i]) {
                x = thisCopy[i];
                y = targetCopy[i];
                break;
              }
            }

            if (x < y) return -1;
            if (y < x) return 1;
            return 0;
          }; // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
          // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
          //
          // Arguments:
          // - buffer - a Buffer to search
          // - val - a string, Buffer, or number
          // - byteOffset - an index into `buffer`; will be clamped to an int32
          // - encoding - an optional encoding, relevant is val is a string
          // - dir - true for indexOf, false for lastIndexOf


          function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
            // Empty buffer means no match
            if (buffer.length === 0) return -1; // Normalize byteOffset

            if (typeof byteOffset === 'string') {
              encoding = byteOffset;
              byteOffset = 0;
            } else if (byteOffset > 0x7fffffff) {
              byteOffset = 0x7fffffff;
            } else if (byteOffset < -0x80000000) {
              byteOffset = -0x80000000;
            }

            byteOffset = +byteOffset; // Coerce to Number.

            if (isNaN(byteOffset)) {
              // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
              byteOffset = dir ? 0 : buffer.length - 1;
            } // Normalize byteOffset: negative offsets start from the end of the buffer


            if (byteOffset < 0) byteOffset = buffer.length + byteOffset;

            if (byteOffset >= buffer.length) {
              if (dir) return -1;else byteOffset = buffer.length - 1;
            } else if (byteOffset < 0) {
              if (dir) byteOffset = 0;else return -1;
            } // Normalize val


            if (typeof val === 'string') {
              val = Buffer.from(val, encoding);
            } // Finally, search either indexOf (if dir is true) or lastIndexOf


            if (Buffer.isBuffer(val)) {
              // Special case: looking for empty string/buffer always fails
              if (val.length === 0) {
                return -1;
              }

              return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
            } else if (typeof val === 'number') {
              val = val & 0xFF; // Search for a byte value [0-255]

              if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
                if (dir) {
                  return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                } else {
                  return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
                }
              }

              return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
            }

            throw new TypeError('val must be string, number or Buffer');
          }

          function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
            var indexSize = 1;
            var arrLength = arr.length;
            var valLength = val.length;

            if (encoding !== undefined) {
              encoding = String(encoding).toLowerCase();

              if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
                if (arr.length < 2 || val.length < 2) {
                  return -1;
                }

                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
              }
            }

            function read(buf, i) {
              if (indexSize === 1) {
                return buf[i];
              } else {
                return buf.readUInt16BE(i * indexSize);
              }
            }

            var i;

            if (dir) {
              var foundIndex = -1;

              for (i = byteOffset; i < arrLength; i++) {
                if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                  if (foundIndex === -1) foundIndex = i;
                  if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                } else {
                  if (foundIndex !== -1) i -= i - foundIndex;
                  foundIndex = -1;
                }
              }
            } else {
              if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;

              for (i = byteOffset; i >= 0; i--) {
                var found = true;

                for (var j = 0; j < valLength; j++) {
                  if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                  }
                }

                if (found) return i;
              }
            }

            return -1;
          }

          Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
            return this.indexOf(val, byteOffset, encoding) !== -1;
          };

          Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
            return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
          };

          Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
            return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
          };

          function hexWrite(buf, string, offset, length) {
            offset = Number(offset) || 0;
            var remaining = buf.length - offset;

            if (!length) {
              length = remaining;
            } else {
              length = Number(length);

              if (length > remaining) {
                length = remaining;
              }
            } // must be an even number of digits


            var strLen = string.length;
            if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');

            if (length > strLen / 2) {
              length = strLen / 2;
            }

            for (var i = 0; i < length; ++i) {
              var parsed = parseInt(string.substr(i * 2, 2), 16);
              if (isNaN(parsed)) return i;
              buf[offset + i] = parsed;
            }

            return i;
          }

          function utf8Write(buf, string, offset, length) {
            return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
          }

          function asciiWrite(buf, string, offset, length) {
            return blitBuffer(asciiToBytes(string), buf, offset, length);
          }

          function latin1Write(buf, string, offset, length) {
            return asciiWrite(buf, string, offset, length);
          }

          function base64Write(buf, string, offset, length) {
            return blitBuffer(base64ToBytes(string), buf, offset, length);
          }

          function ucs2Write(buf, string, offset, length) {
            return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
          }

          Buffer.prototype.write = function write(string, offset, length, encoding) {
            // Buffer#write(string)
            if (offset === undefined) {
              encoding = 'utf8';
              length = this.length;
              offset = 0; // Buffer#write(string, encoding)
            } else if (length === undefined && typeof offset === 'string') {
              encoding = offset;
              length = this.length;
              offset = 0; // Buffer#write(string, offset[, length][, encoding])
            } else if (isFinite(offset)) {
              offset = offset | 0;

              if (isFinite(length)) {
                length = length | 0;
                if (encoding === undefined) encoding = 'utf8';
              } else {
                encoding = length;
                length = undefined;
              } // legacy write(string, encoding, offset, length) - remove in v0.13

            } else {
              throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
            }

            var remaining = this.length - offset;
            if (length === undefined || length > remaining) length = remaining;

            if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
              throw new RangeError('Attempt to write outside buffer bounds');
            }

            if (!encoding) encoding = 'utf8';
            var loweredCase = false;

            for (;;) {
              switch (encoding) {
                case 'hex':
                  return hexWrite(this, string, offset, length);

                case 'utf8':
                case 'utf-8':
                  return utf8Write(this, string, offset, length);

                case 'ascii':
                  return asciiWrite(this, string, offset, length);

                case 'latin1':
                case 'binary':
                  return latin1Write(this, string, offset, length);

                case 'base64':
                  // Warning: maxLength not taken into account in base64Write
                  return base64Write(this, string, offset, length);

                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                  return ucs2Write(this, string, offset, length);

                default:
                  if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                  encoding = ('' + encoding).toLowerCase();
                  loweredCase = true;
              }
            }
          };

          Buffer.prototype.toJSON = function toJSON() {
            return {
              type: 'Buffer',
              data: Array.prototype.slice.call(this._arr || this, 0)
            };
          };

          function base64Slice(buf, start, end) {
            if (start === 0 && end === buf.length) {
              return base64.fromByteArray(buf);
            } else {
              return base64.fromByteArray(buf.slice(start, end));
            }
          }

          function utf8Slice(buf, start, end) {
            end = Math.min(buf.length, end);
            var res = [];
            var i = start;

            while (i < end) {
              var firstByte = buf[i];
              var codePoint = null;
              var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

              if (i + bytesPerSequence <= end) {
                var secondByte, thirdByte, fourthByte, tempCodePoint;

                switch (bytesPerSequence) {
                  case 1:
                    if (firstByte < 0x80) {
                      codePoint = firstByte;
                    }

                    break;

                  case 2:
                    secondByte = buf[i + 1];

                    if ((secondByte & 0xC0) === 0x80) {
                      tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;

                      if (tempCodePoint > 0x7F) {
                        codePoint = tempCodePoint;
                      }
                    }

                    break;

                  case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];

                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                      tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;

                      if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                        codePoint = tempCodePoint;
                      }
                    }

                    break;

                  case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];

                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                      tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;

                      if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                        codePoint = tempCodePoint;
                      }
                    }

                }
              }

              if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD;
                bytesPerSequence = 1;
              } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                codePoint = 0xDC00 | codePoint & 0x3FF;
              }

              res.push(codePoint);
              i += bytesPerSequence;
            }

            return decodeCodePointsArray(res);
          } // Based on http://stackoverflow.com/a/22747272/680742, the browser with
          // the lowest limit is Chrome, with 0x10000 args.
          // We go 1 magnitude less, for safety


          var MAX_ARGUMENTS_LENGTH = 0x1000;

          function decodeCodePointsArray(codePoints) {
            var len = codePoints.length;

            if (len <= MAX_ARGUMENTS_LENGTH) {
              return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
            } // Decode in chunks to avoid "call stack size exceeded".


            var res = '';
            var i = 0;

            while (i < len) {
              res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
            }

            return res;
          }

          function asciiSlice(buf, start, end) {
            var ret = '';
            end = Math.min(buf.length, end);

            for (var i = start; i < end; ++i) {
              ret += String.fromCharCode(buf[i] & 0x7F);
            }

            return ret;
          }

          function latin1Slice(buf, start, end) {
            var ret = '';
            end = Math.min(buf.length, end);

            for (var i = start; i < end; ++i) {
              ret += String.fromCharCode(buf[i]);
            }

            return ret;
          }

          function hexSlice(buf, start, end) {
            var len = buf.length;
            if (!start || start < 0) start = 0;
            if (!end || end < 0 || end > len) end = len;
            var out = '';

            for (var i = start; i < end; ++i) {
              out += toHex(buf[i]);
            }

            return out;
          }

          function utf16leSlice(buf, start, end) {
            var bytes = buf.slice(start, end);
            var res = '';

            for (var i = 0; i < bytes.length; i += 2) {
              res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
            }

            return res;
          }

          Buffer.prototype.slice = function slice(start, end) {
            var len = this.length;
            start = ~~start;
            end = end === undefined ? len : ~~end;

            if (start < 0) {
              start += len;
              if (start < 0) start = 0;
            } else if (start > len) {
              start = len;
            }

            if (end < 0) {
              end += len;
              if (end < 0) end = 0;
            } else if (end > len) {
              end = len;
            }

            if (end < start) end = start;
            var newBuf;

            if (Buffer.TYPED_ARRAY_SUPPORT) {
              newBuf = this.subarray(start, end);
              newBuf.__proto__ = Buffer.prototype;
            } else {
              var sliceLen = end - start;
              newBuf = new Buffer(sliceLen, undefined);

              for (var i = 0; i < sliceLen; ++i) {
                newBuf[i] = this[i + start];
              }
            }

            return newBuf;
          };
          /*
           * Need to make sure that buffer isn't trying to write out of bounds.
           */


          function checkOffset(offset, ext, length) {
            if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
            if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
          }

          Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
            offset = offset | 0;
            byteLength = byteLength | 0;
            if (!noAssert) checkOffset(offset, byteLength, this.length);
            var val = this[offset];
            var mul = 1;
            var i = 0;

            while (++i < byteLength && (mul *= 0x100)) {
              val += this[offset + i] * mul;
            }

            return val;
          };

          Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
            offset = offset | 0;
            byteLength = byteLength | 0;

            if (!noAssert) {
              checkOffset(offset, byteLength, this.length);
            }

            var val = this[offset + --byteLength];
            var mul = 1;

            while (byteLength > 0 && (mul *= 0x100)) {
              val += this[offset + --byteLength] * mul;
            }

            return val;
          };

          Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 1, this.length);
            return this[offset];
          };

          Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 2, this.length);
            return this[offset] | this[offset + 1] << 8;
          };

          Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 2, this.length);
            return this[offset] << 8 | this[offset + 1];
          };

          Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 4, this.length);
            return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
          };

          Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 4, this.length);
            return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
          };

          Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
            offset = offset | 0;
            byteLength = byteLength | 0;
            if (!noAssert) checkOffset(offset, byteLength, this.length);
            var val = this[offset];
            var mul = 1;
            var i = 0;

            while (++i < byteLength && (mul *= 0x100)) {
              val += this[offset + i] * mul;
            }

            mul *= 0x80;
            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
            return val;
          };

          Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
            offset = offset | 0;
            byteLength = byteLength | 0;
            if (!noAssert) checkOffset(offset, byteLength, this.length);
            var i = byteLength;
            var mul = 1;
            var val = this[offset + --i];

            while (i > 0 && (mul *= 0x100)) {
              val += this[offset + --i] * mul;
            }

            mul *= 0x80;
            if (val >= mul) val -= Math.pow(2, 8 * byteLength);
            return val;
          };

          Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 1, this.length);
            if (!(this[offset] & 0x80)) return this[offset];
            return (0xff - this[offset] + 1) * -1;
          };

          Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 2, this.length);
            var val = this[offset] | this[offset + 1] << 8;
            return val & 0x8000 ? val | 0xFFFF0000 : val;
          };

          Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 2, this.length);
            var val = this[offset + 1] | this[offset] << 8;
            return val & 0x8000 ? val | 0xFFFF0000 : val;
          };

          Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 4, this.length);
            return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
          };

          Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 4, this.length);
            return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
          };

          Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 4, this.length);
            return ieee754.read(this, offset, true, 23, 4);
          };

          Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 4, this.length);
            return ieee754.read(this, offset, false, 23, 4);
          };

          Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 8, this.length);
            return ieee754.read(this, offset, true, 52, 8);
          };

          Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
            if (!noAssert) checkOffset(offset, 8, this.length);
            return ieee754.read(this, offset, false, 52, 8);
          };

          function checkInt(buf, value, offset, ext, max, min) {
            if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
            if (offset + ext > buf.length) throw new RangeError('Index out of range');
          }

          Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
            value = +value;
            offset = offset | 0;
            byteLength = byteLength | 0;

            if (!noAssert) {
              var maxBytes = Math.pow(2, 8 * byteLength) - 1;
              checkInt(this, value, offset, byteLength, maxBytes, 0);
            }

            var mul = 1;
            var i = 0;
            this[offset] = value & 0xFF;

            while (++i < byteLength && (mul *= 0x100)) {
              this[offset + i] = value / mul & 0xFF;
            }

            return offset + byteLength;
          };

          Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
            value = +value;
            offset = offset | 0;
            byteLength = byteLength | 0;

            if (!noAssert) {
              var maxBytes = Math.pow(2, 8 * byteLength) - 1;
              checkInt(this, value, offset, byteLength, maxBytes, 0);
            }

            var i = byteLength - 1;
            var mul = 1;
            this[offset + i] = value & 0xFF;

            while (--i >= 0 && (mul *= 0x100)) {
              this[offset + i] = value / mul & 0xFF;
            }

            return offset + byteLength;
          };

          Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
            value = +value;
            offset = offset | 0;
            if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
            if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
            this[offset] = value & 0xff;
            return offset + 1;
          };

          function objectWriteUInt16(buf, value, offset, littleEndian) {
            if (value < 0) value = 0xffff + value + 1;

            for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
              buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
            }
          }

          Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
            value = +value;
            offset = offset | 0;
            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);

            if (Buffer.TYPED_ARRAY_SUPPORT) {
              this[offset] = value & 0xff;
              this[offset + 1] = value >>> 8;
            } else {
              objectWriteUInt16(this, value, offset, true);
            }

            return offset + 2;
          };

          Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
            value = +value;
            offset = offset | 0;
            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);

            if (Buffer.TYPED_ARRAY_SUPPORT) {
              this[offset] = value >>> 8;
              this[offset + 1] = value & 0xff;
            } else {
              objectWriteUInt16(this, value, offset, false);
            }

            return offset + 2;
          };

          function objectWriteUInt32(buf, value, offset, littleEndian) {
            if (value < 0) value = 0xffffffff + value + 1;

            for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
              buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
            }
          }

          Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
            value = +value;
            offset = offset | 0;
            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);

            if (Buffer.TYPED_ARRAY_SUPPORT) {
              this[offset + 3] = value >>> 24;
              this[offset + 2] = value >>> 16;
              this[offset + 1] = value >>> 8;
              this[offset] = value & 0xff;
            } else {
              objectWriteUInt32(this, value, offset, true);
            }

            return offset + 4;
          };

          Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
            value = +value;
            offset = offset | 0;
            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);

            if (Buffer.TYPED_ARRAY_SUPPORT) {
              this[offset] = value >>> 24;
              this[offset + 1] = value >>> 16;
              this[offset + 2] = value >>> 8;
              this[offset + 3] = value & 0xff;
            } else {
              objectWriteUInt32(this, value, offset, false);
            }

            return offset + 4;
          };

          Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
            value = +value;
            offset = offset | 0;

            if (!noAssert) {
              var limit = Math.pow(2, 8 * byteLength - 1);
              checkInt(this, value, offset, byteLength, limit - 1, -limit);
            }

            var i = 0;
            var mul = 1;
            var sub = 0;
            this[offset] = value & 0xFF;

            while (++i < byteLength && (mul *= 0x100)) {
              if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
                sub = 1;
              }

              this[offset + i] = (value / mul >> 0) - sub & 0xFF;
            }

            return offset + byteLength;
          };

          Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
            value = +value;
            offset = offset | 0;

            if (!noAssert) {
              var limit = Math.pow(2, 8 * byteLength - 1);
              checkInt(this, value, offset, byteLength, limit - 1, -limit);
            }

            var i = byteLength - 1;
            var mul = 1;
            var sub = 0;
            this[offset + i] = value & 0xFF;

            while (--i >= 0 && (mul *= 0x100)) {
              if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
                sub = 1;
              }

              this[offset + i] = (value / mul >> 0) - sub & 0xFF;
            }

            return offset + byteLength;
          };

          Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
            value = +value;
            offset = offset | 0;
            if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
            if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
            if (value < 0) value = 0xff + value + 1;
            this[offset] = value & 0xff;
            return offset + 1;
          };

          Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
            value = +value;
            offset = offset | 0;
            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);

            if (Buffer.TYPED_ARRAY_SUPPORT) {
              this[offset] = value & 0xff;
              this[offset + 1] = value >>> 8;
            } else {
              objectWriteUInt16(this, value, offset, true);
            }

            return offset + 2;
          };

          Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
            value = +value;
            offset = offset | 0;
            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);

            if (Buffer.TYPED_ARRAY_SUPPORT) {
              this[offset] = value >>> 8;
              this[offset + 1] = value & 0xff;
            } else {
              objectWriteUInt16(this, value, offset, false);
            }

            return offset + 2;
          };

          Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
            value = +value;
            offset = offset | 0;
            if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);

            if (Buffer.TYPED_ARRAY_SUPPORT) {
              this[offset] = value & 0xff;
              this[offset + 1] = value >>> 8;
              this[offset + 2] = value >>> 16;
              this[offset + 3] = value >>> 24;
            } else {
              objectWriteUInt32(this, value, offset, true);
            }

            return offset + 4;
          };

          Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
            value = +value;
            offset = offset | 0;
            if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
            if (value < 0) value = 0xffffffff + value + 1;

            if (Buffer.TYPED_ARRAY_SUPPORT) {
              this[offset] = value >>> 24;
              this[offset + 1] = value >>> 16;
              this[offset + 2] = value >>> 8;
              this[offset + 3] = value & 0xff;
            } else {
              objectWriteUInt32(this, value, offset, false);
            }

            return offset + 4;
          };

          function checkIEEE754(buf, value, offset, ext, max, min) {
            if (offset + ext > buf.length) throw new RangeError('Index out of range');
            if (offset < 0) throw new RangeError('Index out of range');
          }

          function writeFloat(buf, value, offset, littleEndian, noAssert) {
            if (!noAssert) {
              checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
            }

            ieee754.write(buf, value, offset, littleEndian, 23, 4);
            return offset + 4;
          }

          Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
            return writeFloat(this, value, offset, true, noAssert);
          };

          Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
            return writeFloat(this, value, offset, false, noAssert);
          };

          function writeDouble(buf, value, offset, littleEndian, noAssert) {
            if (!noAssert) {
              checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
            }

            ieee754.write(buf, value, offset, littleEndian, 52, 8);
            return offset + 8;
          }

          Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
            return writeDouble(this, value, offset, true, noAssert);
          };

          Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
            return writeDouble(this, value, offset, false, noAssert);
          }; // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)


          Buffer.prototype.copy = function copy(target, targetStart, start, end) {
            if (!start) start = 0;
            if (!end && end !== 0) end = this.length;
            if (targetStart >= target.length) targetStart = target.length;
            if (!targetStart) targetStart = 0;
            if (end > 0 && end < start) end = start; // Copy 0 bytes; we're done

            if (end === start) return 0;
            if (target.length === 0 || this.length === 0) return 0; // Fatal error conditions

            if (targetStart < 0) {
              throw new RangeError('targetStart out of bounds');
            }

            if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
            if (end < 0) throw new RangeError('sourceEnd out of bounds'); // Are we oob?

            if (end > this.length) end = this.length;

            if (target.length - targetStart < end - start) {
              end = target.length - targetStart + start;
            }

            var len = end - start;
            var i;

            if (this === target && start < targetStart && targetStart < end) {
              // descending copy from end
              for (i = len - 1; i >= 0; --i) {
                target[i + targetStart] = this[i + start];
              }
            } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
              // ascending copy from start
              for (i = 0; i < len; ++i) {
                target[i + targetStart] = this[i + start];
              }
            } else {
              Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
            }

            return len;
          }; // Usage:
          //    buffer.fill(number[, offset[, end]])
          //    buffer.fill(buffer[, offset[, end]])
          //    buffer.fill(string[, offset[, end]][, encoding])


          Buffer.prototype.fill = function fill(val, start, end, encoding) {
            // Handle string cases:
            if (typeof val === 'string') {
              if (typeof start === 'string') {
                encoding = start;
                start = 0;
                end = this.length;
              } else if (typeof end === 'string') {
                encoding = end;
                end = this.length;
              }

              if (val.length === 1) {
                var code = val.charCodeAt(0);

                if (code < 256) {
                  val = code;
                }
              }

              if (encoding !== undefined && typeof encoding !== 'string') {
                throw new TypeError('encoding must be a string');
              }

              if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
                throw new TypeError('Unknown encoding: ' + encoding);
              }
            } else if (typeof val === 'number') {
              val = val & 255;
            } // Invalid ranges are not set to a default, so can range check early.


            if (start < 0 || this.length < start || this.length < end) {
              throw new RangeError('Out of range index');
            }

            if (end <= start) {
              return this;
            }

            start = start >>> 0;
            end = end === undefined ? this.length : end >>> 0;
            if (!val) val = 0;
            var i;

            if (typeof val === 'number') {
              for (i = start; i < end; ++i) {
                this[i] = val;
              }
            } else {
              var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
              var len = bytes.length;

              for (i = 0; i < end - start; ++i) {
                this[i + start] = bytes[i % len];
              }
            }

            return this;
          }; // HELPER FUNCTIONS
          // ================


          var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

          function base64clean(str) {
            // Node strips out invalid characters like \n and \t from the string, base64-js does not
            str = stringtrim(str).replace(INVALID_BASE64_RE, ''); // Node converts strings with length < 2 to ''

            if (str.length < 2) return ''; // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not

            while (str.length % 4 !== 0) {
              str = str + '=';
            }

            return str;
          }

          function stringtrim(str) {
            if (str.trim) return str.trim();
            return str.replace(/^\s+|\s+$/g, '');
          }

          function toHex(n) {
            if (n < 16) return '0' + n.toString(16);
            return n.toString(16);
          }

          function utf8ToBytes(string, units) {
            units = units || Infinity;
            var codePoint;
            var length = string.length;
            var leadSurrogate = null;
            var bytes = [];

            for (var i = 0; i < length; ++i) {
              codePoint = string.charCodeAt(i); // is surrogate component

              if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                  // no lead yet
                  if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                  } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                  } // valid lead


                  leadSurrogate = codePoint;
                  continue;
                } // 2 leads in a row


                if (codePoint < 0xDC00) {
                  if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                  leadSurrogate = codePoint;
                  continue;
                } // valid surrogate pair


                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
              } else if (leadSurrogate) {
                // valid bmp char, but last char was a lead
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
              }

              leadSurrogate = null; // encode utf8

              if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
              } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
              } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
              } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
              } else {
                throw new Error('Invalid code point');
              }
            }

            return bytes;
          }

          function asciiToBytes(str) {
            var byteArray = [];

            for (var i = 0; i < str.length; ++i) {
              // Node's code seems to be doing this and not & 0x7F..
              byteArray.push(str.charCodeAt(i) & 0xFF);
            }

            return byteArray;
          }

          function utf16leToBytes(str, units) {
            var c, hi, lo;
            var byteArray = [];

            for (var i = 0; i < str.length; ++i) {
              if ((units -= 2) < 0) break;
              c = str.charCodeAt(i);
              hi = c >> 8;
              lo = c % 256;
              byteArray.push(lo);
              byteArray.push(hi);
            }

            return byteArray;
          }

          function base64ToBytes(str) {
            return base64.toByteArray(base64clean(str));
          }

          function blitBuffer(src, dst, offset, length) {
            for (var i = 0; i < length; ++i) {
              if (i + offset >= dst.length || i >= src.length) break;
              dst[i + offset] = src[i];
            }

            return i;
          }

          function isnan(val) {
            return val !== val; // eslint-disable-line no-self-compare
          }
          /* WEBPACK VAR INJECTION */

        }).call(this, __webpack_require__(
        /*! ./../../../../packages/store/node_modules/webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"));
        /***/
      },

      /***/
      "../../node_modules/process/browser.js":
      /*!**********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/process/browser.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesProcessBrowserJs(module, exports) {
        // shim for using process in browser
        var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.

        var cachedSetTimeout;
        var cachedClearTimeout;

        function defaultSetTimout() {
          throw new Error('setTimeout has not been defined');
        }

        function defaultClearTimeout() {
          throw new Error('clearTimeout has not been defined');
        }

        (function () {
          try {
            if (typeof setTimeout === 'function') {
              cachedSetTimeout = setTimeout;
            } else {
              cachedSetTimeout = defaultSetTimout;
            }
          } catch (e) {
            cachedSetTimeout = defaultSetTimout;
          }

          try {
            if (typeof clearTimeout === 'function') {
              cachedClearTimeout = clearTimeout;
            } else {
              cachedClearTimeout = defaultClearTimeout;
            }
          } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
          }
        })();

        function runTimeout(fun) {
          if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
          } // if setTimeout wasn't available but was latter defined


          if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
          }

          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
            }
          }
        }

        function runClearTimeout(marker) {
          if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
          } // if clearTimeout wasn't available but was latter defined


          if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
          }

          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
            }
          }
        }

        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;

        function cleanUpNextTick() {
          if (!draining || !currentQueue) {
            return;
          }

          draining = false;

          if (currentQueue.length) {
            queue = currentQueue.concat(queue);
          } else {
            queueIndex = -1;
          }

          if (queue.length) {
            drainQueue();
          }
        }

        function drainQueue() {
          if (draining) {
            return;
          }

          var timeout = runTimeout(cleanUpNextTick);
          draining = true;
          var len = queue.length;

          while (len) {
            currentQueue = queue;
            queue = [];

            while (++queueIndex < len) {
              if (currentQueue) {
                currentQueue[queueIndex].run();
              }
            }

            queueIndex = -1;
            len = queue.length;
          }

          currentQueue = null;
          draining = false;
          runClearTimeout(timeout);
        }

        process.nextTick = function (fun) {
          var args = new Array(arguments.length - 1);

          if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
            }
          }

          queue.push(new Item(fun, args));

          if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
          }
        }; // v8 likes predictible objects


        function Item(fun, array) {
          this.fun = fun;
          this.array = array;
        }

        Item.prototype.run = function () {
          this.fun.apply(null, this.array);
        };

        process.title = 'browser';
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ''; // empty string to avoid regexp issues

        process.versions = {};

        function noop() {}

        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;

        process.listeners = function (name) {
          return [];
        };

        process.binding = function (name) {
          throw new Error('process.binding is not supported');
        };

        process.cwd = function () {
          return '/';
        };

        process.chdir = function (dir) {
          throw new Error('process.chdir is not supported');
        };

        process.umask = function () {
          return 0;
        };
        /***/

      },

      /***/
      "../../node_modules/redux-saga/es/effects.js":
      /*!****************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/redux-saga/es/effects.js ***!
        \****************************************************************************/

      /*! exports provided: take, takem, put, all, race, call, apply, cps, fork, spawn, join, cancel, select, actionChannel, cancelled, flush, getContext, setContext, takeEvery, takeLatest, throttle */

      /***/
      function node_modulesReduxSagaEsEffectsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _internal_io__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./internal/io */
        "../../node_modules/redux-saga/es/internal/io.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "take", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["take"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "takem", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["takem"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "put", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["put"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "all", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["all"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "race", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["race"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "call", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["call"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "apply", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["apply"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "cps", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["cps"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "fork", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["fork"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "spawn", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["spawn"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "join", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["join"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "cancel", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["cancel"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "select", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["select"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "actionChannel", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["actionChannel"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "cancelled", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["cancelled"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "flush", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["flush"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "getContext", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["getContext"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "setContext", function () {
          return _internal_io__WEBPACK_IMPORTED_MODULE_0__["setContext"];
        });
        /* harmony import */


        var _internal_io_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./internal/io-helpers */
        "../../node_modules/redux-saga/es/internal/io-helpers.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "takeEvery", function () {
          return _internal_io_helpers__WEBPACK_IMPORTED_MODULE_1__["takeEvery"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "takeLatest", function () {
          return _internal_io_helpers__WEBPACK_IMPORTED_MODULE_1__["takeLatest"];
        });
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "throttle", function () {
          return _internal_io_helpers__WEBPACK_IMPORTED_MODULE_1__["throttle"];
        });
        /***/

      },

      /***/
      "../../node_modules/redux-saga/es/internal/buffers.js":
      /*!*************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/redux-saga/es/internal/buffers.js ***!
        \*************************************************************************************/

      /*! exports provided: BUFFER_OVERFLOW, buffers */

      /***/
      function node_modulesReduxSagaEsInternalBuffersJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "BUFFER_OVERFLOW", function () {
          return BUFFER_OVERFLOW;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "buffers", function () {
          return buffers;
        });
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./utils */
        "../../node_modules/redux-saga/es/internal/utils.js");

        var BUFFER_OVERFLOW = "Channel's Buffer overflow!";
        var ON_OVERFLOW_THROW = 1;
        var ON_OVERFLOW_DROP = 2;
        var ON_OVERFLOW_SLIDE = 3;
        var ON_OVERFLOW_EXPAND = 4;
        var zeroBuffer = {
          isEmpty: _utils__WEBPACK_IMPORTED_MODULE_0__["kTrue"],
          put: _utils__WEBPACK_IMPORTED_MODULE_0__["noop"],
          take: _utils__WEBPACK_IMPORTED_MODULE_0__["noop"]
        };

        function ringBuffer() {
          var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
          var overflowAction = arguments[1];
          var arr = new Array(limit);
          var length = 0;
          var pushIndex = 0;
          var popIndex = 0;

          var push = function push(it) {
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            length++;
          };

          var take = function take() {
            if (length != 0) {
              var it = arr[popIndex];
              arr[popIndex] = null;
              length--;
              popIndex = (popIndex + 1) % limit;
              return it;
            }
          };

          var flush = function flush() {
            var items = [];

            while (length) {
              items.push(take());
            }

            return items;
          };

          return {
            isEmpty: function isEmpty() {
              return length == 0;
            },
            put: function put(it) {
              if (length < limit) {
                push(it);
              } else {
                var doubledLimit = void 0;

                switch (overflowAction) {
                  case ON_OVERFLOW_THROW:
                    throw new Error(BUFFER_OVERFLOW);

                  case ON_OVERFLOW_SLIDE:
                    arr[pushIndex] = it;
                    pushIndex = (pushIndex + 1) % limit;
                    popIndex = pushIndex;
                    break;

                  case ON_OVERFLOW_EXPAND:
                    doubledLimit = 2 * limit;
                    arr = flush();
                    length = arr.length;
                    pushIndex = arr.length;
                    popIndex = 0;
                    arr.length = doubledLimit;
                    limit = doubledLimit;
                    push(it);
                    break;

                  default: // DROP

                }
              }
            },
            take: take,
            flush: flush
          };
        }

        var buffers = {
          none: function none() {
            return zeroBuffer;
          },
          fixed: function fixed(limit) {
            return ringBuffer(limit, ON_OVERFLOW_THROW);
          },
          dropping: function dropping(limit) {
            return ringBuffer(limit, ON_OVERFLOW_DROP);
          },
          sliding: function sliding(limit) {
            return ringBuffer(limit, ON_OVERFLOW_SLIDE);
          },
          expanding: function expanding(initialSize) {
            return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
          }
        };
        /***/
      },

      /***/
      "../../node_modules/redux-saga/es/internal/channel.js":
      /*!*************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/redux-saga/es/internal/channel.js ***!
        \*************************************************************************************/

      /*! exports provided: END, isEnd, emitter, INVALID_BUFFER, UNDEFINED_INPUT_ERROR, channel, eventChannel, stdChannel */

      /***/
      function node_modulesReduxSagaEsInternalChannelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "END", function () {
          return END;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "isEnd", function () {
          return isEnd;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "emitter", function () {
          return emitter;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "INVALID_BUFFER", function () {
          return INVALID_BUFFER;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "UNDEFINED_INPUT_ERROR", function () {
          return UNDEFINED_INPUT_ERROR;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "channel", function () {
          return channel;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "eventChannel", function () {
          return eventChannel;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "stdChannel", function () {
          return stdChannel;
        });
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./utils */
        "../../node_modules/redux-saga/es/internal/utils.js");
        /* harmony import */


        var _buffers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./buffers */
        "../../node_modules/redux-saga/es/internal/buffers.js");
        /* harmony import */


        var _scheduler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./scheduler */
        "../../node_modules/redux-saga/es/internal/scheduler.js");

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
        var END = {
          type: CHANNEL_END_TYPE
        };

        var isEnd = function isEnd(a) {
          return a && a.type === CHANNEL_END_TYPE;
        };

        function emitter() {
          var subscribers = [];

          function subscribe(sub) {
            subscribers.push(sub);
            return function () {
              return Object(_utils__WEBPACK_IMPORTED_MODULE_0__["remove"])(subscribers, sub);
            };
          }

          function emit(item) {
            var arr = subscribers.slice();

            for (var i = 0, len = arr.length; i < len; i++) {
              arr[i](item);
            }
          }

          return {
            subscribe: subscribe,
            emit: emit
          };
        }

        var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
        var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

        if (true) {
          UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
        }

        function channel() {
          var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers__WEBPACK_IMPORTED_MODULE_1__["buffers"].fixed();
          var closed = false;
          var takers = [];
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(buffer, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].buffer, INVALID_BUFFER);

          function checkForbiddenStates() {
            if (closed && takers.length) {
              throw Object(_utils__WEBPACK_IMPORTED_MODULE_0__["internalErr"])('Cannot have a closed channel with pending takers');
            }

            if (takers.length && !buffer.isEmpty()) {
              throw Object(_utils__WEBPACK_IMPORTED_MODULE_0__["internalErr"])('Cannot have pending takers with non empty buffer');
            }
          }

          function put(input) {
            checkForbiddenStates();
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(input, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, UNDEFINED_INPUT_ERROR);

            if (closed) {
              return;
            }

            if (!takers.length) {
              return buffer.put(input);
            }

            for (var i = 0; i < takers.length; i++) {
              var cb = takers[i];

              if (!cb[_utils__WEBPACK_IMPORTED_MODULE_0__["MATCH"]] || cb[_utils__WEBPACK_IMPORTED_MODULE_0__["MATCH"]](input)) {
                takers.splice(i, 1);
                return cb(input);
              }
            }
          }

          function take(cb) {
            checkForbiddenStates();
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(cb, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, "channel.take's callback must be a function");

            if (closed && buffer.isEmpty()) {
              cb(END);
            } else if (!buffer.isEmpty()) {
              cb(buffer.take());
            } else {
              takers.push(cb);

              cb.cancel = function () {
                return Object(_utils__WEBPACK_IMPORTED_MODULE_0__["remove"])(takers, cb);
              };
            }
          }

          function flush(cb) {
            checkForbiddenStates(); // TODO: check if some new state should be forbidden now

            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(cb, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, "channel.flush' callback must be a function");

            if (closed && buffer.isEmpty()) {
              cb(END);
              return;
            }

            cb(buffer.flush());
          }

          function close() {
            checkForbiddenStates();

            if (!closed) {
              closed = true;

              if (takers.length) {
                var arr = takers;
                takers = [];

                for (var i = 0, len = arr.length; i < len; i++) {
                  arr[i](END);
                }
              }
            }
          }

          return {
            take: take,
            put: put,
            flush: flush,
            close: close,

            get __takers__() {
              return takers;
            },

            get __closed__() {
              return closed;
            }

          };
        }

        function eventChannel(subscribe) {
          var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers__WEBPACK_IMPORTED_MODULE_1__["buffers"].none();
          var matcher = arguments[2];
          /**
            should be if(typeof matcher !== undefined) instead?
            see PR #273 for a background discussion
          **/

          if (arguments.length > 2) {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(matcher, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, 'Invalid match function passed to eventChannel');
          }

          var chan = channel(buffer);

          var close = function close() {
            if (!chan.__closed__) {
              if (unsubscribe) {
                unsubscribe();
              }

              chan.close();
            }
          };

          var unsubscribe = subscribe(function (input) {
            if (isEnd(input)) {
              close();
              return;
            }

            if (matcher && !matcher(input)) {
              return;
            }

            chan.put(input);
          });

          if (chan.__closed__) {
            unsubscribe();
          }

          if (!_utils__WEBPACK_IMPORTED_MODULE_0__["is"].func(unsubscribe)) {
            throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
          }

          return {
            take: chan.take,
            flush: chan.flush,
            close: close
          };
        }

        function stdChannel(subscribe) {
          var chan = eventChannel(function (cb) {
            return subscribe(function (input) {
              if (input[_utils__WEBPACK_IMPORTED_MODULE_0__["SAGA_ACTION"]]) {
                cb(input);
                return;
              }

              Object(_scheduler__WEBPACK_IMPORTED_MODULE_2__["asap"])(function () {
                return cb(input);
              });
            });
          });
          return _extends({}, chan, {
            take: function take(cb, matcher) {
              if (arguments.length > 1) {
                Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(matcher, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, "channel.take's matcher argument must be a function");
                cb[_utils__WEBPACK_IMPORTED_MODULE_0__["MATCH"]] = matcher;
              }

              chan.take(cb);
            }
          });
        }
        /***/

      },

      /***/
      "../../node_modules/redux-saga/es/internal/io-helpers.js":
      /*!****************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/redux-saga/es/internal/io-helpers.js ***!
        \****************************************************************************************/

      /*! exports provided: takeEvery, takeLatest, throttle */

      /***/
      function node_modulesReduxSagaEsInternalIoHelpersJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "takeEvery", function () {
          return takeEvery;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "takeLatest", function () {
          return takeLatest;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "throttle", function () {
          return throttle;
        });
        /* harmony import */


        var _io__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./io */
        "../../node_modules/redux-saga/es/internal/io.js");
        /* harmony import */


        var _sagaHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./sagaHelpers */
        "../../node_modules/redux-saga/es/internal/sagaHelpers/index.js");

        function takeEvery(patternOrChannel, worker) {
          for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }

          return _io__WEBPACK_IMPORTED_MODULE_0__["fork"].apply(undefined, [_sagaHelpers__WEBPACK_IMPORTED_MODULE_1__["takeEveryHelper"], patternOrChannel, worker].concat(args));
        }

        function takeLatest(patternOrChannel, worker) {
          for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
            args[_key2 - 2] = arguments[_key2];
          }

          return _io__WEBPACK_IMPORTED_MODULE_0__["fork"].apply(undefined, [_sagaHelpers__WEBPACK_IMPORTED_MODULE_1__["takeLatestHelper"], patternOrChannel, worker].concat(args));
        }

        function throttle(ms, pattern, worker) {
          for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
            args[_key3 - 3] = arguments[_key3];
          }

          return _io__WEBPACK_IMPORTED_MODULE_0__["fork"].apply(undefined, [_sagaHelpers__WEBPACK_IMPORTED_MODULE_1__["throttleHelper"], ms, pattern, worker].concat(args));
        }
        /***/

      },

      /***/
      "../../node_modules/redux-saga/es/internal/io.js":
      /*!********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/redux-saga/es/internal/io.js ***!
        \********************************************************************************/

      /*! exports provided: detach, take, takem, put, all, race, call, apply, cps, fork, spawn, join, cancel, select, actionChannel, cancelled, flush, getContext, setContext, asEffect */

      /***/
      function node_modulesReduxSagaEsInternalIoJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "detach", function () {
          return detach;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "take", function () {
          return take;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "takem", function () {
          return takem;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "put", function () {
          return put;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "all", function () {
          return all;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "race", function () {
          return race;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "call", function () {
          return call;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "apply", function () {
          return apply;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "cps", function () {
          return cps;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "fork", function () {
          return fork;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "spawn", function () {
          return spawn;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "join", function () {
          return join;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "cancel", function () {
          return cancel;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "select", function () {
          return select;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "actionChannel", function () {
          return actionChannel;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "cancelled", function () {
          return cancelled;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "flush", function () {
          return flush;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getContext", function () {
          return getContext;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "setContext", function () {
          return setContext;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "asEffect", function () {
          return asEffect;
        });
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./utils */
        "../../node_modules/redux-saga/es/internal/utils.js");

        var IO =
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_0__["sym"])('IO');
        var TAKE = 'TAKE';
        var PUT = 'PUT';
        var ALL = 'ALL';
        var RACE = 'RACE';
        var CALL = 'CALL';
        var CPS = 'CPS';
        var FORK = 'FORK';
        var JOIN = 'JOIN';
        var CANCEL = 'CANCEL';
        var SELECT = 'SELECT';
        var ACTION_CHANNEL = 'ACTION_CHANNEL';
        var CANCELLED = 'CANCELLED';
        var FLUSH = 'FLUSH';
        var GET_CONTEXT = 'GET_CONTEXT';
        var SET_CONTEXT = 'SET_CONTEXT';
        var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

        var effect = function effect(type, payload) {
          var _ref;

          return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
        };

        var detach = function detach(eff) {
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(asEffect.fork(eff), _utils__WEBPACK_IMPORTED_MODULE_0__["is"].object, 'detach(eff): argument must be a fork effect');
          eff[FORK].detached = true;
          return eff;
        };

        function take() {
          var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

          if (arguments.length) {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(arguments[0], _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
          }

          if (_utils__WEBPACK_IMPORTED_MODULE_0__["is"].pattern(patternOrChannel)) {
            return effect(TAKE, {
              pattern: patternOrChannel
            });
          }

          if (_utils__WEBPACK_IMPORTED_MODULE_0__["is"].channel(patternOrChannel)) {
            return effect(TAKE, {
              channel: patternOrChannel
            });
          }

          throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
        }

        take.maybe = function () {
          var eff = take.apply(undefined, arguments);
          eff[TAKE].maybe = true;
          return eff;
        };

        var takem =
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_0__["deprecate"])(take.maybe,
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_0__["updateIncentive"])('takem', 'take.maybe'));

        function put(channel, action) {
          if (arguments.length > 1) {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'put(channel, action): argument channel is undefined');
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(action, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'put(channel, action): argument action is undefined');
          } else {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'put(action): argument action is undefined');
            action = channel;
            channel = null;
          }

          return effect(PUT, {
            channel: channel,
            action: action
          });
        }

        put.resolve = function () {
          var eff = put.apply(undefined, arguments);
          eff[PUT].resolve = true;
          return eff;
        };

        put.sync =
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_0__["deprecate"])(put.resolve,
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_0__["updateIncentive"])('put.sync', 'put.resolve'));

        function all(effects) {
          return effect(ALL, effects);
        }

        function race(effects) {
          return effect(RACE, effects);
        }

        function getFnCallDesc(meth, fn, args) {
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(fn, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, meth + ': argument fn is undefined');
          var context = null;

          if (_utils__WEBPACK_IMPORTED_MODULE_0__["is"].array(fn)) {
            var _fn = fn;
            context = _fn[0];
            fn = _fn[1];
          } else if (fn.fn) {
            var _fn2 = fn;
            context = _fn2.context;
            fn = _fn2.fn;
          }

          if (context && _utils__WEBPACK_IMPORTED_MODULE_0__["is"].string(fn) && _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func(context[fn])) {
            fn = context[fn];
          }

          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(fn, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, meth + ': argument ' + fn + ' is not a function');
          return {
            context: context,
            fn: fn,
            args: args
          };
        }

        function call(fn) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          return effect(CALL, getFnCallDesc('call', fn, args));
        }

        function apply(context, fn) {
          var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
          return effect(CALL, getFnCallDesc('apply', {
            context: context,
            fn: fn
          }, args));
        }

        function cps(fn) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return effect(CPS, getFnCallDesc('cps', fn, args));
        }

        function fork(fn) {
          for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            args[_key3 - 1] = arguments[_key3];
          }

          return effect(FORK, getFnCallDesc('fork', fn, args));
        }

        function spawn(fn) {
          for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
            args[_key4 - 1] = arguments[_key4];
          }

          return detach(fork.apply(undefined, [fn].concat(args)));
        }

        function join() {
          for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            tasks[_key5] = arguments[_key5];
          }

          if (tasks.length > 1) {
            return all(tasks.map(function (t) {
              return join(t);
            }));
          }

          var task = tasks[0];
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'join(task): argument task is undefined');
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
          return effect(JOIN, task);
        }

        function cancel() {
          for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            tasks[_key6] = arguments[_key6];
          }

          if (tasks.length > 1) {
            return all(tasks.map(function (t) {
              return cancel(t);
            }));
          }

          var task = tasks[0];

          if (tasks.length === 1) {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'cancel(task): argument task is undefined');
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(task, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
          }

          return effect(CANCEL, task || _utils__WEBPACK_IMPORTED_MODULE_0__["SELF_CANCELLATION"]);
        }

        function select(selector) {
          for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
            args[_key7 - 1] = arguments[_key7];
          }

          if (arguments.length === 0) {
            selector = _utils__WEBPACK_IMPORTED_MODULE_0__["ident"];
          } else {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(selector, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'select(selector,[...]): argument selector is undefined');
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(selector, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
          }

          return effect(SELECT, {
            selector: selector,
            args: args
          });
        }
        /**
          channel(pattern, [buffer])    => creates an event channel for store actions
        **/


        function actionChannel(pattern, buffer) {
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(pattern, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');

          if (arguments.length > 1) {
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(buffer, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
            Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(buffer, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
          }

          return effect(ACTION_CHANNEL, {
            pattern: pattern,
            buffer: buffer
          });
        }

        function cancelled() {
          return effect(CANCELLED, {});
        }

        function flush(channel) {
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(channel, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
          return effect(FLUSH, channel);
        }

        function getContext(prop) {
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(prop, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].string, 'getContext(prop): argument ' + prop + ' is not a string');
          return effect(GET_CONTEXT, prop);
        }

        function setContext(props) {
          Object(_utils__WEBPACK_IMPORTED_MODULE_0__["check"])(props, _utils__WEBPACK_IMPORTED_MODULE_0__["is"].object, Object(_utils__WEBPACK_IMPORTED_MODULE_0__["createSetContextWarning"])(null, props));
          return effect(SET_CONTEXT, props);
        }

        var createAsEffectType = function createAsEffectType(type) {
          return function (effect) {
            return effect && effect[IO] && effect[type];
          };
        };

        var asEffect = {
          take:
          /*#__PURE__*/
          createAsEffectType(TAKE),
          put:
          /*#__PURE__*/
          createAsEffectType(PUT),
          all:
          /*#__PURE__*/
          createAsEffectType(ALL),
          race:
          /*#__PURE__*/
          createAsEffectType(RACE),
          call:
          /*#__PURE__*/
          createAsEffectType(CALL),
          cps:
          /*#__PURE__*/
          createAsEffectType(CPS),
          fork:
          /*#__PURE__*/
          createAsEffectType(FORK),
          join:
          /*#__PURE__*/
          createAsEffectType(JOIN),
          cancel:
          /*#__PURE__*/
          createAsEffectType(CANCEL),
          select:
          /*#__PURE__*/
          createAsEffectType(SELECT),
          actionChannel:
          /*#__PURE__*/
          createAsEffectType(ACTION_CHANNEL),
          cancelled:
          /*#__PURE__*/
          createAsEffectType(CANCELLED),
          flush:
          /*#__PURE__*/
          createAsEffectType(FLUSH),
          getContext:
          /*#__PURE__*/
          createAsEffectType(GET_CONTEXT),
          setContext:
          /*#__PURE__*/
          createAsEffectType(SET_CONTEXT)
        };
        /***/
      },

      /***/
      "../../node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js":
      /*!*****************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js ***!
        \*****************************************************************************************************/

      /*! exports provided: qEnd, safeName, default */

      /***/
      function node_modulesReduxSagaEsInternalSagaHelpersFsmIteratorJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "qEnd", function () {
          return qEnd;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "safeName", function () {
          return safeName;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return fsmIterator;
        });
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ../utils */
        "../../node_modules/redux-saga/es/internal/utils.js");

        var done = {
          done: true,
          value: undefined
        };
        var qEnd = {};

        function safeName(patternOrChannel) {
          if (_utils__WEBPACK_IMPORTED_MODULE_0__["is"].channel(patternOrChannel)) {
            return 'channel';
          } else if (Array.isArray(patternOrChannel)) {
            return String(patternOrChannel.map(function (entry) {
              return String(entry);
            }));
          } else {
            return String(patternOrChannel);
          }
        }

        function fsmIterator(fsm, q0) {
          var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
          var updateState = void 0,
              qNext = q0;

          function next(arg, error) {
            if (qNext === qEnd) {
              return done;
            }

            if (error) {
              qNext = qEnd;
              throw error;
            } else {
              updateState && updateState(arg);

              var _fsm$qNext = fsm[qNext](),
                  q = _fsm$qNext[0],
                  output = _fsm$qNext[1],
                  _updateState = _fsm$qNext[2];

              qNext = q;
              updateState = _updateState;
              return qNext === qEnd ? done : output;
            }
          }

          return Object(_utils__WEBPACK_IMPORTED_MODULE_0__["makeIterator"])(next, function (error) {
            return next(null, error);
          }, name, true);
        }
        /***/

      },

      /***/
      "../../node_modules/redux-saga/es/internal/sagaHelpers/index.js":
      /*!***********************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/redux-saga/es/internal/sagaHelpers/index.js ***!
        \***********************************************************************************************/

      /*! exports provided: takeEvery, takeLatest, throttle, takeEveryHelper, takeLatestHelper, throttleHelper */

      /***/
      function node_modulesReduxSagaEsInternalSagaHelpersIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "takeEvery", function () {
          return takeEvery;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "takeLatest", function () {
          return takeLatest;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "throttle", function () {
          return throttle;
        });
        /* harmony import */


        var _takeEvery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./takeEvery */
        "../../node_modules/redux-saga/es/internal/sagaHelpers/takeEvery.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "takeEveryHelper", function () {
          return _takeEvery__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /* harmony import */


        var _takeLatest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./takeLatest */
        "../../node_modules/redux-saga/es/internal/sagaHelpers/takeLatest.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "takeLatestHelper", function () {
          return _takeLatest__WEBPACK_IMPORTED_MODULE_1__["default"];
        });
        /* harmony import */


        var _throttle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./throttle */
        "../../node_modules/redux-saga/es/internal/sagaHelpers/throttle.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "throttleHelper", function () {
          return _throttle__WEBPACK_IMPORTED_MODULE_2__["default"];
        });
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../utils */
        "../../node_modules/redux-saga/es/internal/utils.js");

        var deprecationWarning = function deprecationWarning(helperName) {
          return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
        };

        var takeEvery =
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_3__["deprecate"])(_takeEvery__WEBPACK_IMPORTED_MODULE_0__["default"],
        /*#__PURE__*/
        deprecationWarning('takeEvery'));
        var takeLatest =
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_3__["deprecate"])(_takeLatest__WEBPACK_IMPORTED_MODULE_1__["default"],
        /*#__PURE__*/
        deprecationWarning('takeLatest'));
        var throttle =
        /*#__PURE__*/
        Object(_utils__WEBPACK_IMPORTED_MODULE_3__["deprecate"])(_throttle__WEBPACK_IMPORTED_MODULE_2__["default"],
        /*#__PURE__*/
        deprecationWarning('throttle'));
        /***/
      },

      /***/
      "../../node_modules/redux-saga/es/internal/sagaHelpers/takeEvery.js":
      /*!***************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/redux-saga/es/internal/sagaHelpers/takeEvery.js ***!
        \***************************************************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesReduxSagaEsInternalSagaHelpersTakeEveryJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return takeEvery;
        });
        /* harmony import */


        var _fsmIterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./fsmIterator */
        "../../node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js");
        /* harmony import */


        var _io__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ../io */
        "../../node_modules/redux-saga/es/internal/io.js");
        /* harmony import */


        var _channel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ../channel */
        "../../node_modules/redux-saga/es/internal/channel.js");

        function takeEvery(patternOrChannel, worker) {
          for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }

          var yTake = {
            done: false,
            value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["take"])(patternOrChannel)
          };

          var yFork = function yFork(ac) {
            return {
              done: false,
              value: _io__WEBPACK_IMPORTED_MODULE_1__["fork"].apply(undefined, [worker].concat(args, [ac]))
            };
          };

          var action = void 0,
              setAction = function setAction(ac) {
            return action = ac;
          };

          return Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["default"])({
            q1: function q1() {
              return ['q2', yTake, setAction];
            },
            q2: function q2() {
              return action === _channel__WEBPACK_IMPORTED_MODULE_2__["END"] ? [_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["qEnd"]] : ['q1', yFork(action)];
            }
          }, 'q1', 'takeEvery(' + Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["safeName"])(patternOrChannel) + ', ' + worker.name + ')');
        }
        /***/

      },

      /***/
      "../../node_modules/redux-saga/es/internal/sagaHelpers/takeLatest.js":
      /*!****************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/redux-saga/es/internal/sagaHelpers/takeLatest.js ***!
        \****************************************************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesReduxSagaEsInternalSagaHelpersTakeLatestJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return takeLatest;
        });
        /* harmony import */


        var _fsmIterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./fsmIterator */
        "../../node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js");
        /* harmony import */


        var _io__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ../io */
        "../../node_modules/redux-saga/es/internal/io.js");
        /* harmony import */


        var _channel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ../channel */
        "../../node_modules/redux-saga/es/internal/channel.js");

        function takeLatest(patternOrChannel, worker) {
          for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }

          var yTake = {
            done: false,
            value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["take"])(patternOrChannel)
          };

          var yFork = function yFork(ac) {
            return {
              done: false,
              value: _io__WEBPACK_IMPORTED_MODULE_1__["fork"].apply(undefined, [worker].concat(args, [ac]))
            };
          };

          var yCancel = function yCancel(task) {
            return {
              done: false,
              value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["cancel"])(task)
            };
          };

          var task = void 0,
              action = void 0;

          var setTask = function setTask(t) {
            return task = t;
          };

          var setAction = function setAction(ac) {
            return action = ac;
          };

          return Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["default"])({
            q1: function q1() {
              return ['q2', yTake, setAction];
            },
            q2: function q2() {
              return action === _channel__WEBPACK_IMPORTED_MODULE_2__["END"] ? [_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["qEnd"]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
            },
            q3: function q3() {
              return ['q1', yFork(action), setTask];
            }
          }, 'q1', 'takeLatest(' + Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["safeName"])(patternOrChannel) + ', ' + worker.name + ')');
        }
        /***/

      },

      /***/
      "../../node_modules/redux-saga/es/internal/sagaHelpers/throttle.js":
      /*!**************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/redux-saga/es/internal/sagaHelpers/throttle.js ***!
        \**************************************************************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesReduxSagaEsInternalSagaHelpersThrottleJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return throttle;
        });
        /* harmony import */


        var _fsmIterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./fsmIterator */
        "../../node_modules/redux-saga/es/internal/sagaHelpers/fsmIterator.js");
        /* harmony import */


        var _io__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ../io */
        "../../node_modules/redux-saga/es/internal/io.js");
        /* harmony import */


        var _channel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ../channel */
        "../../node_modules/redux-saga/es/internal/channel.js");
        /* harmony import */


        var _buffers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../buffers */
        "../../node_modules/redux-saga/es/internal/buffers.js");
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ../utils */
        "../../node_modules/redux-saga/es/internal/utils.js");

        function throttle(delayLength, pattern, worker) {
          for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
            args[_key - 3] = arguments[_key];
          }

          var action = void 0,
              channel = void 0;
          var yActionChannel = {
            done: false,
            value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["actionChannel"])(pattern, _buffers__WEBPACK_IMPORTED_MODULE_3__["buffers"].sliding(1))
          };

          var yTake = function yTake() {
            return {
              done: false,
              value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["take"])(channel)
            };
          };

          var yFork = function yFork(ac) {
            return {
              done: false,
              value: _io__WEBPACK_IMPORTED_MODULE_1__["fork"].apply(undefined, [worker].concat(args, [ac]))
            };
          };

          var yDelay = {
            done: false,
            value: Object(_io__WEBPACK_IMPORTED_MODULE_1__["call"])(_utils__WEBPACK_IMPORTED_MODULE_4__["delay"], delayLength)
          };

          var setAction = function setAction(ac) {
            return action = ac;
          };

          var setChannel = function setChannel(ch) {
            return channel = ch;
          };

          return Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["default"])({
            q1: function q1() {
              return ['q2', yActionChannel, setChannel];
            },
            q2: function q2() {
              return ['q3', yTake(), setAction];
            },
            q3: function q3() {
              return action === _channel__WEBPACK_IMPORTED_MODULE_2__["END"] ? [_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["qEnd"]] : ['q4', yFork(action)];
            },
            q4: function q4() {
              return ['q2', yDelay];
            }
          }, 'q1', 'throttle(' + Object(_fsmIterator__WEBPACK_IMPORTED_MODULE_0__["safeName"])(pattern) + ', ' + worker.name + ')');
        }
        /***/

      },

      /***/
      "../../node_modules/redux-saga/es/internal/scheduler.js":
      /*!***************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/redux-saga/es/internal/scheduler.js ***!
        \***************************************************************************************/

      /*! exports provided: asap, suspend, flush */

      /***/
      function node_modulesReduxSagaEsInternalSchedulerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "asap", function () {
          return asap;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "suspend", function () {
          return suspend;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "flush", function () {
          return flush;
        });

        var queue = [];
        /**
          Variable to hold a counting semaphore
          - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
            already suspended)
          - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
            triggers flushing the queued tasks.
        **/

        var semaphore = 0;
        /**
          Executes a task 'atomically'. Tasks scheduled during this execution will be queued
          and flushed after this task has finished (assuming the scheduler endup in a released
          state).
        **/

        function exec(task) {
          try {
            suspend();
            task();
          } finally {
            release();
          }
        }
        /**
          Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
        **/


        function asap(task) {
          queue.push(task);

          if (!semaphore) {
            suspend();
            flush();
          }
        }
        /**
          Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
          scheduler is released.
        **/


        function suspend() {
          semaphore++;
        }
        /**
          Puts the scheduler in a `released` state.
        **/


        function release() {
          semaphore--;
        }
        /**
          Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
        **/


        function flush() {
          release();
          var task = void 0;

          while (!semaphore && (task = queue.shift()) !== undefined) {
            exec(task);
          }
        }
        /***/

      },

      /***/
      "../../node_modules/redux-saga/es/internal/utils.js":
      /*!***********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/redux-saga/es/internal/utils.js ***!
        \***********************************************************************************/

      /*! exports provided: sym, TASK, HELPER, MATCH, CANCEL, SAGA_ACTION, SELF_CANCELLATION, konst, kTrue, kFalse, noop, ident, check, hasOwn, is, object, remove, array, deferred, arrayOfDeffered, delay, createMockTask, autoInc, uid, makeIterator, log, deprecate, updateIncentive, internalErr, createSetContextWarning, wrapSagaDispatch, cloneableGenerator */

      /***/
      function node_modulesReduxSagaEsInternalUtilsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "sym", function () {
          return sym;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "TASK", function () {
          return TASK;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "HELPER", function () {
          return HELPER;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "MATCH", function () {
          return MATCH;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "CANCEL", function () {
          return CANCEL;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "SAGA_ACTION", function () {
          return SAGA_ACTION;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "SELF_CANCELLATION", function () {
          return SELF_CANCELLATION;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "konst", function () {
          return konst;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "kTrue", function () {
          return kTrue;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "kFalse", function () {
          return kFalse;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "noop", function () {
          return noop;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "ident", function () {
          return ident;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "check", function () {
          return check;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "hasOwn", function () {
          return hasOwn;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "is", function () {
          return is;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "object", function () {
          return object;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "remove", function () {
          return remove;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "array", function () {
          return array;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "deferred", function () {
          return deferred;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "arrayOfDeffered", function () {
          return arrayOfDeffered;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "delay", function () {
          return delay;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "createMockTask", function () {
          return createMockTask;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "autoInc", function () {
          return autoInc;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "uid", function () {
          return uid;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "makeIterator", function () {
          return makeIterator;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "log", function () {
          return log;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "deprecate", function () {
          return deprecate;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "updateIncentive", function () {
          return updateIncentive;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "internalErr", function () {
          return internalErr;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "createSetContextWarning", function () {
          return createSetContextWarning;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "wrapSagaDispatch", function () {
          return wrapSagaDispatch;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "cloneableGenerator", function () {
          return cloneableGenerator;
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        var sym = function sym(id) {
          return '@@redux-saga/' + id;
        };

        var TASK =
        /*#__PURE__*/
        sym('TASK');
        var HELPER =
        /*#__PURE__*/
        sym('HELPER');
        var MATCH =
        /*#__PURE__*/
        sym('MATCH');
        var CANCEL =
        /*#__PURE__*/
        sym('CANCEL_PROMISE');
        var SAGA_ACTION =
        /*#__PURE__*/
        sym('SAGA_ACTION');
        var SELF_CANCELLATION =
        /*#__PURE__*/
        sym('SELF_CANCELLATION');

        var konst = function konst(v) {
          return function () {
            return v;
          };
        };

        var kTrue =
        /*#__PURE__*/
        konst(true);
        var kFalse =
        /*#__PURE__*/
        konst(false);

        var noop = function noop() {};

        var ident = function ident(v) {
          return v;
        };

        function check(value, predicate, error) {
          if (!predicate(value)) {
            log('error', 'uncaught at check', error);
            throw new Error(error);
          }
        }

        var hasOwnProperty = Object.prototype.hasOwnProperty;

        function hasOwn(object, property) {
          return is.notUndef(object) && hasOwnProperty.call(object, property);
        }

        var is = {
          undef: function undef(v) {
            return v === null || v === undefined;
          },
          notUndef: function notUndef(v) {
            return v !== null && v !== undefined;
          },
          func: function func(f) {
            return typeof f === 'function';
          },
          number: function number(n) {
            return typeof n === 'number';
          },
          string: function string(s) {
            return typeof s === 'string';
          },
          array: Array.isArray,
          object: function object(obj) {
            return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
          },
          promise: function promise(p) {
            return p && is.func(p.then);
          },
          iterator: function iterator(it) {
            return it && is.func(it.next) && is.func(it.throw);
          },
          iterable: function iterable(it) {
            return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
          },
          task: function task(t) {
            return t && t[TASK];
          },
          observable: function observable(ob) {
            return ob && is.func(ob.subscribe);
          },
          buffer: function buffer(buf) {
            return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
          },
          pattern: function pattern(pat) {
            return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
          },
          channel: function channel(ch) {
            return ch && is.func(ch.take) && is.func(ch.close);
          },
          helper: function helper(it) {
            return it && it[HELPER];
          },
          stringableFunc: function stringableFunc(f) {
            return is.func(f) && hasOwn(f, 'toString');
          }
        };
        var object = {
          assign: function assign(target, source) {
            for (var i in source) {
              if (hasOwn(source, i)) {
                target[i] = source[i];
              }
            }
          }
        };

        function remove(array, item) {
          var index = array.indexOf(item);

          if (index >= 0) {
            array.splice(index, 1);
          }
        }

        var array = {
          from: function from(obj) {
            var arr = Array(obj.length);

            for (var i in obj) {
              if (hasOwn(obj, i)) {
                arr[i] = obj[i];
              }
            }

            return arr;
          }
        };

        function deferred() {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var def = _extends({}, props);

          var promise = new Promise(function (resolve, reject) {
            def.resolve = resolve;
            def.reject = reject;
          });
          def.promise = promise;
          return def;
        }

        function arrayOfDeffered(length) {
          var arr = [];

          for (var i = 0; i < length; i++) {
            arr.push(deferred());
          }

          return arr;
        }

        function delay(ms) {
          var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          var timeoutId = void 0;
          var promise = new Promise(function (resolve) {
            timeoutId = setTimeout(function () {
              return resolve(val);
            }, ms);
          });

          promise[CANCEL] = function () {
            return clearTimeout(timeoutId);
          };

          return promise;
        }

        function createMockTask() {
          var _ref;

          var running = true;

          var _result = void 0,
              _error = void 0;

          return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
            return running;
          }, _ref.result = function result() {
            return _result;
          }, _ref.error = function error() {
            return _error;
          }, _ref.setRunning = function setRunning(b) {
            return running = b;
          }, _ref.setResult = function setResult(r) {
            return _result = r;
          }, _ref.setError = function setError(e) {
            return _error = e;
          }, _ref;
        }

        function autoInc() {
          var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          return function () {
            return ++seed;
          };
        }

        var uid =
        /*#__PURE__*/
        autoInc();

        var kThrow = function kThrow(err) {
          throw err;
        };

        var kReturn = function kReturn(value) {
          return {
            value: value,
            done: true
          };
        };

        function makeIterator(next) {
          var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
          var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
          var isHelper = arguments[3];
          var iterator = {
            name: name,
            next: next,
            throw: thro,
            return: kReturn
          };

          if (isHelper) {
            iterator[HELPER] = true;
          }

          if (typeof Symbol !== 'undefined') {
            iterator[Symbol.iterator] = function () {
              return iterator;
            };
          }

          return iterator;
        }
        /**
          Print error in a useful way whether in a browser environment
          (with expandable error stack traces), or in a node.js environment
          (text-only log output)
         **/


        function log(level, message) {
          var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
          /*eslint-disable no-console*/

          if (typeof window === 'undefined') {
            console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
          } else {
            console[level](message, error);
          }
        }

        function deprecate(fn, deprecationWarning) {
          return function () {
            if (true) log('warn', deprecationWarning);
            return fn.apply(undefined, arguments);
          };
        }

        var updateIncentive = function updateIncentive(deprecated, preferred) {
          return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
        };

        var internalErr = function internalErr(err) {
          return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
        };

        var createSetContextWarning = function createSetContextWarning(ctx, props) {
          return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
        };

        var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
          return function (action) {
            return dispatch(Object.defineProperty(action, SAGA_ACTION, {
              value: true
            }));
          };
        };

        var cloneableGenerator = function cloneableGenerator(generatorFunc) {
          return function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            var history = [];
            var gen = generatorFunc.apply(undefined, args);
            return {
              next: function next(arg) {
                history.push(arg);
                return gen.next(arg);
              },
              clone: function clone() {
                var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
                history.forEach(function (arg) {
                  return clonedGen.next(arg);
                });
                return clonedGen;
              },
              return: function _return(value) {
                return gen.return(value);
              },
              throw: function _throw(exception) {
                return gen.throw(exception);
              }
            };
          };
        };
        /***/

      },

      /***/
      "../../node_modules/regenerator-runtime/runtime.js":
      /*!**********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/regenerator-runtime/runtime.js ***!
        \**********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesRegeneratorRuntimeRuntimeJs(module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        var runtime = function (exports) {
          "use strict";

          var Op = Object.prototype;
          var hasOwn = Op.hasOwnProperty;
          var undefined; // More compressible than void 0.

          var $Symbol = typeof Symbol === "function" ? Symbol : {};
          var iteratorSymbol = $Symbol.iterator || "@@iterator";
          var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
          var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

          function wrap(innerFn, outerFn, self, tryLocsList) {
            // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
            var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
            var generator = Object.create(protoGenerator.prototype);
            var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
            // .throw, and .return methods.

            generator._invoke = makeInvokeMethod(innerFn, self, context);
            return generator;
          }

          exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
          // record like context.tryEntries[i].completion. This interface could
          // have been (and was previously) designed to take a closure to be
          // invoked without arguments, but in all the cases we care about we
          // already have an existing method we want to call, so there's no need
          // to create a new function object. We can even get away with assuming
          // the method takes exactly one argument, since that happens to be true
          // in every case, so we don't have to touch the arguments object. The
          // only additional allocation required is the completion record, which
          // has a stable shape and so hopefully should be cheap to allocate.

          function tryCatch(fn, obj, arg) {
            try {
              return {
                type: "normal",
                arg: fn.call(obj, arg)
              };
            } catch (err) {
              return {
                type: "throw",
                arg: err
              };
            }
          }

          var GenStateSuspendedStart = "suspendedStart";
          var GenStateSuspendedYield = "suspendedYield";
          var GenStateExecuting = "executing";
          var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
          // breaking out of the dispatch switch statement.

          var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
          // .constructor.prototype properties for functions that return Generator
          // objects. For full spec compliance, you may wish to configure your
          // minifier not to mangle the names of these two functions.

          function Generator() {}

          function GeneratorFunction() {}

          function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
          // don't natively support it.


          var IteratorPrototype = {};

          IteratorPrototype[iteratorSymbol] = function () {
            return this;
          };

          var getProto = Object.getPrototypeOf;
          var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

          if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
            // This environment has a native %IteratorPrototype%; use it instead
            // of the polyfill.
            IteratorPrototype = NativeIteratorPrototype;
          }

          var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
          GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
          GeneratorFunctionPrototype.constructor = GeneratorFunction;
          GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
          // Iterator interface in terms of a single ._invoke method.

          function defineIteratorMethods(prototype) {
            ["next", "throw", "return"].forEach(function (method) {
              prototype[method] = function (arg) {
                return this._invoke(method, arg);
              };
            });
          }

          exports.isGeneratorFunction = function (genFun) {
            var ctor = typeof genFun === "function" && genFun.constructor;
            return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
            // do is to check its .name property.
            (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
          };

          exports.mark = function (genFun) {
            if (Object.setPrototypeOf) {
              Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
            } else {
              genFun.__proto__ = GeneratorFunctionPrototype;

              if (!(toStringTagSymbol in genFun)) {
                genFun[toStringTagSymbol] = "GeneratorFunction";
              }
            }

            genFun.prototype = Object.create(Gp);
            return genFun;
          }; // Within the body of any async function, `await x` is transformed to
          // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
          // `hasOwn.call(value, "__await")` to determine if the yielded value is
          // meant to be awaited.


          exports.awrap = function (arg) {
            return {
              __await: arg
            };
          };

          function AsyncIterator(generator) {
            function invoke(method, arg, resolve, reject) {
              var record = tryCatch(generator[method], generator, arg);

              if (record.type === "throw") {
                reject(record.arg);
              } else {
                var result = record.arg;
                var value = result.value;

                if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                  return Promise.resolve(value.__await).then(function (value) {
                    invoke("next", value, resolve, reject);
                  }, function (err) {
                    invoke("throw", err, resolve, reject);
                  });
                }

                return Promise.resolve(value).then(function (unwrapped) {
                  // When a yielded Promise is resolved, its final value becomes
                  // the .value of the Promise<{value,done}> result for the
                  // current iteration.
                  result.value = unwrapped;
                  resolve(result);
                }, function (error) {
                  // If a rejected Promise was yielded, throw the rejection back
                  // into the async generator function so it can be handled there.
                  return invoke("throw", error, resolve, reject);
                });
              }
            }

            var previousPromise;

            function enqueue(method, arg) {
              function callInvokeWithMethodAndArg() {
                return new Promise(function (resolve, reject) {
                  invoke(method, arg, resolve, reject);
                });
              }

              return previousPromise = // If enqueue has been called before, then we want to wait until
              // all previous Promises have been resolved before calling invoke,
              // so that results are always delivered in the correct order. If
              // enqueue has not been called before, then it is important to
              // call invoke immediately, without waiting on a callback to fire,
              // so that the async generator function has the opportunity to do
              // any necessary setup in a predictable way. This predictability
              // is why the Promise constructor synchronously invokes its
              // executor callback, and why async functions synchronously
              // execute code before the first await. Since we implement simple
              // async functions in terms of async generators, it is especially
              // important to get this right, even though it requires care.
              previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
              // invocations of the iterator.
              callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            } // Define the unified helper method that is used to implement .next,
            // .throw, and .return (see defineIteratorMethods).


            this._invoke = enqueue;
          }

          defineIteratorMethods(AsyncIterator.prototype);

          AsyncIterator.prototype[asyncIteratorSymbol] = function () {
            return this;
          };

          exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
          // AsyncIterator objects; they just return a Promise for the value of
          // the final result produced by the iterator.

          exports.async = function (innerFn, outerFn, self, tryLocsList) {
            var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
            return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
            : iter.next().then(function (result) {
              return result.done ? result.value : iter.next();
            });
          };

          function makeInvokeMethod(innerFn, self, context) {
            var state = GenStateSuspendedStart;
            return function invoke(method, arg) {
              if (state === GenStateExecuting) {
                throw new Error("Generator is already running");
              }

              if (state === GenStateCompleted) {
                if (method === "throw") {
                  throw arg;
                } // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


                return doneResult();
              }

              context.method = method;
              context.arg = arg;

              while (true) {
                var delegate = context.delegate;

                if (delegate) {
                  var delegateResult = maybeInvokeDelegate(delegate, context);

                  if (delegateResult) {
                    if (delegateResult === ContinueSentinel) continue;
                    return delegateResult;
                  }
                }

                if (context.method === "next") {
                  // Setting context._sent for legacy support of Babel's
                  // function.sent implementation.
                  context.sent = context._sent = context.arg;
                } else if (context.method === "throw") {
                  if (state === GenStateSuspendedStart) {
                    state = GenStateCompleted;
                    throw context.arg;
                  }

                  context.dispatchException(context.arg);
                } else if (context.method === "return") {
                  context.abrupt("return", context.arg);
                }

                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);

                if (record.type === "normal") {
                  // If an exception is thrown from innerFn, we leave state ===
                  // GenStateExecuting and loop back for another invocation.
                  state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                  if (record.arg === ContinueSentinel) {
                    continue;
                  }

                  return {
                    value: record.arg,
                    done: context.done
                  };
                } else if (record.type === "throw") {
                  state = GenStateCompleted; // Dispatch the exception by looping back around to the
                  // context.dispatchException(context.arg) call above.

                  context.method = "throw";
                  context.arg = record.arg;
                }
              }
            };
          } // Call delegate.iterator[context.method](context.arg) and handle the
          // result, either by returning a { value, done } result from the
          // delegate iterator, or by modifying context.method and context.arg,
          // setting context.delegate to null, and returning the ContinueSentinel.


          function maybeInvokeDelegate(delegate, context) {
            var method = delegate.iterator[context.method];

            if (method === undefined) {
              // A .throw or .return when the delegate iterator has no .throw
              // method always terminates the yield* loop.
              context.delegate = null;

              if (context.method === "throw") {
                // Note: ["return"] must be used for ES3 parsing compatibility.
                if (delegate.iterator["return"]) {
                  // If the delegate iterator has a return method, give it a
                  // chance to clean up.
                  context.method = "return";
                  context.arg = undefined;
                  maybeInvokeDelegate(delegate, context);

                  if (context.method === "throw") {
                    // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                  }
                }

                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
              }

              return ContinueSentinel;
            }

            var record = tryCatch(method, delegate.iterator, context.arg);

            if (record.type === "throw") {
              context.method = "throw";
              context.arg = record.arg;
              context.delegate = null;
              return ContinueSentinel;
            }

            var info = record.arg;

            if (!info) {
              context.method = "throw";
              context.arg = new TypeError("iterator result is not an object");
              context.delegate = null;
              return ContinueSentinel;
            }

            if (info.done) {
              // Assign the result of the finished delegate to the temporary
              // variable specified by delegate.resultName (see delegateYield).
              context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

              context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
              // exception, let the outer generator proceed normally. If
              // context.method was "next", forget context.arg since it has been
              // "consumed" by the delegate iterator. If context.method was
              // "return", allow the original .return call to continue in the
              // outer generator.

              if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
              }
            } else {
              // Re-yield the result returned by the delegate method.
              return info;
            } // The delegate iterator is finished, so forget it and continue with
            // the outer generator.


            context.delegate = null;
            return ContinueSentinel;
          } // Define Generator.prototype.{next,throw,return} in terms of the
          // unified ._invoke helper method.


          defineIteratorMethods(Gp);
          Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
          // @@iterator function is called on it. Some browsers' implementations of the
          // iterator prototype chain incorrectly implement this, causing the Generator
          // object to not be returned from this call. This ensures that doesn't happen.
          // See https://github.com/facebook/regenerator/issues/274 for more details.

          Gp[iteratorSymbol] = function () {
            return this;
          };

          Gp.toString = function () {
            return "[object Generator]";
          };

          function pushTryEntry(locs) {
            var entry = {
              tryLoc: locs[0]
            };

            if (1 in locs) {
              entry.catchLoc = locs[1];
            }

            if (2 in locs) {
              entry.finallyLoc = locs[2];
              entry.afterLoc = locs[3];
            }

            this.tryEntries.push(entry);
          }

          function resetTryEntry(entry) {
            var record = entry.completion || {};
            record.type = "normal";
            delete record.arg;
            entry.completion = record;
          }

          function Context(tryLocsList) {
            // The root entry object (effectively a try statement without a catch
            // or a finally block) gives us a place to store values thrown from
            // locations where there is no enclosing try statement.
            this.tryEntries = [{
              tryLoc: "root"
            }];
            tryLocsList.forEach(pushTryEntry, this);
            this.reset(true);
          }

          exports.keys = function (object) {
            var keys = [];

            for (var key in object) {
              keys.push(key);
            }

            keys.reverse(); // Rather than returning an object with a next method, we keep
            // things simple and return the next function itself.

            return function next() {
              while (keys.length) {
                var key = keys.pop();

                if (key in object) {
                  next.value = key;
                  next.done = false;
                  return next;
                }
              } // To avoid creating an additional object, we just hang the .value
              // and .done properties off the next function object itself. This
              // also ensures that the minifier will not anonymize the function.


              next.done = true;
              return next;
            };
          };

          function values(iterable) {
            if (iterable) {
              var iteratorMethod = iterable[iteratorSymbol];

              if (iteratorMethod) {
                return iteratorMethod.call(iterable);
              }

              if (typeof iterable.next === "function") {
                return iterable;
              }

              if (!isNaN(iterable.length)) {
                var i = -1,
                    next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }

                  next.value = undefined;
                  next.done = true;
                  return next;
                };

                return next.next = next;
              }
            } // Return an iterator with no values.


            return {
              next: doneResult
            };
          }

          exports.values = values;

          function doneResult() {
            return {
              value: undefined,
              done: true
            };
          }

          Context.prototype = {
            constructor: Context,
            reset: function reset(skipTempReset) {
              this.prev = 0;
              this.next = 0; // Resetting context._sent for legacy support of Babel's
              // function.sent implementation.

              this.sent = this._sent = undefined;
              this.done = false;
              this.delegate = null;
              this.method = "next";
              this.arg = undefined;
              this.tryEntries.forEach(resetTryEntry);

              if (!skipTempReset) {
                for (var name in this) {
                  // Not sure about the optimal order of these conditions:
                  if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                    this[name] = undefined;
                  }
                }
              }
            },
            stop: function stop() {
              this.done = true;
              var rootEntry = this.tryEntries[0];
              var rootRecord = rootEntry.completion;

              if (rootRecord.type === "throw") {
                throw rootRecord.arg;
              }

              return this.rval;
            },
            dispatchException: function dispatchException(exception) {
              if (this.done) {
                throw exception;
              }

              var context = this;

              function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;

                if (caught) {
                  // If the dispatched exception was caught by a catch block,
                  // then let that catch block handle the exception normally.
                  context.method = "next";
                  context.arg = undefined;
                }

                return !!caught;
              }

              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                var record = entry.completion;

                if (entry.tryLoc === "root") {
                  // Exception thrown outside of any try block that could handle
                  // it, so set the completion value of the entire function to
                  // throw the exception.
                  return handle("end");
                }

                if (entry.tryLoc <= this.prev) {
                  var hasCatch = hasOwn.call(entry, "catchLoc");
                  var hasFinally = hasOwn.call(entry, "finallyLoc");

                  if (hasCatch && hasFinally) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    } else if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else if (hasCatch) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    }
                  } else if (hasFinally) {
                    if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else {
                    throw new Error("try statement without catch or finally");
                  }
                }
              }
            },
            abrupt: function abrupt(type, arg) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                  var finallyEntry = entry;
                  break;
                }
              }

              if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                // Ignore the finally entry if control is not jumping to a
                // location outside the try/catch block.
                finallyEntry = null;
              }

              var record = finallyEntry ? finallyEntry.completion : {};
              record.type = type;
              record.arg = arg;

              if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
              }

              return this.complete(record);
            },
            complete: function complete(record, afterLoc) {
              if (record.type === "throw") {
                throw record.arg;
              }

              if (record.type === "break" || record.type === "continue") {
                this.next = record.arg;
              } else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
              } else if (record.type === "normal" && afterLoc) {
                this.next = afterLoc;
              }

              return ContinueSentinel;
            },
            finish: function finish(finallyLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.finallyLoc === finallyLoc) {
                  this.complete(entry.completion, entry.afterLoc);
                  resetTryEntry(entry);
                  return ContinueSentinel;
                }
              }
            },
            "catch": function _catch(tryLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc === tryLoc) {
                  var record = entry.completion;

                  if (record.type === "throw") {
                    var thrown = record.arg;
                    resetTryEntry(entry);
                  }

                  return thrown;
                }
              } // The context.catch method must only be called with a location
              // argument that corresponds to a known catch block.


              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(iterable, resultName, nextLoc) {
              this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
              };

              if (this.method === "next") {
                // Deliberately forget the last sent value so that we don't
                // accidentally pass it on to the delegate.
                this.arg = undefined;
              }

              return ContinueSentinel;
            }
          }; // Regardless of whether this script is executing as a CommonJS module
          // or not, return the runtime object so that we can declare the variable
          // regeneratorRuntime in the outer scope, which allows this module to be
          // injected easily by `bin/regenerator --include-runtime script.js`.

          return exports;
        }( // If this script is executing as a CommonJS module, use module.exports
        // as the regeneratorRuntime namespace. Otherwise create a new empty
        // object. Either way, the resulting object will be used to initialize
        // the regeneratorRuntime variable at the top of this file.
        true ? module.exports : undefined);

        try {
          regeneratorRuntime = runtime;
        } catch (accidentalStrictMode) {
          // This module should not be running in strict mode, so the above
          // assignment should always work unless something is misconfigured. Just
          // in case runtime.js accidentally runs in strict mode, we can escape
          // strict mode using a global Function call. This could conceivably fail
          // if a Content Security Policy forbids using Function, but in that case
          // the proper solution is to fix the accidental strict mode problem. If
          // you've misconfigured your bundler to force strict mode and applied a
          // CSP to forbid Function, and you're not willing to fix either of those
          // problems, please detail your unique predicament in a GitHub issue.
          Function("r", "regeneratorRuntime = r")(runtime);
        }
        /***/

      },

      /***/
      "../../node_modules/setimmediate/setImmediate.js":
      /*!********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/setimmediate/setImmediate.js ***!
        \********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesSetimmediateSetImmediateJs(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (global, process) {
          (function (global, undefined) {
            "use strict";

            if (global.setImmediate) {
              return;
            }

            var nextHandle = 1; // Spec says greater than zero

            var tasksByHandle = {};
            var currentlyRunningATask = false;
            var doc = global.document;
            var registerImmediate;

            function setImmediate(callback) {
              // Callback can either be a function or a string
              if (typeof callback !== "function") {
                callback = new Function("" + callback);
              } // Copy function arguments


              var args = new Array(arguments.length - 1);

              for (var i = 0; i < args.length; i++) {
                args[i] = arguments[i + 1];
              } // Store and register the task


              var task = {
                callback: callback,
                args: args
              };
              tasksByHandle[nextHandle] = task;
              registerImmediate(nextHandle);
              return nextHandle++;
            }

            function clearImmediate(handle) {
              delete tasksByHandle[handle];
            }

            function run(task) {
              var callback = task.callback;
              var args = task.args;

              switch (args.length) {
                case 0:
                  callback();
                  break;

                case 1:
                  callback(args[0]);
                  break;

                case 2:
                  callback(args[0], args[1]);
                  break;

                case 3:
                  callback(args[0], args[1], args[2]);
                  break;

                default:
                  callback.apply(undefined, args);
                  break;
              }
            }

            function runIfPresent(handle) {
              // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
              // So if we're currently running a task, we'll need to delay this invocation.
              if (currentlyRunningATask) {
                // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
                // "too much recursion" error.
                setTimeout(runIfPresent, 0, handle);
              } else {
                var task = tasksByHandle[handle];

                if (task) {
                  currentlyRunningATask = true;

                  try {
                    run(task);
                  } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                  }
                }
              }
            }

            function installNextTickImplementation() {
              registerImmediate = function registerImmediate(handle) {
                process.nextTick(function () {
                  runIfPresent(handle);
                });
              };
            }

            function canUsePostMessage() {
              // The test against `importScripts` prevents this implementation from being installed inside a web worker,
              // where `global.postMessage` means something completely different and can't be used for this purpose.
              if (global.postMessage && !global.importScripts) {
                var postMessageIsAsynchronous = true;
                var oldOnMessage = global.onmessage;

                global.onmessage = function () {
                  postMessageIsAsynchronous = false;
                };

                global.postMessage("", "*");
                global.onmessage = oldOnMessage;
                return postMessageIsAsynchronous;
              }
            }

            function installPostMessageImplementation() {
              // Installs an event handler on `global` for the `message` event: see
              // * https://developer.mozilla.org/en/DOM/window.postMessage
              // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
              var messagePrefix = "setImmediate$" + Math.random() + "$";

              var onGlobalMessage = function onGlobalMessage(event) {
                if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                  runIfPresent(+event.data.slice(messagePrefix.length));
                }
              };

              if (global.addEventListener) {
                global.addEventListener("message", onGlobalMessage, false);
              } else {
                global.attachEvent("onmessage", onGlobalMessage);
              }

              registerImmediate = function registerImmediate(handle) {
                global.postMessage(messagePrefix + handle, "*");
              };
            }

            function installMessageChannelImplementation() {
              var channel = new MessageChannel();

              channel.port1.onmessage = function (event) {
                var handle = event.data;
                runIfPresent(handle);
              };

              registerImmediate = function registerImmediate(handle) {
                channel.port2.postMessage(handle);
              };
            }

            function installReadyStateChangeImplementation() {
              var html = doc.documentElement;

              registerImmediate = function registerImmediate(handle) {
                // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                var script = doc.createElement("script");

                script.onreadystatechange = function () {
                  runIfPresent(handle);
                  script.onreadystatechange = null;
                  html.removeChild(script);
                  script = null;
                };

                html.appendChild(script);
              };
            }

            function installSetTimeoutImplementation() {
              registerImmediate = function registerImmediate(handle) {
                setTimeout(runIfPresent, 0, handle);
              };
            } // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.


            var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
            attachTo = attachTo && attachTo.setTimeout ? attachTo : global; // Don't get fooled by e.g. browserify environments.

            if ({}.toString.call(global.process) === "[object process]") {
              // For Node.js before 0.9
              installNextTickImplementation();
            } else if (canUsePostMessage()) {
              // For non-IE10 modern browsers
              installPostMessageImplementation();
            } else if (global.MessageChannel) {
              // For web workers, where supported
              installMessageChannelImplementation();
            } else if (doc && "onreadystatechange" in doc.createElement("script")) {
              // For IE 6–8
              installReadyStateChangeImplementation();
            } else {
              // For older browsers
              installSetTimeoutImplementation();
            }

            attachTo.setImmediate = setImmediate;
            attachTo.clearImmediate = clearImmediate;
          })(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self);
          /* WEBPACK VAR INJECTION */

        }).call(this, __webpack_require__(
        /*! ./../../packages/store/node_modules/webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"), __webpack_require__(
        /*! ./../process/browser.js */
        "../../node_modules/process/browser.js"));
        /***/
      },

      /***/
      "../../node_modules/strip-hex-prefix/src/index.js":
      /*!*********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/strip-hex-prefix/src/index.js ***!
        \*********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesStripHexPrefixSrcIndexJs(module, exports, __webpack_require__) {
        var isHexPrefixed = __webpack_require__(
        /*! is-hex-prefixed */
        "../../node_modules/is-hex-prefixed/src/index.js");
        /**
         * Removes '0x' from a given `String` is present
         * @param {String} str the string value
         * @return {String|Optional} a string by pass if necessary
         */


        module.exports = function stripHexPrefix(str) {
          if (typeof str !== 'string') {
            return str;
          }

          return isHexPrefixed(str) ? str.slice(2) : str;
        };
        /***/

      },

      /***/
      "../../node_modules/timers-browserify/main.js":
      /*!*****************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/timers-browserify/main.js ***!
        \*****************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesTimersBrowserifyMainJs(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (global) {
          var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
          var apply = Function.prototype.apply; // DOM APIs, for completeness

          exports.setTimeout = function () {
            return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
          };

          exports.setInterval = function () {
            return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
          };

          exports.clearTimeout = exports.clearInterval = function (timeout) {
            if (timeout) {
              timeout.close();
            }
          };

          function Timeout(id, clearFn) {
            this._id = id;
            this._clearFn = clearFn;
          }

          Timeout.prototype.unref = Timeout.prototype.ref = function () {};

          Timeout.prototype.close = function () {
            this._clearFn.call(scope, this._id);
          }; // Does not start the time, just sets up the members needed.


          exports.enroll = function (item, msecs) {
            clearTimeout(item._idleTimeoutId);
            item._idleTimeout = msecs;
          };

          exports.unenroll = function (item) {
            clearTimeout(item._idleTimeoutId);
            item._idleTimeout = -1;
          };

          exports._unrefActive = exports.active = function (item) {
            clearTimeout(item._idleTimeoutId);
            var msecs = item._idleTimeout;

            if (msecs >= 0) {
              item._idleTimeoutId = setTimeout(function onTimeout() {
                if (item._onTimeout) item._onTimeout();
              }, msecs);
            }
          }; // setimmediate attaches itself to the global object


          __webpack_require__(
          /*! setimmediate */
          "../../node_modules/setimmediate/setImmediate.js"); // On some exotic environments, it's not clear which object `setimmediate` was
          // able to install onto.  Search each possibility in the same order as the
          // `setimmediate` library.


          exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || this && this.setImmediate;
          exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || this && this.clearImmediate;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../../packages/store/node_modules/webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"));
        /***/
      },

      /***/
      "../../node_modules/util/node_modules/inherits/inherits_browser.js":
      /*!**************************************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/util/node_modules/inherits/inherits_browser.js ***!
        \**************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesUtilNode_modulesInheritsInherits_browserJs(module, exports) {
        if (typeof Object.create === 'function') {
          // implementation from standard node.js 'util' module
          module.exports = function inherits(ctor, superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
              constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
              }
            });
          };
        } else {
          // old school shim for old browsers
          module.exports = function inherits(ctor, superCtor) {
            ctor.super_ = superCtor;

            var TempCtor = function TempCtor() {};

            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
          };
        }
        /***/

      },

      /***/
      "../../node_modules/util/support/isBufferBrowser.js":
      /*!***********************************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/util/support/isBufferBrowser.js ***!
        \***********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesUtilSupportIsBufferBrowserJs(module, exports) {
        module.exports = function isBuffer(arg) {
          return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
        };
        /***/

      },

      /***/
      "../../node_modules/util/util.js":
      /*!****************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/util/util.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesUtilUtilJs(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (process) {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
            var keys = Object.keys(obj);
            var descriptors = {};

            for (var i = 0; i < keys.length; i++) {
              descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
            }

            return descriptors;
          };

          var formatRegExp = /%[sdj%]/g;

          exports.format = function (f) {
            if (!isString(f)) {
              var objects = [];

              for (var i = 0; i < arguments.length; i++) {
                objects.push(inspect(arguments[i]));
              }

              return objects.join(' ');
            }

            var i = 1;
            var args = arguments;
            var len = args.length;
            var str = String(f).replace(formatRegExp, function (x) {
              if (x === '%%') return '%';
              if (i >= len) return x;

              switch (x) {
                case '%s':
                  return String(args[i++]);

                case '%d':
                  return Number(args[i++]);

                case '%j':
                  try {
                    return JSON.stringify(args[i++]);
                  } catch (_) {
                    return '[Circular]';
                  }

                default:
                  return x;
              }
            });

            for (var x = args[i]; i < len; x = args[++i]) {
              if (isNull(x) || !isObject(x)) {
                str += ' ' + x;
              } else {
                str += ' ' + inspect(x);
              }
            }

            return str;
          }; // Mark that a method should not be used.
          // Returns a modified function which warns once by default.
          // If --no-deprecation is set, then it is a no-op.


          exports.deprecate = function (fn, msg) {
            if (typeof process !== 'undefined' && process.noDeprecation === true) {
              return fn;
            } // Allow for deprecating things in the process of starting up.


            if (typeof process === 'undefined') {
              return function () {
                return exports.deprecate(fn, msg).apply(this, arguments);
              };
            }

            var warned = false;

            function deprecated() {
              if (!warned) {
                if (process.throwDeprecation) {
                  throw new Error(msg);
                } else if (process.traceDeprecation) {
                  console.trace(msg);
                } else {
                  console.error(msg);
                }

                warned = true;
              }

              return fn.apply(this, arguments);
            }

            return deprecated;
          };

          var debugs = {};
          var debugEnviron;

          exports.debuglog = function (set) {
            if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || '';
            set = set.toUpperCase();

            if (!debugs[set]) {
              if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
                var pid = process.pid;

                debugs[set] = function () {
                  var msg = exports.format.apply(exports, arguments);
                  console.error('%s %d: %s', set, pid, msg);
                };
              } else {
                debugs[set] = function () {};
              }
            }

            return debugs[set];
          };
          /**
           * Echos the value of a value. Trys to print the value out
           * in the best way possible given the different types.
           *
           * @param {Object} obj The object to print out.
           * @param {Object} opts Optional options object that alters the output.
           */

          /* legacy: obj, showHidden, depth, colors*/


          function inspect(obj, opts) {
            // default options
            var ctx = {
              seen: [],
              stylize: stylizeNoColor
            }; // legacy...

            if (arguments.length >= 3) ctx.depth = arguments[2];
            if (arguments.length >= 4) ctx.colors = arguments[3];

            if (isBoolean(opts)) {
              // legacy...
              ctx.showHidden = opts;
            } else if (opts) {
              // got an "options" object
              exports._extend(ctx, opts);
            } // set default options


            if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
            if (isUndefined(ctx.depth)) ctx.depth = 2;
            if (isUndefined(ctx.colors)) ctx.colors = false;
            if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
            if (ctx.colors) ctx.stylize = stylizeWithColor;
            return formatValue(ctx, obj, ctx.depth);
          }

          exports.inspect = inspect; // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics

          inspect.colors = {
            'bold': [1, 22],
            'italic': [3, 23],
            'underline': [4, 24],
            'inverse': [7, 27],
            'white': [37, 39],
            'grey': [90, 39],
            'black': [30, 39],
            'blue': [34, 39],
            'cyan': [36, 39],
            'green': [32, 39],
            'magenta': [35, 39],
            'red': [31, 39],
            'yellow': [33, 39]
          }; // Don't use 'blue' not visible on cmd.exe

          inspect.styles = {
            'special': 'cyan',
            'number': 'yellow',
            'boolean': 'yellow',
            'undefined': 'grey',
            'null': 'bold',
            'string': 'green',
            'date': 'magenta',
            // "name": intentionally not styling
            'regexp': 'red'
          };

          function stylizeWithColor(str, styleType) {
            var style = inspect.styles[styleType];

            if (style) {
              return "\x1B[" + inspect.colors[style][0] + 'm' + str + "\x1B[" + inspect.colors[style][1] + 'm';
            } else {
              return str;
            }
          }

          function stylizeNoColor(str, styleType) {
            return str;
          }

          function arrayToHash(array) {
            var hash = {};
            array.forEach(function (val, idx) {
              hash[val] = true;
            });
            return hash;
          }

          function formatValue(ctx, value, recurseTimes) {
            // Provide a hook for user-specified inspect functions.
            // Check that value is an object with an inspect function on it
            if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
            value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
            !(value.constructor && value.constructor.prototype === value)) {
              var ret = value.inspect(recurseTimes, ctx);

              if (!isString(ret)) {
                ret = formatValue(ctx, ret, recurseTimes);
              }

              return ret;
            } // Primitive types cannot have properties


            var primitive = formatPrimitive(ctx, value);

            if (primitive) {
              return primitive;
            } // Look up the keys of the object.


            var keys = Object.keys(value);
            var visibleKeys = arrayToHash(keys);

            if (ctx.showHidden) {
              keys = Object.getOwnPropertyNames(value);
            } // IE doesn't make error fields non-enumerable
            // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx


            if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
              return formatError(value);
            } // Some type of object without properties can be shortcutted.


            if (keys.length === 0) {
              if (isFunction(value)) {
                var name = value.name ? ': ' + value.name : '';
                return ctx.stylize('[Function' + name + ']', 'special');
              }

              if (isRegExp(value)) {
                return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
              }

              if (isDate(value)) {
                return ctx.stylize(Date.prototype.toString.call(value), 'date');
              }

              if (isError(value)) {
                return formatError(value);
              }
            }

            var base = '',
                array = false,
                braces = ['{', '}']; // Make Array say that they are Array

            if (isArray(value)) {
              array = true;
              braces = ['[', ']'];
            } // Make functions say that they are functions


            if (isFunction(value)) {
              var n = value.name ? ': ' + value.name : '';
              base = ' [Function' + n + ']';
            } // Make RegExps say that they are RegExps


            if (isRegExp(value)) {
              base = ' ' + RegExp.prototype.toString.call(value);
            } // Make dates with properties first say the date


            if (isDate(value)) {
              base = ' ' + Date.prototype.toUTCString.call(value);
            } // Make error with message first say the error


            if (isError(value)) {
              base = ' ' + formatError(value);
            }

            if (keys.length === 0 && (!array || value.length == 0)) {
              return braces[0] + base + braces[1];
            }

            if (recurseTimes < 0) {
              if (isRegExp(value)) {
                return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
              } else {
                return ctx.stylize('[Object]', 'special');
              }
            }

            ctx.seen.push(value);
            var output;

            if (array) {
              output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
            } else {
              output = keys.map(function (key) {
                return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
              });
            }

            ctx.seen.pop();
            return reduceToSingleString(output, base, braces);
          }

          function formatPrimitive(ctx, value) {
            if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');

            if (isString(value)) {
              var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
              return ctx.stylize(simple, 'string');
            }

            if (isNumber(value)) return ctx.stylize('' + value, 'number');
            if (isBoolean(value)) return ctx.stylize('' + value, 'boolean'); // For some reason typeof null is "object", so special case here.

            if (isNull(value)) return ctx.stylize('null', 'null');
          }

          function formatError(value) {
            return '[' + Error.prototype.toString.call(value) + ']';
          }

          function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
            var output = [];

            for (var i = 0, l = value.length; i < l; ++i) {
              if (hasOwnProperty(value, String(i))) {
                output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
              } else {
                output.push('');
              }
            }

            keys.forEach(function (key) {
              if (!key.match(/^\d+$/)) {
                output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
              }
            });
            return output;
          }

          function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
            var name, str, desc;
            desc = Object.getOwnPropertyDescriptor(value, key) || {
              value: value[key]
            };

            if (desc.get) {
              if (desc.set) {
                str = ctx.stylize('[Getter/Setter]', 'special');
              } else {
                str = ctx.stylize('[Getter]', 'special');
              }
            } else {
              if (desc.set) {
                str = ctx.stylize('[Setter]', 'special');
              }
            }

            if (!hasOwnProperty(visibleKeys, key)) {
              name = '[' + key + ']';
            }

            if (!str) {
              if (ctx.seen.indexOf(desc.value) < 0) {
                if (isNull(recurseTimes)) {
                  str = formatValue(ctx, desc.value, null);
                } else {
                  str = formatValue(ctx, desc.value, recurseTimes - 1);
                }

                if (str.indexOf('\n') > -1) {
                  if (array) {
                    str = str.split('\n').map(function (line) {
                      return '  ' + line;
                    }).join('\n').substr(2);
                  } else {
                    str = '\n' + str.split('\n').map(function (line) {
                      return '   ' + line;
                    }).join('\n');
                  }
                }
              } else {
                str = ctx.stylize('[Circular]', 'special');
              }
            }

            if (isUndefined(name)) {
              if (array && key.match(/^\d+$/)) {
                return str;
              }

              name = JSON.stringify('' + key);

              if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                name = name.substr(1, name.length - 2);
                name = ctx.stylize(name, 'name');
              } else {
                name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                name = ctx.stylize(name, 'string');
              }
            }

            return name + ': ' + str;
          }

          function reduceToSingleString(output, base, braces) {
            var numLinesEst = 0;
            var length = output.reduce(function (prev, cur) {
              numLinesEst++;
              if (cur.indexOf('\n') >= 0) numLinesEst++;
              return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
            }, 0);

            if (length > 60) {
              return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
            }

            return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
          } // NOTE: These type checking functions intentionally don't use `instanceof`
          // because it is fragile and can be easily faked with `Object.create()`.


          function isArray(ar) {
            return Array.isArray(ar);
          }

          exports.isArray = isArray;

          function isBoolean(arg) {
            return typeof arg === 'boolean';
          }

          exports.isBoolean = isBoolean;

          function isNull(arg) {
            return arg === null;
          }

          exports.isNull = isNull;

          function isNullOrUndefined(arg) {
            return arg == null;
          }

          exports.isNullOrUndefined = isNullOrUndefined;

          function isNumber(arg) {
            return typeof arg === 'number';
          }

          exports.isNumber = isNumber;

          function isString(arg) {
            return typeof arg === 'string';
          }

          exports.isString = isString;

          function isSymbol(arg) {
            return typeof arg === 'symbol';
          }

          exports.isSymbol = isSymbol;

          function isUndefined(arg) {
            return arg === void 0;
          }

          exports.isUndefined = isUndefined;

          function isRegExp(re) {
            return isObject(re) && objectToString(re) === '[object RegExp]';
          }

          exports.isRegExp = isRegExp;

          function isObject(arg) {
            return typeof arg === 'object' && arg !== null;
          }

          exports.isObject = isObject;

          function isDate(d) {
            return isObject(d) && objectToString(d) === '[object Date]';
          }

          exports.isDate = isDate;

          function isError(e) {
            return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
          }

          exports.isError = isError;

          function isFunction(arg) {
            return typeof arg === 'function';
          }

          exports.isFunction = isFunction;

          function isPrimitive(arg) {
            return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
            typeof arg === 'undefined';
          }

          exports.isPrimitive = isPrimitive;
          exports.isBuffer = __webpack_require__(
          /*! ./support/isBuffer */
          "../../node_modules/util/support/isBufferBrowser.js");

          function objectToString(o) {
            return Object.prototype.toString.call(o);
          }

          function pad(n) {
            return n < 10 ? '0' + n.toString(10) : n.toString(10);
          }

          var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']; // 26 Feb 16:19:34

          function timestamp() {
            var d = new Date();
            var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
            return [d.getDate(), months[d.getMonth()], time].join(' ');
          } // log is just a thin wrapper to console.log that prepends a timestamp


          exports.log = function () {
            console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
          };
          /**
           * Inherit the prototype methods from one constructor into another.
           *
           * The Function.prototype.inherits from lang.js rewritten as a standalone
           * function (not on Function.prototype). NOTE: If this file is to be loaded
           * during bootstrapping this function needs to be rewritten using some native
           * functions as prototype setup using normal JavaScript does not work as
           * expected during bootstrapping (see mirror.js in r114903).
           *
           * @param {function} ctor Constructor function which needs to inherit the
           *     prototype.
           * @param {function} superCtor Constructor function to inherit prototype from.
           */


          exports.inherits = __webpack_require__(
          /*! inherits */
          "../../node_modules/util/node_modules/inherits/inherits_browser.js");

          exports._extend = function (origin, add) {
            // Don't do anything if add isn't an object
            if (!add || !isObject(add)) return origin;
            var keys = Object.keys(add);
            var i = keys.length;

            while (i--) {
              origin[keys[i]] = add[keys[i]];
            }

            return origin;
          };

          function hasOwnProperty(obj, prop) {
            return Object.prototype.hasOwnProperty.call(obj, prop);
          }

          var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

          exports.promisify = function promisify(original) {
            if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');

            if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
              var fn = original[kCustomPromisifiedSymbol];

              if (typeof fn !== 'function') {
                throw new TypeError('The "util.promisify.custom" argument must be of type Function');
              }

              Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                value: fn,
                enumerable: false,
                writable: false,
                configurable: true
              });
              return fn;
            }

            function fn() {
              var promiseResolve, promiseReject;
              var promise = new Promise(function (resolve, reject) {
                promiseResolve = resolve;
                promiseReject = reject;
              });
              var args = [];

              for (var i = 0; i < arguments.length; i++) {
                args.push(arguments[i]);
              }

              args.push(function (err, value) {
                if (err) {
                  promiseReject(err);
                } else {
                  promiseResolve(value);
                }
              });

              try {
                original.apply(this, args);
              } catch (err) {
                promiseReject(err);
              }

              return promise;
            }

            Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
            if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
              value: fn,
              enumerable: false,
              writable: false,
              configurable: true
            });
            return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
          };

          exports.promisify.custom = kCustomPromisifiedSymbol;

          function callbackifyOnRejected(reason, cb) {
            // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
            // Because `null` is a special error value in callbacks which means "no error
            // occurred", we error-wrap so the callback consumer can distinguish between
            // "the promise rejected with null" or "the promise fulfilled with undefined".
            if (!reason) {
              var newReason = new Error('Promise was rejected with a falsy value');
              newReason.reason = reason;
              reason = newReason;
            }

            return cb(reason);
          }

          function callbackify(original) {
            if (typeof original !== 'function') {
              throw new TypeError('The "original" argument must be of type Function');
            } // We DO NOT return the promise as it gives the user a false sense that
            // the promise is actually somehow related to the callback's execution
            // and that the callback throwing will reject the promise.


            function callbackified() {
              var args = [];

              for (var i = 0; i < arguments.length; i++) {
                args.push(arguments[i]);
              }

              var maybeCb = args.pop();

              if (typeof maybeCb !== 'function') {
                throw new TypeError('The last argument must be of type Function');
              }

              var self = this;

              var cb = function cb() {
                return maybeCb.apply(self, arguments);
              }; // In true node style we process the callback on `nextTick` with all the
              // implications (stack, `uncaughtException`, `async_hooks`)


              original.apply(this, args).then(function (ret) {
                process.nextTick(cb, null, ret);
              }, function (rej) {
                process.nextTick(callbackifyOnRejected, rej, cb);
              });
            }

            Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
            Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
            return callbackified;
          }

          exports.callbackify = callbackify;
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../process/browser.js */
        "../../node_modules/process/browser.js"));
        /***/
      },

      /***/
      "../../node_modules/xtend/immutable.js":
      /*!**********************************************************************!*\
        !*** /Users/amal/work/drizzle-suite/node_modules/xtend/immutable.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesXtendImmutableJs(module, exports) {
        module.exports = extend;
        var hasOwnProperty = Object.prototype.hasOwnProperty;

        function extend() {
          var target = {};

          for (var i = 0; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        }
        /***/

      },

      /***/
      "./node_modules/webpack/buildin/global.js":
      /*!***********************************!*\
        !*** (webpack)/buildin/global.js ***!
        \***********************************/

      /*! no static exports found */

      /***/
      function node_modulesWebpackBuildinGlobalJs(module, exports) {
        var g; // This works in non-strict mode

        g = function () {
          return this;
        }();

        try {
          // This works if eval is allowed (see CSP)
          g = g || new Function("return this")();
        } catch (e) {
          // This works if the window reference is available
          if (typeof window === "object") g = window;
        } // g can still be undefined, but nothing to do about it...
        // We return undefined, instead of nothing here, so it's
        // easier to handle this case. if(!global) { ...}


        module.exports = g;
        /***/
      },

      /***/
      "./node_modules/webpack/buildin/module.js":
      /*!***********************************!*\
        !*** (webpack)/buildin/module.js ***!
        \***********************************/

      /*! no static exports found */

      /***/
      function node_modulesWebpackBuildinModuleJs(module, exports) {
        module.exports = function (module) {
          if (!module.webpackPolyfill) {
            module.deprecate = function () {};

            module.paths = []; // module.parent = undefined by default

            if (!module.children) module.children = [];
            Object.defineProperty(module, "loaded", {
              enumerable: true,
              get: function get() {
                return module.l;
              }
            });
            Object.defineProperty(module, "id", {
              enumerable: true,
              get: function get() {
                return module.i;
              }
            });
            module.webpackPolyfill = 1;
          }

          return module;
        };
        /***/

      },

      /***/
      "./src/Drizzle.js":
      /*!************************!*\
        !*** ./src/Drizzle.js ***!
        \************************/

      /*! exports provided: getOrCreateWeb3Contract, default */

      /***/
      function srcDrizzleJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getOrCreateWeb3Contract", function () {
          return getOrCreateWeb3Contract;
        });
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../../node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/objectWithoutProperties */
        "../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
        /* harmony import */


        var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../../node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../../node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _generateStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./generateStore */
        "./src/generateStore.js");
        /* harmony import */


        var _defaultOptions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./defaultOptions */
        "./src/defaultOptions.js");
        /* harmony import */


        var _mergeOptions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./mergeOptions */
        "./src/mergeOptions.js");
        /* harmony import */


        var _DrizzleContract__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./DrizzleContract */
        "./src/DrizzleContract.js");

        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");

          return _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(key) === "symbol" ? key : String(key);
        }

        function _toPrimitive(input, hint) {
          if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];

          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return (hint === "string" ? String : Number)(input);
        } // Load as promise so that async Drizzle initialization can still resolve


        var isEnvReadyPromise = new Promise(function (resolve, reject) {
          var hasNavigator = typeof navigator !== 'undefined';
          var hasWindow = typeof window !== 'undefined';
          var hasDocument = typeof document !== 'undefined';

          if (hasNavigator && navigator.product === 'ReactNative') {
            return resolve();
          }

          if (hasWindow) {
            return window.addEventListener('load', resolve);
          } // resolve in any case if we missed the load event and the document is already loaded


          if (hasDocument && document.readyState === "complete") {
            return resolve();
          }
        });

        var getOrCreateWeb3Contract = function getOrCreateWeb3Contract(store, contractConfig, web3) {
          if (contractConfig.web3Contract) {
            return contractConfig.web3Contract;
          }

          var state = store.getState();
          var networkId = state.web3 && state.web3.networkId;
          var selectedAccount = state.accounts[0];
          var abi = contractConfig.abi,
              networks = contractConfig.networks,
              deployedBytecode = contractConfig.deployedBytecode;
          return new web3.eth.Contract(abi, networks[networkId].address, {
            from: selectedAccount,
            data: deployedBytecode
          });
        };

        var Drizzle =
        /*#__PURE__*/
        function () {
          function Drizzle(givenOptions, store) {
            var _this = this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Drizzle);

            var options = Object(_mergeOptions__WEBPACK_IMPORTED_MODULE_6__["default"])(_defaultOptions__WEBPACK_IMPORTED_MODULE_5__["default"], givenOptions); // Variables

            this.contracts = {};
            this.contractList = [];
            this.options = options;
            this.store = store || this.generateStore(options);
            this.web3 = {};
            this.loadingContract = {}; // Wait for window load event in case of injected web3.

            isEnvReadyPromise.then(function () {
              // Begin Drizzle initialization.
              _this.store.dispatch({
                type: 'DRIZZLE_INITIALIZING',
                drizzle: _this,
                options: options
              });
            });
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Drizzle, [{
            key: "addContract",
            value: function addContract(contractConfig) {
              var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
              var web3Contract = getOrCreateWeb3Contract(this.store, contractConfig, this.web3);
              var drizzleContract = new _DrizzleContract__WEBPACK_IMPORTED_MODULE_7__["default"](web3Contract, this.web3, contractConfig.contractName, this.store, events);

              if (this.contracts[drizzleContract.contractName]) {
                throw new Error("Contract already exists: ".concat(drizzleContract.contractName));
              }

              this.store.dispatch({
                type: 'CONTRACT_INITIALIZING',
                contractConfig: contractConfig
              });
              this.contracts[drizzleContract.contractName] = drizzleContract;
              this.contractList.push(drizzleContract);
              this.store.dispatch({
                type: 'CONTRACT_INITIALIZED',
                name: contractConfig.contractName
              });
            }
          }, {
            key: "deleteContract",
            value: function deleteContract(contractName) {
              // Deleting a contract means removing it from this instance's
              // `contractList`, `contracts`, and `loadingContract`
              if (!this.contracts[contractName]) {
                throw new Error("Contract does not exist: ".concat(contractName));
              }

              this.contractList = this.contractList.filter(function (contract) {
                return contract.contractName !== contractName;
              });

              var _this$contracts = this.contracts,
                  omittedContract = _this$contracts[contractName],
                  restContracts = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(_this$contracts, [contractName].map(_toPropertyKey));

              this.contracts = restContracts;

              var _this$loadingContract = this.loadingContract,
                  omittedLoading = _this$loadingContract[contractName],
                  restLoadingContract = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(_this$loadingContract, [contractName].map(_toPropertyKey));

              this.loadingContract = restLoadingContract;
              this.store.dispatch({
                type: 'DELETE_CONTRACT',
                contractName: contractName
              });
            }
          }, {
            key: "findContractByAddress",
            value: function findContractByAddress(address) {
              return this.contractList.find(function (contract) {
                return contract.address.toLowerCase() === address.toLowerCase();
              });
            }
            /*
             * NOTE
             * This strangeness is for backward compatibility with < v1.2.4
             * Future versions will have generateStore's contents here
             */

          }, {
            key: "generateStore",
            value: function generateStore(options) {
              return Object(_generateStore__WEBPACK_IMPORTED_MODULE_4__["generateStore"])(options);
            }
          }]);

          return Drizzle;
        }();
        /* harmony default export */


        __webpack_exports__["default"] = Drizzle;
        /***/
      },

      /***/
      "./src/DrizzleContract.js":
      /*!********************************!*\
        !*** ./src/DrizzleContract.js ***!
        \********************************/

      /*! exports provided: default */

      /***/
      function srcDrizzleContractJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../../node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../../node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../../node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);

        var DrizzleContract =
        /*#__PURE__*/
        function () {
          function DrizzleContract(web3Contract, web3, name, store) {
            var events = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
            var contractArtifact = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, DrizzleContract);

            this.abi = web3Contract.options.jsonInterface;
            this.address = web3Contract.options.address;
            this.web3 = web3;
            this.contractName = name;
            this.contractArtifact = contractArtifact;
            this.store = store; // Merge web3 contract instance into DrizzleContract instance.

            Object.assign(this, web3Contract);

            for (var i = 0; i < this.abi.length; i++) {
              var item = this.abi[i];

              if (item.type == 'function' && item.constant === true) {
                this.methods[item.name].cacheCall = this.cacheCallFunction(item.name, i);
              }

              if (item.type == 'function' && item.constant === false) {
                this.methods[item.name].cacheSend = this.cacheSendFunction(item.name, i);
              }
            } // Register event listeners if any events.


            if (events.length > 0) {
              for (i = 0; i < events.length; i++) {
                var event = events[i];

                if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(event) === 'object') {
                  store.dispatch({
                    type: 'LISTEN_FOR_EVENT',
                    contract: this,
                    eventName: event.eventName,
                    eventOptions: event.eventOptions
                  });
                } else {
                  store.dispatch({
                    type: 'LISTEN_FOR_EVENT',
                    contract: this,
                    eventName: event
                  });
                }
              }
            }
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(DrizzleContract, [{
            key: "cacheCallFunction",
            value: function cacheCallFunction(fnName, fnIndex, fn) {
              var contract = this;
              return function () {
                // Collect args and hash to use as key, 0x0 if no args
                var argsHash = '0x0';
                var args = arguments;

                if (args.length > 0) {
                  argsHash = contract.generateArgsHash(args);
                }

                var contractName = contract.contractName;
                var functionState = contract.store.getState().contracts[contractName][fnName]; // If call result is in state and fresh, return value instead of calling

                if (argsHash in functionState) {
                  if (contract.store.getState().contracts[contractName].synced === true) {
                    return argsHash;
                  }
                } // Otherwise, call function and update store


                contract.store.dispatch({
                  type: 'CALL_CONTRACT_FN',
                  contract: contract,
                  fnName: fnName,
                  fnIndex: fnIndex,
                  args: args,
                  argsHash: argsHash
                }); // Return nothing because state is currently empty.

                return argsHash;
              };
            }
          }, {
            key: "cacheSendFunction",
            value: function cacheSendFunction(fnName, fnIndex, fn) {
              // NOTE: May not need fn index
              var contract = this;
              return function () {
                var args = arguments; // Generate temporary ID

                var transactionStack = contract.store.getState().transactionStack;
                var stackId = transactionStack.length;
                var stackTempKey = "TEMP_".concat(new Date().getTime()); // Add ID to "transactionStack" with temp value, will be overwritten on TX_BROADCASTED

                contract.store.dispatch({
                  type: 'PUSH_TO_TXSTACK',
                  stackTempKey: stackTempKey
                }); // Dispatch tx to saga
                // When txhash received, will be value of stack ID

                contract.store.dispatch({
                  type: 'SEND_CONTRACT_TX',
                  contract: contract,
                  fnName: fnName,
                  fnIndex: fnIndex,
                  args: args,
                  stackId: stackId,
                  stackTempKey: stackTempKey
                }); // return stack ID

                return stackId;
              };
            }
          }, {
            key: "generateArgsHash",
            value: function generateArgsHash(args) {
              var web3 = this.web3;
              var hashString = '';

              for (var i = 0; i < args.length; i++) {
                if (typeof args[i] !== 'function') {
                  var argToHash = args[i]; // Stringify objects to allow hashing

                  if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(argToHash) === 'object') {
                    argToHash = JSON.stringify(argToHash);
                  } // Convert number to strong to allow hashing


                  if (typeof argToHash === 'number') {
                    argToHash = argToHash.toString();
                  } // This check is in place for web3 v0.x


                  if ('utils' in web3) {
                    var hashPiece = web3.utils.sha3(argToHash);
                  } else {
                    var hashPiece = web3.sha3(argToHash);
                  }

                  hashString += hashPiece;
                }
              }

              return web3.utils.sha3(hashString);
            }
          }]);

          return DrizzleContract;
        }();
        /* harmony default export */


        __webpack_exports__["default"] = DrizzleContract;
        /***/
      },

      /***/
      "./src/accountBalances/accountBalancesReducer.js":
      /*!*******************************************************!*\
        !*** ./src/accountBalances/accountBalancesReducer.js ***!
        \*******************************************************/

      /*! exports provided: default */

      /***/
      function srcAccountBalancesAccountBalancesReducerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../../node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);

        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);

          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function (sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
          }

          return keys;
        }

        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};

            if (i % 2) {
              ownKeys(source, true).forEach(function (key) {
                _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(source).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }

          return target;
        }

        var initialState = {};

        var accountBalancesReducer = function accountBalancesReducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments.length > 1 ? arguments[1] : undefined;

          if (action.type === 'ACCOUNT_BALANCE_FETCHED') {
            return _objectSpread({}, state, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, action.account, action.accountBalance));
          }

          return state;
        };
        /* harmony default export */


        __webpack_exports__["default"] = accountBalancesReducer;
        /***/
      },

      /***/
      "./src/accountBalances/accountBalancesSaga.js":
      /*!****************************************************!*\
        !*** ./src/accountBalances/accountBalancesSaga.js ***!
        \****************************************************/

      /*! exports provided: getAccountBalances, getAccountsState, default */

      /***/
      function srcAccountBalancesAccountBalancesSagaJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getAccountBalances", function () {
          return getAccountBalances;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getAccountsState", function () {
          return getAccountsState;
        });
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/regenerator */
        "../../node_modules/@babel/runtime/regenerator/index.js");
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! redux-saga/effects */
        "../../node_modules/redux-saga/es/effects.js");

        var _marked =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(getAccountBalances),
            _marked2 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(accountBalancesSaga);

        function getAccountBalances(action) {
          var accounts, web3, i, account, accountBalance;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function getAccountBalances$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["select"])(getAccountsState);

                case 2:
                  accounts = _context.sent;
                  web3 = action.web3;

                  if (!accounts) {
                    console.error('No accounts found while attempting to fetch balances!');
                  }

                  _context.prev = 5;
                  _context.t0 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.keys(accounts);

                case 7:
                  if ((_context.t1 = _context.t0()).done) {
                    _context.next = 17;
                    break;
                  }

                  i = _context.t1.value;
                  account = accounts[i];
                  _context.next = 12;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["call"])(web3.eth.getBalance, account);

                case 12:
                  accountBalance = _context.sent;
                  _context.next = 15;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: 'ACCOUNT_BALANCE_FETCHED',
                    account: account,
                    accountBalance: accountBalance
                  });

                case 15:
                  _context.next = 7;
                  break;

                case 17:
                  _context.next = 25;
                  break;

                case 19:
                  _context.prev = 19;
                  _context.t2 = _context["catch"](5);
                  _context.next = 23;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: 'ACCOUNT_BALANCE_FAILED',
                    error: _context.t2
                  });

                case 23:
                  console.error('Error fetching account ' + account + ' balance:');
                  console.error(_context.t2);

                case 25:
                  _context.next = 27;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: 'ACCOUNT_BALANCES_FETCHED'
                  });

                case 27:
                case "end":
                  return _context.stop();
              }
            }
          }, _marked, null, [[5, 19]]);
        }

        var getAccountsState = function getAccountsState(state) {
          return state.accounts;
        };

        function accountBalancesSaga() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function accountBalancesSaga$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["takeLatest"])('ACCOUNT_BALANCES_FETCHING', getAccountBalances);

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _marked2);
        }
        /* harmony default export */


        __webpack_exports__["default"] = accountBalancesSaga;
        /***/
      },

      /***/
      "./src/accounts/accountsReducer.js":
      /*!*****************************************!*\
        !*** ./src/accounts/accountsReducer.js ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function srcAccountsAccountsReducerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);

        var initialState = {};

        var accountsReducer = function accountsReducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments.length > 1 ? arguments[1] : undefined;

          if (action.type === 'ACCOUNTS_FETCHING') {
            return state;
          }

          if (action.type === 'ACCOUNTS_FETCHED') {
            return Object.assign({}, state, action.accounts);
          }

          return state;
        };
        /* harmony default export */


        __webpack_exports__["default"] = accountsReducer;
        /***/
      },

      /***/
      "./src/accounts/accountsSaga.js":
      /*!**************************************!*\
        !*** ./src/accounts/accountsSaga.js ***!
        \**************************************/

      /*! exports provided: getAccounts, default */

      /***/
      function srcAccountsAccountsSagaJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getAccounts", function () {
          return getAccounts;
        });
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/regenerator */
        "../../node_modules/@babel/runtime/regenerator/index.js");
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var redux_saga__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! redux-saga */
        "redux-saga");
        /* harmony import */


        var redux_saga__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(redux_saga__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! redux-saga/effects */
        "../../node_modules/redux-saga/es/effects.js");
        /* harmony import */


        var _accountBalances_accountBalancesSaga__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../accountBalances/accountBalancesSaga */
        "./src/accountBalances/accountBalancesSaga.js");

        var _marked =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(getAccounts),
            _marked2 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(createAccountsPollChannel),
            _marked3 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(callCreateAccountsPollChannel),
            _marked4 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(accountsSaga);
        /*
         * Fetch Accounts List
         */


        function getAccounts(action) {
          var web3, accounts;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function getAccounts$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  web3 = action.web3;
                  _context.prev = 1;
                  _context.next = 4;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["call"])(web3.eth.getAccounts);

                case 4:
                  accounts = _context.sent;

                  if (accounts) {
                    _context.next = 7;
                    break;
                  }

                  throw 'No accounts found!';

                case 7:
                  _context.next = 9;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["put"])({
                    type: 'ACCOUNTS_FETCHED',
                    accounts: accounts
                  });

                case 9:
                  _context.next = 17;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](1);
                  _context.next = 15;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["put"])({
                    type: 'ACCOUNTS_FAILED',
                    error: _context.t0
                  });

                case 15:
                  console.error('Error fetching accounts:');
                  console.error(_context.t0);

                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _marked, null, [[1, 11]]);
        }
        /*
         * Poll for Account Changes
         */


        function createAccountsPollChannel(_ref) {
          var interval, web3;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function createAccountsPollChannel$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  interval = _ref.interval, web3 = _ref.web3;
                  return _context2.abrupt("return", Object(redux_saga__WEBPACK_IMPORTED_MODULE_1__["eventChannel"])(function (emit) {
                    var persistedWeb3 = web3;
                    var accountsPoller = setInterval(function () {
                      emit({
                        type: 'SYNCING_ACCOUNTS',
                        persistedWeb3: persistedWeb3
                      });
                    }, interval); // options.polls.accounts

                    var unsubscribe = function unsubscribe() {
                      clearInterval(accountsPoller);
                    };

                    return unsubscribe;
                  }));

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _marked2);
        }

        function callCreateAccountsPollChannel(_ref2) {
          var interval, web3, accountsChannel, event;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function callCreateAccountsPollChannel$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  interval = _ref2.interval, web3 = _ref2.web3;
                  _context3.next = 3;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["call"])(createAccountsPollChannel, {
                    interval: interval,
                    web3: web3
                  });

                case 3:
                  accountsChannel = _context3.sent;
                  _context3.prev = 4;

                case 5:
                  if (false) {}

                  _context3.next = 8;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["take"])(accountsChannel);

                case 8:
                  event = _context3.sent;

                  if (!(event.type === 'SYNCING_ACCOUNTS')) {
                    _context3.next = 14;
                    break;
                  }

                  _context3.next = 12;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["call"])(getAccounts, {
                    web3: event.persistedWeb3
                  });

                case 12:
                  _context3.next = 14;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["call"])(_accountBalances_accountBalancesSaga__WEBPACK_IMPORTED_MODULE_3__["getAccountBalances"], {
                    web3: event.persistedWeb3
                  });

                case 14:
                  _context3.next = 16;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["put"])(event);

                case 16:
                  _context3.next = 5;
                  break;

                case 18:
                  _context3.prev = 18;
                  accountsChannel.close();
                  return _context3.finish(18);

                case 21:
                case "end":
                  return _context3.stop();
              }
            }
          }, _marked3, null, [[4,, 18, 21]]);
        }

        function accountsSaga() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function accountsSaga$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["takeLatest"])('ACCOUNTS_FETCHING', getAccounts);

                case 2:
                  _context4.next = 4;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["takeLatest"])('ACCOUNTS_POLLING', callCreateAccountsPollChannel);

                case 4:
                case "end":
                  return _context4.stop();
              }
            }
          }, _marked4);
        }
        /* harmony default export */


        __webpack_exports__["default"] = accountsSaga;
        /***/
      },

      /***/
      "./src/blocks/blocksReducer.js":
      /*!*************************************!*\
        !*** ./src/blocks/blocksReducer.js ***!
        \*************************************/

      /*! exports provided: default */

      /***/
      function srcBlocksBlocksReducerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);

        var initialState = {};

        var blocksReducer = function blocksReducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments.length > 1 ? arguments[1] : undefined;

          if (action.type === 'BLOCK_PROCESSING') {
            return action.block;
          }

          return state;
        };
        /* harmony default export */


        __webpack_exports__["default"] = blocksReducer;
        /***/
      },

      /***/
      "./src/blocks/blocksSaga.js":
      /*!**********************************!*\
        !*** ./src/blocks/blocksSaga.js ***!
        \**********************************/

      /*! exports provided: createBlockChannel, createBlockPollChannel, default */

      /***/
      function srcBlocksBlocksSagaJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "createBlockChannel", function () {
          return createBlockChannel;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "createBlockPollChannel", function () {
          return createBlockPollChannel;
        });
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/regenerator */
        "../../node_modules/@babel/runtime/regenerator/index.js");
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var redux_saga__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! redux-saga */
        "redux-saga");
        /* harmony import */


        var redux_saga__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(redux_saga__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! redux-saga/effects */
        "../../node_modules/redux-saga/es/effects.js");
        /* harmony import */


        var eth_block_tracker_es5__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! eth-block-tracker-es5 */
        "../../node_modules/eth-block-tracker-es5/dist/index.js");
        /* harmony import */


        var eth_block_tracker_es5__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(eth_block_tracker_es5__WEBPACK_IMPORTED_MODULE_3__);

        var _marked =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(callCreateBlockChannel),
            _marked2 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(callCreateBlockPollChannel),
            _marked3 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(processBlockHeader),
            _marked4 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(processBlock),
            _marked5 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(blocksSaga);
        /*
         * Listen for Blocks
         */


        function createBlockChannel(_ref) {
          var drizzle = _ref.drizzle,
              web3 = _ref.web3,
              syncAlways = _ref.syncAlways;
          return Object(redux_saga__WEBPACK_IMPORTED_MODULE_1__["eventChannel"])(function (emit) {
            var blockEvents = web3.eth.subscribe('newBlockHeaders', function (error, result) {
              if (error) {
                emit({
                  type: 'BLOCKS_FAILED',
                  error: error
                });
                console.error('Error in block header subscription:');
                console.error(error);
                emit(redux_saga__WEBPACK_IMPORTED_MODULE_1__["END"]);
              }
            }).on('data', function (blockHeader) {
              emit({
                type: 'BLOCK_RECEIVED',
                blockHeader: blockHeader,
                drizzle: drizzle,
                web3: web3,
                syncAlways: syncAlways
              });
            }).on('error', function (error) {
              emit({
                type: 'BLOCKS_FAILED',
                error: error
              });
              emit(redux_saga__WEBPACK_IMPORTED_MODULE_1__["END"]);
            });

            var unsubscribe = function unsubscribe() {
              blockEvents.off();
            };

            return unsubscribe;
          });
        }

        function callCreateBlockChannel(_ref2) {
          var drizzle, web3, syncAlways, blockChannel, event;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function callCreateBlockChannel$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  drizzle = _ref2.drizzle, web3 = _ref2.web3, syncAlways = _ref2.syncAlways;
                  _context.next = 3;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["call"])(createBlockChannel, {
                    drizzle: drizzle,
                    web3: web3,
                    syncAlways: syncAlways
                  });

                case 3:
                  blockChannel = _context.sent;
                  _context.prev = 4;

                case 5:
                  if (false) {}

                  _context.next = 8;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["take"])(blockChannel);

                case 8:
                  event = _context.sent;
                  _context.next = 11;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["put"])(event);

                case 11:
                  _context.next = 5;
                  break;

                case 13:
                  _context.prev = 13;
                  blockChannel.close();
                  return _context.finish(13);

                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _marked, null, [[4,, 13, 16]]);
        }
        /*
         * Poll for Blocks
         */


        function createBlockPollChannel(_ref3) {
          var drizzle = _ref3.drizzle,
              interval = _ref3.interval,
              web3 = _ref3.web3,
              syncAlways = _ref3.syncAlways;
          return Object(redux_saga__WEBPACK_IMPORTED_MODULE_1__["eventChannel"])(function (emit) {
            var blockTracker = new eth_block_tracker_es5__WEBPACK_IMPORTED_MODULE_3___default.a({
              provider: web3.currentProvider,
              pollingInterval: interval
            });
            blockTracker.on('block', function (block) {
              emit({
                type: 'BLOCK_FOUND',
                block: block,
                drizzle: drizzle,
                web3: web3,
                syncAlways: syncAlways
              });
            });
            blockTracker.start()["catch"](function (error) {
              emit({
                type: 'BLOCKS_FAILED',
                error: error
              });
              emit(redux_saga__WEBPACK_IMPORTED_MODULE_1__["END"]);
            });

            var unsubscribe = function unsubscribe() {
              blockTracker.stop()["catch"](function (_) {// BlockTracker assumes there is an outstanding event subscription.
                // However for our tests we start and stop a BlockTracker in succession
                // that triggers an error.
              });
            };

            return unsubscribe;
          });
        }

        function callCreateBlockPollChannel(_ref4) {
          var drizzle, interval, web3, syncAlways, blockChannel, event;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function callCreateBlockPollChannel$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  drizzle = _ref4.drizzle, interval = _ref4.interval, web3 = _ref4.web3, syncAlways = _ref4.syncAlways;
                  _context2.next = 3;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["call"])(createBlockPollChannel, {
                    drizzle: drizzle,
                    interval: interval,
                    web3: web3,
                    syncAlways: syncAlways
                  });

                case 3:
                  blockChannel = _context2.sent;
                  _context2.prev = 4;

                case 5:
                  if (false) {}

                  _context2.next = 8;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["take"])(blockChannel);

                case 8:
                  event = _context2.sent;
                  _context2.next = 11;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["put"])(event);

                case 11:
                  _context2.next = 5;
                  break;

                case 13:
                  _context2.prev = 13;
                  blockChannel.close();
                  return _context2.finish(13);

                case 16:
                case "end":
                  return _context2.stop();
              }
            }
          }, _marked2, null, [[4,, 13, 16]]);
        }
        /*
         * Process Blocks
         */


        function processBlockHeader(_ref5) {
          var blockHeader, drizzle, web3, syncAlways, blockNumber, block;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function processBlockHeader$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  blockHeader = _ref5.blockHeader, drizzle = _ref5.drizzle, web3 = _ref5.web3, syncAlways = _ref5.syncAlways;
                  blockNumber = blockHeader.number;
                  _context3.prev = 2;
                  _context3.next = 5;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["call"])(web3.eth.getBlock, blockNumber, true);

                case 5:
                  block = _context3.sent;
                  _context3.next = 8;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["call"])(processBlock, {
                    block: block,
                    drizzle: drizzle,
                    web3: web3,
                    syncAlways: syncAlways
                  });

                case 8:
                  _context3.next = 16;
                  break;

                case 10:
                  _context3.prev = 10;
                  _context3.t0 = _context3["catch"](2);
                  console.error('Error in block processing:');
                  console.error(_context3.t0);
                  _context3.next = 16;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["put"])({
                    type: 'BLOCK_FAILED',
                    error: _context3.t0
                  });

                case 16:
                case "end":
                  return _context3.stop();
              }
            }
          }, _marked3, null, [[2, 10]]);
        }

        function processBlock(_ref6) {
          var block, drizzle, web3, syncAlways, txs, i, from, fromContract, to, toContract;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function processBlock$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  block = _ref6.block, drizzle = _ref6.drizzle, web3 = _ref6.web3, syncAlways = _ref6.syncAlways;
                  _context4.prev = 1;
                  _context4.next = 4;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["put"])({
                    type: 'BLOCK_PROCESSING',
                    block: block
                  });

                case 4:
                  if (!syncAlways) {
                    _context4.next = 8;
                    break;
                  }

                  _context4.next = 7;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["all"])(Object.keys(drizzle.contracts).map(function (key) {
                    return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["put"])({
                      type: 'CONTRACT_SYNCING',
                      contract: drizzle.contracts[key]
                    });
                  }));

                case 7:
                  return _context4.abrupt("return");

                case 8:
                  txs = block.transactions;

                  if (!(txs.length > 0)) {
                    _context4.next = 25;
                    break;
                  }

                  i = 0;

                case 11:
                  if (!(i < txs.length)) {
                    _context4.next = 25;
                    break;
                  }

                  from = txs[i].from || '';
                  fromContract = drizzle.findContractByAddress(from.toLowerCase());

                  if (!fromContract) {
                    _context4.next = 17;
                    break;
                  }

                  _context4.next = 17;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["put"])({
                    type: 'CONTRACT_SYNCING',
                    contract: fromContract
                  });

                case 17:
                  to = txs[i].to || '';
                  toContract = drizzle.findContractByAddress(to.toLowerCase());

                  if (!toContract) {
                    _context4.next = 22;
                    break;
                  }

                  _context4.next = 22;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["put"])({
                    type: 'CONTRACT_SYNCING',
                    contract: toContract
                  });

                case 22:
                  i++;
                  _context4.next = 11;
                  break;

                case 25:
                  _context4.next = 33;
                  break;

                case 27:
                  _context4.prev = 27;
                  _context4.t0 = _context4["catch"](1);
                  console.error('Error in block processing:');
                  console.error(_context4.t0);
                  _context4.next = 33;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["put"])({
                    type: 'BLOCK_FAILED',
                    error: _context4.t0
                  });

                case 33:
                case "end":
                  return _context4.stop();
              }
            }
          }, _marked4, null, [[1, 27]]);
        }

        function blocksSaga() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function blocksSaga$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["takeLatest"])('BLOCKS_LISTENING', callCreateBlockChannel);

                case 2:
                  _context5.next = 4;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["takeEvery"])('BLOCK_RECEIVED', processBlockHeader);

                case 4:
                  _context5.next = 6;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["takeLatest"])('BLOCKS_POLLING', callCreateBlockPollChannel);

                case 6:
                  _context5.next = 8;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_2__["takeEvery"])('BLOCK_FOUND', processBlock);

                case 8:
                case "end":
                  return _context5.stop();
              }
            }
          }, _marked5);
        }
        /* harmony default export */


        __webpack_exports__["default"] = blocksSaga;
        /***/
      },

      /***/
      "./src/contractStateUtils.js":
      /*!***********************************!*\
        !*** ./src/contractStateUtils.js ***!
        \***********************************/

      /*! exports provided: getAbi, isConstant, generateContractInitialState, generateContractsInitialState */

      /***/
      function srcContractStateUtilsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getAbi", function () {
          return getAbi;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "isConstant", function () {
          return isConstant;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "generateContractInitialState", function () {
          return generateContractInitialState;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "generateContractsInitialState", function () {
          return generateContractsInitialState;
        });
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../../node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);

        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);

          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function (sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
          }

          return keys;
        }

        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};

            if (i % 2) {
              ownKeys(source, true).forEach(function (key) {
                _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(source).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }

          return target;
        }

        var getAbi = function getAbi(contractEntry) {
          return contractEntry.web3Contract ? contractEntry.web3Contract.options.jsonInterface : contractEntry.abi;
        };

        var isConstant = function isConstant(x) {
          return x.type === 'function' && x.constant === true;
        };

        var generateContractInitialState = function generateContractInitialState(contractConfig) {
          var constants = getAbi(contractConfig).filter(isConstant);
          var objectOfConstants = constants.reduce(function (acc, x) {
            return _objectSpread({}, acc, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, x.name, {}));
          }, {});
          return _objectSpread({
            initialized: false,
            synced: false
          }, objectOfConstants);
        };

        var generateContractsInitialState = function generateContractsInitialState(options) {
          return (options.contracts || []).reduce(function (state, contract) {
            state[contract.contractName] = generateContractInitialState(contract);
            return state;
          }, {});
        };
        /***/

      },

      /***/
      "./src/contracts/constants.js":
      /*!************************************!*\
        !*** ./src/contracts/constants.js ***!
        \************************************/

      /*! exports provided: EVENT_FIRED, EVENT_CHANGED, EVENT_ERROR */

      /***/
      function srcContractsConstantsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "EVENT_FIRED", function () {
          return EVENT_FIRED;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "EVENT_CHANGED", function () {
          return EVENT_CHANGED;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "EVENT_ERROR", function () {
          return EVENT_ERROR;
        });

        var EVENT_FIRED = 'EVENT_FIRED';
        var EVENT_CHANGED = 'EVENT_CHANGED';
        var EVENT_ERROR = 'EVENT_ERROR';
        /***/
      },

      /***/
      "./src/contracts/contractsReducer.js":
      /*!*******************************************!*\
        !*** ./src/contracts/contractsReducer.js ***!
        \*******************************************/

      /*! exports provided: default */

      /***/
      function srcContractsContractsReducerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../../node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../../node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/objectWithoutProperties */
        "../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
        /* harmony import */


        var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../../node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _contractStateUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ../contractStateUtils */
        "./src/contractStateUtils.js");
        /* harmony import */


        var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./constants */
        "./src/contracts/constants.js");

        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");

          return _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(key) === "symbol" ? key : String(key);
        }

        function _toPrimitive(input, hint) {
          if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];

          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return (hint === "string" ? String : Number)(input);
        }

        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);

          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function (sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
          }

          return keys;
        }

        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};

            if (i % 2) {
              ownKeys(source, true).forEach(function (key) {
                _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(source).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }

          return target;
        }

        var initialState = {};

        var contractsReducer = function contractsReducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments.length > 1 ? arguments[1] : undefined;
          /*
           * Contract Status
           */

          if (action.type === 'CONTRACT_INITIALIZING') {
            return _objectSpread({}, state, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, action.contractConfig.contractName, Object(_contractStateUtils__WEBPACK_IMPORTED_MODULE_4__["generateContractInitialState"])(action.contractConfig)));
          }

          if (action.type === 'CONTRACT_INITIALIZED') {
            return _objectSpread({}, state, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, action.name, _objectSpread({}, state[action.name], {
              initialized: true,
              synced: true,
              events: []
            })));
          }

          if (action.type === 'DELETE_CONTRACT') {
            var _action$contractName = action.contractName,
                omitted = state[_action$contractName],
                rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(state, [_action$contractName].map(_toPropertyKey));

            return rest;
          }

          if (action.type === 'CONTRACT_SYNCING') {
            var contractName = action.contract.contractName;
            return _objectSpread({}, state, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, contractName, _objectSpread({}, state[contractName], {
              synced: false
            })));
          }

          if (action.type === 'CONTRACT_SYNCED') {
            return _objectSpread({}, state, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, action.contractName, _objectSpread({}, state[action.contractName], {
              synced: true
            })));
          }

          if (action.type === 'CONTRACT_SYNC_IND') {
            return _objectSpread({}, state, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, action.contractName, _objectSpread({}, state[action.contractName], {
              synced: false
            })));
          }
          /*
           * Contract Functions
           */


          if (action.type === 'GOT_CONTRACT_VAR') {
            return _objectSpread({}, state, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, action.name, _objectSpread({}, state[action.name], _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, action.variable, _objectSpread({}, state[action.name][action.variable], _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, action.argsHash, _objectSpread({}, state[action.name][action.variable][action.argsHash], {
              args: action.args,
              fnIndex: action.fnIndex,
              value: action.value,
              error: null
            })))))));
          }

          if (action.type === 'ERROR_CONTRACT_VAR') {
            return _objectSpread({}, state, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, action.name, _objectSpread({}, state[action.name], _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, action.variable, _objectSpread({}, state[action.name][action.variable], _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, action.argsHash, _objectSpread({}, state[action.name][action.variable][action.argsHash], {
              args: action.args,
              fnIndex: action.fnIndex,
              value: null,
              error: action.error
            })))))));
          }
          /*
           * Contract Events
           */


          if (action.type === _constants__WEBPACK_IMPORTED_MODULE_5__["EVENT_FIRED"]) {
            return _objectSpread({}, state, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, action.name, _objectSpread({}, state[action.name], {
              events: [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(state[action.name].events), [action.event])
            })));
          }

          return state;
        };
        /* harmony default export */


        __webpack_exports__["default"] = contractsReducer;
        /***/
      },

      /***/
      "./src/contracts/contractsSaga.js":
      /*!****************************************!*\
        !*** ./src/contracts/contractsSaga.js ***!
        \****************************************/

      /*! exports provided: createContractEventChannel, default */

      /***/
      function srcContractsContractsSagaJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "createContractEventChannel", function () {
          return createContractEventChannel;
        });
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../../node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../../node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../../node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/regenerator */
        "../../node_modules/@babel/runtime/regenerator/index.js");
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var redux_saga__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! redux-saga */
        "redux-saga");
        /* harmony import */


        var redux_saga__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(redux_saga__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! redux-saga/effects */
        "../../node_modules/redux-saga/es/effects.js");
        /* harmony import */


        var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./constants */
        "./src/contracts/constants.js");

        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);

          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function (sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
          }

          return keys;
        }

        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};

            if (i % 2) {
              ownKeys(source, true).forEach(function (key) {
                _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(source).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }

          return target;
        }

        var _marked =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(callListenForContractEvent),
            _marked2 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(callSendContractTx),
            _marked3 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(callCallContractFn),
            _marked4 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(callSyncContract),
            _marked5 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(contractsSaga);
        /*
         * Events
         */


        function createContractEventChannel(_ref) {
          var contract = _ref.contract,
              eventName = _ref.eventName,
              eventOptions = _ref.eventOptions;
          var name = contract.contractName;
          return Object(redux_saga__WEBPACK_IMPORTED_MODULE_4__["eventChannel"])(function (emit) {
            var eventListener = contract.events[eventName](eventOptions).on('data', function (event) {
              emit({
                type: _constants__WEBPACK_IMPORTED_MODULE_6__["EVENT_FIRED"],
                name: name,
                event: event
              });
            }).on('changed', function (event) {
              emit({
                type: _constants__WEBPACK_IMPORTED_MODULE_6__["EVENT_CHANGED"],
                name: name,
                event: event
              });
            }).on('error', function (error) {
              emit({
                type: _constants__WEBPACK_IMPORTED_MODULE_6__["EVENT_ERROR"],
                name: name,
                error: error
              });
              emit(redux_saga__WEBPACK_IMPORTED_MODULE_4__["END"]);
            });

            var unsubscribe = function unsubscribe() {
              eventListener.removeListener(eventName);
            };

            return unsubscribe;
          });
        }

        function callListenForContractEvent(_ref2) {
          var contract, eventName, eventOptions, contractEventChannel, event;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function callListenForContractEvent$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  contract = _ref2.contract, eventName = _ref2.eventName, eventOptions = _ref2.eventOptions;
                  _context.next = 3;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["call"])(createContractEventChannel, {
                    contract: contract,
                    eventName: eventName,
                    eventOptions: eventOptions
                  });

                case 3:
                  contractEventChannel = _context.sent;

                case 4:
                  if (false) {}

                  _context.next = 7;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["take"])(contractEventChannel);

                case 7:
                  event = _context.sent;
                  _context.next = 10;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["put"])(event);

                case 10:
                  _context.next = 4;
                  break;

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _marked);
        }
        /*
         * Send and Cache
         */


        function createTxChannel(_ref3) {
          var txObject = _ref3.txObject,
              stackId = _ref3.stackId,
              _ref3$sendArgs = _ref3.sendArgs,
              sendArgs = _ref3$sendArgs === void 0 ? {} : _ref3$sendArgs,
              contractName = _ref3.contractName,
              stackTempKey = _ref3.stackTempKey;
          var persistTxHash;
          return Object(redux_saga__WEBPACK_IMPORTED_MODULE_4__["eventChannel"])(function (emit) {
            var txPromiEvent = txObject.send(sendArgs).on('transactionHash', function (txHash) {
              persistTxHash = txHash;
              emit({
                type: 'TX_BROADCASTED',
                txHash: txHash,
                stackId: stackId
              });
              emit({
                type: 'CONTRACT_SYNC_IND',
                contractName: contractName
              });
            }).on('confirmation', function (confirmationNumber, receipt) {
              emit({
                type: 'TX_CONFIRMAITON',
                confirmationReceipt: receipt,
                txHash: persistTxHash
              });
            }).on('receipt', function (receipt) {
              emit({
                type: 'TX_SUCCESSFUL',
                receipt: receipt,
                txHash: persistTxHash
              });
              emit(redux_saga__WEBPACK_IMPORTED_MODULE_4__["END"]);
            }).on('error', function (error, receipt) {
              console.error(error);
              console.error(receipt);
              emit({
                type: 'TX_ERROR',
                error: error,
                stackTempKey: stackTempKey
              });
              emit(redux_saga__WEBPACK_IMPORTED_MODULE_4__["END"]);
            });

            var unsubscribe = function unsubscribe() {
              txPromiEvent.off();
            };

            return unsubscribe;
          });
        }

        function callSendContractTx(_ref4) {
          var contract, fnName, fnIndex, args, stackId, stackTempKey, finalArg, sendArgs, finalArgTest, contractName, txObject, txChannel, event;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function callSendContractTx$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  contract = _ref4.contract, fnName = _ref4.fnName, fnIndex = _ref4.fnIndex, args = _ref4.args, stackId = _ref4.stackId, stackTempKey = _ref4.stackTempKey;

                  if (!args.length) {
                    _context2.next = 10;
                    break;
                  }

                  finalArg = args.length > 1 ? args[args.length - 1] : args[0];
                  sendArgs = {};
                  finalArgTest = false;

                  if (!(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(finalArg) === 'object')) {
                    _context2.next = 9;
                    break;
                  }

                  _context2.next = 8;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["call"])(isSendOrCallOptions, finalArg);

                case 8:
                  finalArgTest = _context2.sent;

                case 9:
                  if (finalArgTest) {
                    sendArgs = finalArg;
                    args.length > 1 ? delete args[args.length - 1] : delete args[0];
                    args.length = args.length - 1;
                  }

                case 10:
                  // Get name to mark as desynchronized on tx creation
                  contractName = contract.contractName; // Create the transaction object and execute the tx.

                  _context2.next = 13;
                  return redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["call"].apply(void 0, [contract.methods[fnName]].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(args)));

                case 13:
                  txObject = _context2.sent;
                  _context2.next = 16;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["call"])(createTxChannel, {
                    txObject: txObject,
                    stackId: stackId,
                    sendArgs: sendArgs,
                    contractName: contractName,
                    stackTempKey: stackTempKey
                  });

                case 16:
                  txChannel = _context2.sent;
                  _context2.prev = 17;

                case 18:
                  if (false) {}

                  _context2.next = 21;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["take"])(txChannel);

                case 21:
                  event = _context2.sent;
                  _context2.next = 24;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["put"])(event);

                case 24:
                  _context2.next = 18;
                  break;

                case 26:
                  _context2.prev = 26;
                  txChannel.close();
                  return _context2.finish(26);

                case 29:
                case "end":
                  return _context2.stop();
              }
            }
          }, _marked2, null, [[17,, 26, 29]]);
        }
        /*
         * Call and Cache
         */


        function callCallContractFn(_ref5) {
          var contract, fnName, fnIndex, args, argsHash, _ref5$sync, sync, finalArg, callArgs, finalArgTest, txObject, callResult, dispatchArgs, errorArgs;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function callCallContractFn$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  contract = _ref5.contract, fnName = _ref5.fnName, fnIndex = _ref5.fnIndex, args = _ref5.args, argsHash = _ref5.argsHash, _ref5$sync = _ref5.sync, sync = _ref5$sync === void 0 ? false : _ref5$sync;

                  if (!sync) {
                    _context3.next = 3;
                    break;
                  }

                  return _context3.abrupt("return");

                case 3:
                  if (!args.length) {
                    _context3.next = 12;
                    break;
                  }

                  finalArg = args.length > 1 ? args[args.length - 1] : args[0];
                  callArgs = {};
                  finalArgTest = false;

                  if (!(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(finalArg) === 'object')) {
                    _context3.next = 11;
                    break;
                  }

                  _context3.next = 10;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["call"])(isSendOrCallOptions, finalArg);

                case 10:
                  finalArgTest = _context3.sent;

                case 11:
                  if (finalArgTest) {
                    callArgs = finalArg;
                    args.length > 1 ? delete args[args.length - 1] : delete args[0];
                    args.length = args.length - 1;
                  }

                case 12:
                  _context3.next = 14;
                  return redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["call"].apply(void 0, [contract.methods[fnName]].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(args)));

                case 14:
                  txObject = _context3.sent;
                  _context3.prev = 15;
                  _context3.next = 18;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["call"])(txObject.call, callArgs);

                case 18:
                  callResult = _context3.sent;
                  dispatchArgs = {
                    name: contract.contractName,
                    variable: contract.abi[fnIndex].name,
                    argsHash: argsHash,
                    args: args,
                    value: callResult,
                    fnIndex: fnIndex
                  };
                  _context3.next = 22;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["put"])(_objectSpread({
                    type: 'GOT_CONTRACT_VAR'
                  }, dispatchArgs));

                case 22:
                  _context3.next = 30;
                  break;

                case 24:
                  _context3.prev = 24;
                  _context3.t0 = _context3["catch"](15);
                  console.error(_context3.t0);
                  errorArgs = {
                    name: contract.contractName,
                    variable: contract.abi[fnIndex].name,
                    argsHash: argsHash,
                    args: args,
                    error: _context3.t0,
                    fnIndex: fnIndex
                  };
                  _context3.next = 30;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["put"])(_objectSpread({
                    type: 'ERROR_CONTRACT_VAR'
                  }, errorArgs));

                case 30:
                case "end":
                  return _context3.stop();
              }
            }
          }, _marked3, null, [[15, 24]]);
        }
        /*
         * Sync Contract
         */


        function callSyncContract(action) {
          var contract, contractName, contractsState, contractFnsState, fnName, argsHash, fnIndex, args;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function callSyncContract$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  // Get contract state from store
                  contract = action.contract;
                  contractName = contract.contractName;
                  _context4.next = 4;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["select"])(getContractsState);

                case 4:
                  contractsState = _context4.sent;
                  contractFnsState = Object.assign({}, contractsState[contractName]); // Remove unnecessary keys

                  delete contractFnsState.initialized;
                  delete contractFnsState.synced;
                  delete contractFnsState.events; // Iterate over functions and hashes

                  _context4.t0 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.keys(contractFnsState);

                case 10:
                  if ((_context4.t1 = _context4.t0()).done) {
                    _context4.next = 25;
                    break;
                  }

                  fnName = _context4.t1.value;
                  _context4.t2 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.keys(contractFnsState[fnName]);

                case 13:
                  if ((_context4.t3 = _context4.t2()).done) {
                    _context4.next = 23;
                    break;
                  }

                  argsHash = _context4.t3.value;
                  fnIndex = contractFnsState[fnName][argsHash].fnIndex;
                  args = contractFnsState[fnName][argsHash].args; // Pull args and call fn for each given function
                  // keeping for pre-v1.1.5 compatibility with CALL_CONTRACT_FN event.

                  _context4.next = 19;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["put"])({
                    type: 'CALL_CONTRACT_FN',
                    contract: contract,
                    fnName: fnName,
                    fnIndex: fnIndex,
                    args: args,
                    argsHash: argsHash,
                    sync: true
                  });

                case 19:
                  _context4.next = 21;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["call"])(callCallContractFn, {
                    contract: contract,
                    fnName: fnName,
                    fnIndex: fnIndex,
                    args: args,
                    argsHash: argsHash
                  });

                case 21:
                  _context4.next = 13;
                  break;

                case 23:
                  _context4.next = 10;
                  break;

                case 25:
                  _context4.next = 27;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["put"])({
                    type: 'CONTRACT_SYNCED',
                    contractName: contractName
                  });

                case 27:
                case "end":
                  return _context4.stop();
              }
            }
          }, _marked4);
        }

        var getContractsState = function getContractsState(state) {
          return state.contracts;
        };

        function isSendOrCallOptions(options) {
          if ('from' in options) return true;
          if ('gas' in options) return true;
          if ('gasPrice' in options) return true;
          if ('value' in options) return true;
          return false;
        }

        function contractsSaga() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function contractsSaga$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["takeEvery"])('SEND_CONTRACT_TX', callSendContractTx);

                case 2:
                  _context5.next = 4;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["takeEvery"])('CALL_CONTRACT_FN', callCallContractFn);

                case 4:
                  _context5.next = 6;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["takeEvery"])('CONTRACT_SYNCING', callSyncContract);

                case 6:
                  _context5.next = 8;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_5__["takeEvery"])('LISTEN_FOR_EVENT', callListenForContractEvent);

                case 8:
                case "end":
                  return _context5.stop();
              }
            }
          }, _marked5);
        }
        /* harmony default export */


        __webpack_exports__["default"] = contractsSaga;
        /***/
      },

      /***/
      "./src/defaultOptions.js":
      /*!*******************************!*\
        !*** ./src/defaultOptions.js ***!
        \*******************************/

      /*! exports provided: default */

      /***/
      function srcDefaultOptionsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);

        var defaultOptions = {
          web3: {
            // `block` no longer needed;
            // keeping for pre-v1.1.1 compatibility with drizzle-react.
            block: false,
            fallback: {
              type: 'ws',
              url: 'ws://127.0.0.1:8545'
            }
          },
          contracts: [],
          events: {},
          polls: {
            blocks: 3000
          },
          syncAlways: false,
          networkWhitelist: []
        };
        /* harmony default export */

        __webpack_exports__["default"] = defaultOptions;
        /***/
      },

      /***/
      "./src/drizzle-middleware.js":
      /*!***********************************!*\
        !*** ./src/drizzle-middleware.js ***!
        \***********************************/

      /*! exports provided: drizzleMiddleware, default */

      /***/
      function srcDrizzleMiddlewareJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "drizzleMiddleware", function () {
          return drizzleMiddleware;
        });

        var drizzleMiddleware = function drizzleMiddleware(drizzleInstance) {
          return function (store) {
            return function (next) {
              return function (action) {
                var type = action.type;

                if (type === 'DRIZZLE_INITIALIZING') {
                  drizzleInstance = action.drizzle;
                }

                if (type === 'ACCOUNTS_FETCHED' && drizzleInstance && drizzleInstance.contractList.length) {
                  var newAccount = action.accounts[0];
                  var oldAccount = drizzleInstance.contractList[0].options.from; // Update `from` fields with newAccount

                  if (oldAccount !== newAccount) {
                    drizzleInstance.contractList.forEach(function (contract) {
                      contract.options.from = newAccount;
                    });
                  }
                }

                if (type === 'ADD_CONTRACT' && drizzleInstance) {
                  try {
                    var contractConfig = action.contractConfig,
                        events = action.events;
                    drizzleInstance.addContract(contractConfig, events);
                  } catch (error) {
                    console.error('Attempt to add a duplicate contract.\n', error); // Notify user via

                    var notificationAction = {
                      type: 'ERROR_ADD_CONTRACT',
                      error: error,
                      attemptedAction: action
                    };
                    store.dispatch(notificationAction); // Don't propogate current action

                    return;
                  }
                }

                return next(action);
              };
            };
          };
        };

        var initializedMiddleware = drizzleMiddleware(undefined);
        /* harmony default export */

        __webpack_exports__["default"] = initializedMiddleware;
        /***/
      },

      /***/
      "./src/drizzleStatus/drizzleStatusReducer.js":
      /*!***************************************************!*\
        !*** ./src/drizzleStatus/drizzleStatusReducer.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function srcDrizzleStatusDrizzleStatusReducerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../../node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);

        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);

          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function (sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
          }

          return keys;
        }

        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};

            if (i % 2) {
              ownKeys(source, true).forEach(function (key) {
                _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(source).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }

          return target;
        }

        var initialState = {
          initialized: false
        };

        var drizzleStatusReducer = function drizzleStatusReducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments.length > 1 ? arguments[1] : undefined;
          /*
           * Drizzle Status
           */

          if (action.type === 'DRIZZLE_INITIALIZED') {
            return _objectSpread({}, state, {
              initialized: true
            });
          }

          return state;
        };
        /* harmony default export */


        __webpack_exports__["default"] = drizzleStatusReducer;
        /***/
      },

      /***/
      "./src/drizzleStatus/drizzleStatusSaga.js":
      /*!************************************************!*\
        !*** ./src/drizzleStatus/drizzleStatusSaga.js ***!
        \************************************************/

      /*! exports provided: initializeDrizzle, default */

      /***/
      function srcDrizzleStatusDrizzleStatusSagaJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "initializeDrizzle", function () {
          return initializeDrizzle;
        });
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/regenerator */
        "../../node_modules/@babel/runtime/regenerator/index.js");
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! redux-saga/effects */
        "../../node_modules/redux-saga/es/effects.js");
        /* harmony import */


        var _web3_web3Saga__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ../web3/web3Saga */
        "./src/web3/web3Saga.js");
        /* harmony import */


        var _accounts_accountsSaga__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../accounts/accountsSaga */
        "./src/accounts/accountsSaga.js");
        /* harmony import */


        var _accountBalances_accountBalancesSaga__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ../accountBalances/accountBalancesSaga */
        "./src/accountBalances/accountBalancesSaga.js");
        /* harmony import */


        var _web3_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../web3/constants */
        "./src/web3/constants.js");

        var _marked =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(initializeDrizzle),
            _marked2 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(drizzleStatusSaga); // Initialization Functions


        function initializeDrizzle(action) {
          var options, web3Options, drizzle, web3, networkId, networkWhitelist, i, contractConfig, events, contractName, syncAlways, interval;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function initializeDrizzle$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  options = action.options;
                  web3Options = options.web3;
                  drizzle = action.drizzle; // Initialize web3 and get the current network ID.

                  _context.next = 6;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["call"])(_web3_web3Saga__WEBPACK_IMPORTED_MODULE_2__["initializeWeb3"], {
                    options: web3Options
                  });

                case 6:
                  web3 = _context.sent;
                  drizzle.web3 = web3; // Client may opt out of connecting their account to the dapp Guard against
                  // further web3 interaction, and note web3 will be undefined
                  //

                  if (!web3) {
                    _context.next = 45;
                    break;
                  }

                  _context.next = 11;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["call"])(_web3_web3Saga__WEBPACK_IMPORTED_MODULE_2__["getNetworkId"], {
                    web3: web3
                  });

                case 11:
                  networkId = _context.sent; // Check whether network is allowed

                  networkWhitelist = options.networkWhitelist;

                  if (!(networkWhitelist.length && networkId !== _web3_constants__WEBPACK_IMPORTED_MODULE_5__["NETWORK_IDS"].ganache && !networkWhitelist.includes(networkId))) {
                    _context.next = 18;
                    break;
                  }

                  _context.next = 16;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: _web3_constants__WEBPACK_IMPORTED_MODULE_5__["NETWORK_MISMATCH"],
                    networkId: networkId
                  });

                case 16:
                  _context.next = 45;
                  break;

                case 18:
                  _context.next = 20;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["call"])(_accounts_accountsSaga__WEBPACK_IMPORTED_MODULE_3__["getAccounts"], {
                    web3: web3
                  });

                case 20:
                  _context.next = 22;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["call"])(_accountBalances_accountBalancesSaga__WEBPACK_IMPORTED_MODULE_4__["getAccountBalances"], {
                    web3: web3
                  });

                case 22:
                  i = 0;

                case 23:
                  if (!(i < options.contracts.length)) {
                    _context.next = 33;
                    break;
                  }

                  contractConfig = options.contracts[i];
                  events = [];
                  contractName = contractConfig.contractName;

                  if (contractName in options.events) {
                    events = options.events[contractName];
                  }

                  _context.next = 30;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["call"])([drizzle, drizzle.addContract], contractConfig, events);

                case 30:
                  i++;
                  _context.next = 23;
                  break;

                case 33:
                  syncAlways = options.syncAlways; // Protect server-side environments by ensuring ethereum access is
                  // guarded by isMetaMask which should only be in browser environment.
                  //

                  if (!(web3.currentProvider.isMetaMask && !window.ethereum)) {
                    _context.next = 40;
                    break;
                  } // Using old MetaMask, attempt block polling.


                  interval = options.polls.blocks;
                  _context.next = 38;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: 'BLOCKS_POLLING',
                    drizzle: drizzle,
                    interval: interval,
                    web3: web3,
                    syncAlways: syncAlways
                  });

                case 38:
                  _context.next = 42;
                  break;

                case 40:
                  _context.next = 42;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: 'BLOCKS_LISTENING',
                    drizzle: drizzle,
                    web3: web3,
                    syncAlways: syncAlways
                  });

                case 42:
                  if (!('accounts' in options.polls)) {
                    _context.next = 45;
                    break;
                  }

                  _context.next = 45;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: 'ACCOUNTS_POLLING',
                    interval: options.polls.accounts,
                    web3: web3
                  });

                case 45:
                  _context.next = 54;
                  break;

                case 47:
                  _context.prev = 47;
                  _context.t0 = _context["catch"](0);
                  _context.next = 51;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: 'DRIZZLE_FAILED',
                    error: _context.t0
                  });

                case 51:
                  console.error('Error initializing Drizzle:');
                  console.error(_context.t0);
                  return _context.abrupt("return");

                case 54:
                  _context.next = 56;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: 'DRIZZLE_INITIALIZED'
                  });

                case 56:
                case "end":
                  return _context.stop();
              }
            }
          }, _marked, null, [[0, 47]]);
        }

        function drizzleStatusSaga() {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function drizzleStatusSaga$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["takeLatest"])('DRIZZLE_INITIALIZING', initializeDrizzle);

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _marked2);
        }
        /* harmony default export */


        __webpack_exports__["default"] = drizzleStatusSaga;
        /***/
      },

      /***/
      "./src/generateStore.js":
      /*!******************************!*\
        !*** ./src/generateStore.js ***!
        \******************************/

      /*! exports provided: generateStore */

      /***/
      function srcGenerateStoreJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* WEBPACK VAR INJECTION */


        (function (global) {
          /* harmony export (binding) */
          __webpack_require__.d(__webpack_exports__, "generateStore", function () {
            return generateStore;
          });
          /* harmony import */


          var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
          /*! @babel/runtime/helpers/defineProperty */
          "../../node_modules/@babel/runtime/helpers/defineProperty.js");
          /* harmony import */


          var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/
          __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
          /* harmony import */


          var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
          /*! @babel/runtime/helpers/toConsumableArray */
          "../../node_modules/@babel/runtime/helpers/toConsumableArray.js");
          /* harmony import */


          var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/
          __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
          /* harmony import */


          var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
          /*! @babel/runtime/helpers/objectWithoutProperties */
          "../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
          /* harmony import */


          var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default =
          /*#__PURE__*/
          __webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__);
          /* harmony import */


          var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
          /*! @babel/runtime/regenerator */
          "../../node_modules/@babel/runtime/regenerator/index.js");
          /* harmony import */


          var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default =
          /*#__PURE__*/
          __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
          /* harmony import */


          var redux_saga_effects__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
          /*! redux-saga/effects */
          "../../node_modules/redux-saga/es/effects.js");
          /* harmony import */


          var redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
          /*! redux */
          "redux");
          /* harmony import */


          var redux__WEBPACK_IMPORTED_MODULE_5___default =
          /*#__PURE__*/
          __webpack_require__.n(redux__WEBPACK_IMPORTED_MODULE_5__);
          /* harmony import */


          var redux_saga__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
          /*! redux-saga */
          "redux-saga");
          /* harmony import */


          var redux_saga__WEBPACK_IMPORTED_MODULE_6___default =
          /*#__PURE__*/
          __webpack_require__.n(redux_saga__WEBPACK_IMPORTED_MODULE_6__);
          /* harmony import */


          var _rootSaga__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
          /*! ./rootSaga */
          "./src/rootSaga.js");
          /* harmony import */


          var _reducer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
          /*! ./reducer */
          "./src/reducer.js");
          /* harmony import */


          var _contractStateUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
          /*! ./contractStateUtils */
          "./src/contractStateUtils.js");
          /* harmony import */


          var _drizzle_middleware__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
          /*! ./drizzle-middleware */
          "./src/drizzle-middleware.js");

          function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);

            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(object);
              if (enumerableOnly) symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              });
              keys.push.apply(keys, symbols);
            }

            return keys;
          }

          function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i] != null ? arguments[i] : {};

              if (i % 2) {
                ownKeys(source, true).forEach(function (key) {
                  _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]);
                });
              } else if (Object.getOwnPropertyDescriptors) {
                Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
              } else {
                ownKeys(source).forEach(function (key) {
                  Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                });
              }
            }

            return target;
          }

          var composeSagas = function composeSagas(sagas) {
            return (
              /*#__PURE__*/
              _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee() {
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_4__["all"])(sagas.map(redux_saga_effects__WEBPACK_IMPORTED_MODULE_4__["fork"]));

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })
            );
          };
          /**
           * Generate the redux store by combining drizzleOptions, application reducers,
           * middleware and initial app state.
           *
           * @param {object} config - The configuration object
           * @param {object} config.drizzleOptions - drizzle configuration object
           * @param {object} config.reducers={} - application level reducers to include in drizzle's redux store
           * @param {object[]} config.appSagas=[] - application sagas to be managed by drizzle's saga middleware
           * @param {object[]} config.appMiddlewares=[] - application middlewares to be managed by drizzle's saga middleware
           * @param {boolean} config.disableReduxDevTools=false - disable redux devtools hook
           * @returns {object} Redux store
           *
           */


          function generateStore(_ref) {
            var drizzleOptions = _ref.drizzleOptions,
                _ref$appReducers = _ref.appReducers,
                appReducers = _ref$appReducers === void 0 ? {} : _ref$appReducers,
                _ref$appSagas = _ref.appSagas,
                appSagas = _ref$appSagas === void 0 ? [] : _ref$appSagas,
                _ref$appMiddlewares = _ref.appMiddlewares,
                appMiddlewares = _ref$appMiddlewares === void 0 ? [] : _ref$appMiddlewares,
                _ref$disableReduxDevT = _ref.disableReduxDevTools,
                disableReduxDevTools = _ref$disableReduxDevT === void 0 ? false : _ref$disableReduxDevT,
                options = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2___default()(_ref, ["drizzleOptions", "appReducers", "appSagas", "appMiddlewares", "disableReduxDevTools"]); // Note: Preserve backwards compatibility for passing options to
            // `generateStore`.  in drizzle v1.3.3 and prior of generate had a signature
            // of `generateStore(options)`.
            //
            // The updated signature looks for `drizzleOptions`, `appReducers`,
            // `appSagas`, `initialAppStore` and `disableReduxDevTools` while
            // {...options} captures the previous release's signature.
            //
            // Resolve drizzleOptions. If called by dapps written to previous API, then
            // drizzleOptions will be `undefined` and will resolve to rest constructed
            // options.
            //


            drizzleOptions = drizzleOptions || options;
            var composeEnhancers = !disableReduxDevTools ? global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux__WEBPACK_IMPORTED_MODULE_5__["compose"] : redux__WEBPACK_IMPORTED_MODULE_5__["compose"];
            var initialContractsState = {
              contracts: Object(_contractStateUtils__WEBPACK_IMPORTED_MODULE_9__["generateContractsInitialState"])(drizzleOptions)
            };
            var sagaMiddleware = redux_saga__WEBPACK_IMPORTED_MODULE_6___default()();
            var allMiddlewares = [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(appMiddlewares), [sagaMiddleware, _drizzle_middleware__WEBPACK_IMPORTED_MODULE_10__["default"]]);

            var allReducers = _objectSpread({}, _reducer__WEBPACK_IMPORTED_MODULE_8__["default"], {}, appReducers);

            var store = Object(redux__WEBPACK_IMPORTED_MODULE_5__["createStore"])(Object(redux__WEBPACK_IMPORTED_MODULE_5__["combineReducers"])(allReducers), initialContractsState, composeEnhancers(redux__WEBPACK_IMPORTED_MODULE_5__["applyMiddleware"].apply(void 0, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(allMiddlewares))));
            sagaMiddleware.run(composeSagas([].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(_rootSaga__WEBPACK_IMPORTED_MODULE_7__["default"]), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(appSagas))));
            return store;
          }
          /* WEBPACK VAR INJECTION */

        }).call(this, __webpack_require__(
        /*! ./../node_modules/webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"));
        /***/
      },

      /***/
      "./src/index.js":
      /*!**********************!*\
        !*** ./src/index.js ***!
        \**********************/

      /*! exports provided: Drizzle, generateContractsInitialState, generateStore, drizzleReducers, drizzleSagas, EventActions */

      /***/
      function srcIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "drizzleReducers", function () {
          return drizzleReducers;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "drizzleSagas", function () {
          return drizzleSagas;
        });
        /* harmony import */


        var _Drizzle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./Drizzle.js */
        "./src/Drizzle.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Drizzle", function () {
          return _Drizzle_js__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /* harmony import */


        var _generateStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./generateStore */
        "./src/generateStore.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "generateStore", function () {
          return _generateStore__WEBPACK_IMPORTED_MODULE_1__["generateStore"];
        });
        /* harmony import */


        var _contractStateUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./contractStateUtils */
        "./src/contractStateUtils.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "generateContractsInitialState", function () {
          return _contractStateUtils__WEBPACK_IMPORTED_MODULE_2__["generateContractsInitialState"];
        });
        /* harmony import */


        var _contracts_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./contracts/constants */
        "./src/contracts/constants.js");
        /* harmony reexport (module object) */


        __webpack_require__.d(__webpack_exports__, "EventActions", function () {
          return _contracts_constants__WEBPACK_IMPORTED_MODULE_3__;
        });
        /* harmony import */


        var _accounts_accountsReducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./accounts/accountsReducer */
        "./src/accounts/accountsReducer.js");
        /* harmony import */


        var _accountBalances_accountBalancesReducer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./accountBalances/accountBalancesReducer */
        "./src/accountBalances/accountBalancesReducer.js");
        /* harmony import */


        var _blocks_blocksReducer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./blocks/blocksReducer */
        "./src/blocks/blocksReducer.js");
        /* harmony import */


        var _contracts_contractsReducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./contracts/contractsReducer */
        "./src/contracts/contractsReducer.js");
        /* harmony import */


        var _drizzleStatus_drizzleStatusReducer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./drizzleStatus/drizzleStatusReducer */
        "./src/drizzleStatus/drizzleStatusReducer.js");
        /* harmony import */


        var _transactions_transactionsReducer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./transactions/transactionsReducer */
        "./src/transactions/transactionsReducer.js");
        /* harmony import */


        var _transactions_transactionStackReducer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./transactions/transactionStackReducer */
        "./src/transactions/transactionStackReducer.js");
        /* harmony import */


        var _web3_web3Reducer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./web3/web3Reducer */
        "./src/web3/web3Reducer.js");
        /* harmony import */


        var _accounts_accountsSaga__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ./accounts/accountsSaga */
        "./src/accounts/accountsSaga.js");
        /* harmony import */


        var _accountBalances_accountBalancesSaga__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ./accountBalances/accountBalancesSaga */
        "./src/accountBalances/accountBalancesSaga.js");
        /* harmony import */


        var _blocks_blocksSaga__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ./blocks/blocksSaga */
        "./src/blocks/blocksSaga.js");
        /* harmony import */


        var _contracts_contractsSaga__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ./contracts/contractsSaga */
        "./src/contracts/contractsSaga.js");
        /* harmony import */


        var _drizzleStatus_drizzleStatusSaga__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ./drizzleStatus/drizzleStatusSaga */
        "./src/drizzleStatus/drizzleStatusSaga.js"); // Events
        // Reducers


        var drizzleReducers = {
          accounts: _accounts_accountsReducer__WEBPACK_IMPORTED_MODULE_4__["default"],
          accountBalances: _accountBalances_accountBalancesReducer__WEBPACK_IMPORTED_MODULE_5__["default"],
          contracts: _contracts_contractsReducer__WEBPACK_IMPORTED_MODULE_7__["default"],
          currentBlock: _blocks_blocksReducer__WEBPACK_IMPORTED_MODULE_6__["default"],
          drizzleStatus: _drizzleStatus_drizzleStatusReducer__WEBPACK_IMPORTED_MODULE_8__["default"],
          transactions: _transactions_transactionsReducer__WEBPACK_IMPORTED_MODULE_9__["default"],
          transactionStack: _transactions_transactionStackReducer__WEBPACK_IMPORTED_MODULE_10__["default"],
          web3: _web3_web3Reducer__WEBPACK_IMPORTED_MODULE_11__["default"] // Sagas

        };
        var drizzleSagas = [_accounts_accountsSaga__WEBPACK_IMPORTED_MODULE_12__["default"], _accountBalances_accountBalancesSaga__WEBPACK_IMPORTED_MODULE_13__["default"], _blocks_blocksSaga__WEBPACK_IMPORTED_MODULE_14__["default"], _contracts_contractsSaga__WEBPACK_IMPORTED_MODULE_15__["default"], _drizzleStatus_drizzleStatusSaga__WEBPACK_IMPORTED_MODULE_16__["default"]];
        /***/
      },

      /***/
      "./src/mergeOptions.js":
      /*!*****************************!*\
        !*** ./src/mergeOptions.js ***!
        \*****************************/

      /*! exports provided: default */

      /***/
      function srcMergeOptionsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var deepmerge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! deepmerge */
        "deepmerge");
        /* harmony import */


        var deepmerge__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(deepmerge__WEBPACK_IMPORTED_MODULE_0__);

        var isPlainObject = __webpack_require__(
        /*! is-plain-object */
        "is-plain-object");
        /* harmony default export */


        __webpack_exports__["default"] = function (defaultOptions, newOptions) {
          return deepmerge__WEBPACK_IMPORTED_MODULE_0___default()(defaultOptions, newOptions, {
            isMergeableObject: isPlainObject
          });
        };
        /***/

      },

      /***/
      "./src/reducer.js":
      /*!************************!*\
        !*** ./src/reducer.js ***!
        \************************/

      /*! exports provided: default */

      /***/
      function srcReducerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _accounts_accountsReducer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./accounts/accountsReducer */
        "./src/accounts/accountsReducer.js");
        /* harmony import */


        var _accountBalances_accountBalancesReducer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./accountBalances/accountBalancesReducer */
        "./src/accountBalances/accountBalancesReducer.js");
        /* harmony import */


        var _blocks_blocksReducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./blocks/blocksReducer */
        "./src/blocks/blocksReducer.js");
        /* harmony import */


        var _contracts_contractsReducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./contracts/contractsReducer */
        "./src/contracts/contractsReducer.js");
        /* harmony import */


        var _drizzleStatus_drizzleStatusReducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./drizzleStatus/drizzleStatusReducer */
        "./src/drizzleStatus/drizzleStatusReducer.js");
        /* harmony import */


        var _transactions_transactionsReducer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./transactions/transactionsReducer */
        "./src/transactions/transactionsReducer.js");
        /* harmony import */


        var _transactions_transactionStackReducer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./transactions/transactionStackReducer */
        "./src/transactions/transactionStackReducer.js");
        /* harmony import */


        var _web3_web3Reducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./web3/web3Reducer */
        "./src/web3/web3Reducer.js"); // All our reducers

        /* harmony default export */


        __webpack_exports__["default"] = {
          accounts: _accounts_accountsReducer__WEBPACK_IMPORTED_MODULE_0__["default"],
          accountBalances: _accountBalances_accountBalancesReducer__WEBPACK_IMPORTED_MODULE_1__["default"],
          contracts: _contracts_contractsReducer__WEBPACK_IMPORTED_MODULE_3__["default"],
          currentBlock: _blocks_blocksReducer__WEBPACK_IMPORTED_MODULE_2__["default"],
          drizzleStatus: _drizzleStatus_drizzleStatusReducer__WEBPACK_IMPORTED_MODULE_4__["default"],
          transactions: _transactions_transactionsReducer__WEBPACK_IMPORTED_MODULE_5__["default"],
          transactionStack: _transactions_transactionStackReducer__WEBPACK_IMPORTED_MODULE_6__["default"],
          web3: _web3_web3Reducer__WEBPACK_IMPORTED_MODULE_7__["default"]
        };
        /***/
      },

      /***/
      "./src/rootSaga.js":
      /*!*************************!*\
        !*** ./src/rootSaga.js ***!
        \*************************/

      /*! exports provided: default */

      /***/
      function srcRootSagaJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _accounts_accountsSaga__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./accounts/accountsSaga */
        "./src/accounts/accountsSaga.js");
        /* harmony import */


        var _accountBalances_accountBalancesSaga__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./accountBalances/accountBalancesSaga */
        "./src/accountBalances/accountBalancesSaga.js");
        /* harmony import */


        var _blocks_blocksSaga__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./blocks/blocksSaga */
        "./src/blocks/blocksSaga.js");
        /* harmony import */


        var _contracts_contractsSaga__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./contracts/contractsSaga */
        "./src/contracts/contractsSaga.js");
        /* harmony import */


        var _drizzleStatus_drizzleStatusSaga__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./drizzleStatus/drizzleStatusSaga */
        "./src/drizzleStatus/drizzleStatusSaga.js");
        /* harmony default export */


        __webpack_exports__["default"] = [_accounts_accountsSaga__WEBPACK_IMPORTED_MODULE_0__["default"], _accountBalances_accountBalancesSaga__WEBPACK_IMPORTED_MODULE_1__["default"], _blocks_blocksSaga__WEBPACK_IMPORTED_MODULE_2__["default"], _contracts_contractsSaga__WEBPACK_IMPORTED_MODULE_3__["default"], _drizzleStatus_drizzleStatusSaga__WEBPACK_IMPORTED_MODULE_4__["default"]];
        /***/
      },

      /***/
      "./src/transactions/transactionStackReducer.js":
      /*!*****************************************************!*\
        !*** ./src/transactions/transactionStackReducer.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function srcTransactionsTransactionStackReducerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../../node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);

        var initialState = [];

        var transactionStackReducer = function transactionStackReducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments.length > 1 ? arguments[1] : undefined;

          if (action.type === 'PUSH_TO_TXSTACK') {
            return [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(state), [action.stackTempKey]);
          }

          if (action.type === 'POP_FROM_TXSTACK') {
            state.pop();
            return _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(state);
          }

          if (action.type === 'TX_BROADCASTED') {
            state[action.stackId] = action.txHash;
            return _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(state);
          }

          return state;
        };
        /* harmony default export */


        __webpack_exports__["default"] = transactionStackReducer;
        /***/
      },

      /***/
      "./src/transactions/transactionsReducer.js":
      /*!*************************************************!*\
        !*** ./src/transactions/transactionsReducer.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function srcTransactionsTransactionsReducerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../../node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../../node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);

        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);

          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function (sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
          }

          return keys;
        }

        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};

            if (i % 2) {
              ownKeys(source, true).forEach(function (key) {
                _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(source).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }

          return target;
        }

        var initialState = {};

        var transactionsReducer = function transactionsReducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments.length > 1 ? arguments[1] : undefined;

          if (action.type === 'TX_BROADCASTED') {
            return _objectSpread({}, state, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, action.txHash, {
              status: 'pending',
              confirmations: []
            }));
          }

          if (action.type === 'TX_CONFIRMAITON') {
            return _objectSpread({}, state, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, action.txHash, _objectSpread({}, state[action.txHash], {
              confirmations: [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(state[action.txHash].confirmations), [action.confirmationReceipt])
            })));
          }

          if (action.type === 'TX_SUCCESSFUL') {
            return _objectSpread({}, state, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, action.txHash, _objectSpread({}, state[action.txHash], {
              status: 'success',
              receipt: action.receipt
            })));
          }

          if (action.type === 'TX_ERROR') {
            return _objectSpread({}, state, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, action.stackTempKey, _objectSpread({}, state[action.stackTempKey], {
              status: 'error',
              error: {
                message: action.error && action.error.message
              }
            })));
          }

          return state;
        };
        /* harmony default export */


        __webpack_exports__["default"] = transactionsReducer;
        /***/
      },

      /***/
      "./src/web3/constants.js":
      /*!*******************************!*\
        !*** ./src/web3/constants.js ***!
        \*******************************/

      /*! exports provided: WEB3_INITIALIZING, WEB3_INITIALIZED, WEB3_FAILED, WEB3_USER_DENIED, NETWORK_ID_FETCHED, NETWORK_ID_FAILED, NETWORK_MISMATCH, NETWORK_IDS */

      /***/
      function srcWeb3ConstantsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "WEB3_INITIALIZING", function () {
          return WEB3_INITIALIZING;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "WEB3_INITIALIZED", function () {
          return WEB3_INITIALIZED;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "WEB3_FAILED", function () {
          return WEB3_FAILED;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "WEB3_USER_DENIED", function () {
          return WEB3_USER_DENIED;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "NETWORK_ID_FETCHED", function () {
          return NETWORK_ID_FETCHED;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "NETWORK_ID_FAILED", function () {
          return NETWORK_ID_FAILED;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "NETWORK_MISMATCH", function () {
          return NETWORK_MISMATCH;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "NETWORK_IDS", function () {
          return NETWORK_IDS;
        });

        var WEB3_INITIALIZING = 'WEB3_INITIALIZING';
        var WEB3_INITIALIZED = 'WEB3_INITIALIZED';
        var WEB3_FAILED = 'WEB3_FAILED';
        var WEB3_USER_DENIED = 'WEB3_USER_DENIED';
        var NETWORK_ID_FETCHED = 'NETWORK_ID_FETCHED';
        var NETWORK_ID_FAILED = 'NETWORK_ID_FAILED';
        var NETWORK_MISMATCH = 'NETWORK_MISMATCH';
        var NETWORK_IDS = {
          mainnet: 1,
          ropsten: 3,
          rinkeby: 4,
          goerli: 5,
          kovan: 42,
          ganache: 5777
        };
        /***/
      },

      /***/
      "./src/web3/web3Reducer.js":
      /*!*********************************!*\
        !*** ./src/web3/web3Reducer.js ***!
        \*********************************/

      /*! exports provided: default */

      /***/
      function srcWeb3Web3ReducerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../../node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./constants */
        "./src/web3/constants.js");

        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);

          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function (sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
          }

          return keys;
        }

        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};

            if (i % 2) {
              ownKeys(source, true).forEach(function (key) {
                _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(source).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }

          return target;
        }

        var initialState = {
          status: ''
        };

        var web3Reducer = function web3Reducer() {
          var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
          var action = arguments.length > 1 ? arguments[1] : undefined;

          if (action.type === _constants__WEBPACK_IMPORTED_MODULE_1__["WEB3_INITIALIZING"]) {
            return _objectSpread({}, state, {
              status: 'initializing'
            });
          }

          if (action.type === _constants__WEBPACK_IMPORTED_MODULE_1__["WEB3_INITIALIZED"]) {
            return _objectSpread({}, state, {
              status: 'initialized'
            });
          }

          if (action.type === _constants__WEBPACK_IMPORTED_MODULE_1__["WEB3_FAILED"]) {
            return _objectSpread({}, state, {
              status: 'failed'
            });
          }

          if (action.type === _constants__WEBPACK_IMPORTED_MODULE_1__["WEB3_USER_DENIED"]) {
            return _objectSpread({}, state, {
              status: 'UserDeniedAccess'
            });
          }

          if (action.type === _constants__WEBPACK_IMPORTED_MODULE_1__["NETWORK_ID_FETCHED"]) {
            return _objectSpread({}, state, {
              networkId: action.networkId
            });
          }

          if (action.type === _constants__WEBPACK_IMPORTED_MODULE_1__["NETWORK_ID_FAILED"]) {
            return _objectSpread({}, state, {
              networkId: action.networkId
            });
          }

          if (action.type === _constants__WEBPACK_IMPORTED_MODULE_1__["NETWORK_MISMATCH"]) {
            return _objectSpread({}, state, {
              networkMismatch: true
            });
          }

          return state;
        };
        /* harmony default export */


        __webpack_exports__["default"] = web3Reducer;
        /***/
      },

      /***/
      "./src/web3/web3Saga.js":
      /*!******************************!*\
        !*** ./src/web3/web3Saga.js ***!
        \******************************/

      /*! exports provided: initializeWeb3, getNetworkId */

      /***/
      function srcWeb3Web3SagaJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "initializeWeb3", function () {
          return initializeWeb3;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getNetworkId", function () {
          return getNetworkId;
        });
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/regenerator */
        "../../node_modules/@babel/runtime/regenerator/index.js");
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! redux-saga/effects */
        "../../node_modules/redux-saga/es/effects.js");
        /* harmony import */


        var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./constants */
        "./src/web3/constants.js");

        var _marked =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(initializeWeb3),
            _marked2 =
        /*#__PURE__*/
        _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(getNetworkId);

        var Web3 = __webpack_require__(
        /*! web3 */
        "web3");
        /*
         * Initialization
         */


        function initializeWeb3(_ref) {
          var options, web3, _window, ethereum, selectedAccount, provider;

          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function initializeWeb3$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  options = _ref.options;
                  _context.prev = 1;
                  web3 = {};

                  if (!(options && options.web3 && options.web3.customProvider)) {
                    _context.next = 8;
                    break;
                  }

                  web3 = new Web3(options.web3.customProvider);
                  _context.next = 7;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: _constants__WEBPACK_IMPORTED_MODULE_2__["WEB3_INITIALIZED"]
                  });

                case 7:
                  return _context.abrupt("return", web3);

                case 8:
                  if (!window.ethereum) {
                    _context.next = 32;
                    break;
                  }

                  _window = window, ethereum = _window.ethereum;
                  web3 = new Web3(ethereum);
                  _context.prev = 11;
                  _context.next = 14;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["call"])([ethereum, 'enable']);

                case 14:
                  selectedAccount = _context.sent;
                  _context.next = 17;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: _constants__WEBPACK_IMPORTED_MODULE_2__["WEB3_INITIALIZED"]
                  });

                case 17:
                  if (selectedAccount) {
                    _context.next = 21;
                    break;
                  }

                  _context.next = 20;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: _constants__WEBPACK_IMPORTED_MODULE_2__["WEB3_USER_DENIED"]
                  });

                case 20:
                  return _context.abrupt("return");

                case 21:
                  return _context.abrupt("return", web3);

                case 24:
                  _context.prev = 24;
                  _context.t0 = _context["catch"](11);
                  console.error(_context.t0);
                  _context.next = 29;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: _constants__WEBPACK_IMPORTED_MODULE_2__["WEB3_ERROR"]
                  });

                case 29:
                  return _context.abrupt("return");

                case 30:
                  _context.next = 52;
                  break;

                case 32:
                  if (!(typeof window.web3 !== 'undefined')) {
                    _context.next = 39;
                    break;
                  } // Checking if Web3 has been injected by the browser (Mist/MetaMask)
                  // Use Mist/MetaMask's provider.


                  web3 = new Web3(window.web3.currentProvider);
                  _context.next = 36;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: _constants__WEBPACK_IMPORTED_MODULE_2__["WEB3_INITIALIZED"]
                  });

                case 36:
                  return _context.abrupt("return", web3);

                case 39:
                  if (!options.fallback) {
                    _context.next = 51;
                    break;
                  }

                  _context.t1 = options.fallback.type;
                  _context.next = _context.t1 === 'ws' ? 43 : 48;
                  break;

                case 43:
                  provider = new Web3.providers.WebsocketProvider(options.fallback.url);
                  web3 = new Web3(provider);
                  _context.next = 47;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: _constants__WEBPACK_IMPORTED_MODULE_2__["WEB3_INITIALIZED"]
                  });

                case 47:
                  return _context.abrupt("return", web3);

                case 48:
                  throw new Error('Invalid web3 fallback provided.');

                case 49:
                  _context.next = 52;
                  break;

                case 51:
                  throw new Error('Cannot find injected web3 or valid fallback.');

                case 52:
                  _context.next = 60;
                  break;

                case 54:
                  _context.prev = 54;
                  _context.t2 = _context["catch"](1);
                  _context.next = 58;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: _constants__WEBPACK_IMPORTED_MODULE_2__["WEB3_FAILED"],
                    error: _context.t2
                  });

                case 58:
                  console.error('Error intializing web3:');
                  console.error(_context.t2);

                case 60:
                case "end":
                  return _context.stop();
              }
            }
          }, _marked, null, [[1, 54], [11, 24]]);
        }
        /*
         * Network ID
         */


        function getNetworkId(_ref2) {
          var web3, networkId;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function getNetworkId$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  web3 = _ref2.web3;
                  _context2.prev = 1;
                  _context2.next = 4;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["call"])(web3.eth.net.getId);

                case 4:
                  networkId = _context2.sent;
                  _context2.next = 7;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: _constants__WEBPACK_IMPORTED_MODULE_2__["NETWORK_ID_FETCHED"],
                    networkId: networkId
                  });

                case 7:
                  return _context2.abrupt("return", networkId);

                case 10:
                  _context2.prev = 10;
                  _context2.t0 = _context2["catch"](1);
                  _context2.next = 14;
                  return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_1__["put"])({
                    type: _constants__WEBPACK_IMPORTED_MODULE_2__["NETWORK_ID_FAILED"],
                    error: _context2.t0
                  });

                case 14:
                  console.error('Error fetching network ID:');
                  console.error(_context2.t0);

                case 16:
                case "end":
                  return _context2.stop();
              }
            }
          }, _marked2, null, [[1, 10]]);
        }
        /***/

      },

      /***/
      "deepmerge":
      /*!****************************!*\
        !*** external "deepmerge" ***!
        \****************************/

      /*! no static exports found */

      /***/
      function deepmerge(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_deepmerge__;
        /***/
      },

      /***/
      "is-plain-object":
      /*!**********************************!*\
        !*** external "is-plain-object" ***!
        \**********************************/

      /*! no static exports found */

      /***/
      function isPlainObject(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_is_plain_object__;
        /***/
      },

      /***/
      "redux":
      /*!************************!*\
        !*** external "redux" ***!
        \************************/

      /*! no static exports found */

      /***/
      function redux(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_redux__;
        /***/
      },

      /***/
      "redux-saga":
      /*!*****************************!*\
        !*** external "redux-saga" ***!
        \*****************************/

      /*! no static exports found */

      /***/
      function reduxSaga(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_redux_saga__;
        /***/
      },

      /***/
      "web3":
      /*!***********************!*\
        !*** external "web3" ***!
        \***********************/

      /*! no static exports found */

      /***/
      function web3(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_web3__;
        /***/
      }
      /******/

    })
  );
});